window.slate = window.slate || {};
window.theme = window.theme || {};
// somewhere to store custom global functions
window.rfd = window.rfd || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === 'undefined' ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === 'undefined' ? '' : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    // console.debug('slate.Variants.ctr', { currentVariant: this.currentVariant, singleOptionSelector: this.singleOptionSelector });

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));

    // Trigger change event on initially selected options after handlers initialized to finish PDP form setup
    setTimeout(
      function () {
        // console.debug('slate.Variants.ctr lookingForCurrentOptions');

        $(this.singleOptionSelector, this.$container).each(function (_, element) {
          var $element = $(element);
          var type = $element.attr('type');
          // console.debug('slate.Variants.ctr lookingForCurrentOptions iterating', { element, $element, type });

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              // console.debug('slate.Variants.ctr lookingForCurrentOptions currentOption', { $element });
              $element.change();
            }
          }
        });

        function safeGenerateHintPhrases(variant, timeout = 5000) {
          const observer = new MutationObserver((_, obs) => {
            if (document.getElementById('u_content_heading_2')) {
              obs.disconnect();
              generateHintPhrases(variant);
              updateHintConfirmation(variant);
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          setTimeout(() => {
            observer.disconnect();
            console.warn(`Element not found after ${timeout}ms`);
          }, timeout);
        }
        safeGenerateHintPhrases(this.currentVariant);
      }.bind(this)
    );
  }

  function updateHintConfirmation(variant) {
      const popupContent = document.querySelector('#dropahint-closing .u-popup-content');
      if (!popupContent) {
        return;
      }

      const paragraphs = popupContent.querySelectorAll('p');
      let targetParagraph = null;

      paragraphs.forEach(p => {
        if (p.textContent.includes('Your hint has been sent')) {
          targetParagraph = p;
        }
      });

      if (targetParagraph) {
        const { sendHint } = generateHintPhrases(variant);
        targetParagraph.innerHTML = sendHint;
      } else {
        console.log('Hint confirmation message not found in popup');
      }
    }


  function generateHintPhrases(variant) {

      const capitalize = (str) => {
        if (!str) return '';
        return str.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
      };

      const productName = capitalize(variant.name?.split(' - ')[0]?.trim()) || 'This Item';
      const color = capitalize(variant.option1?.trim()) || '';
      const size = variant.option2?.trim().toUpperCase() || '';
      const extraOption = capitalize(variant.option3?.trim()) || '';

      const descriptionParts = [productName];
      if (color) descriptionParts.push(color);
      if (extraOption) descriptionParts.push(extraOption);
      if (size && !size.toLowerCase().includes('one size')) descriptionParts.push(`Size ${size}`);

      const itemDescription = descriptionParts.join(', ');

      const dropHintPhrase = `Drop a hint for ${itemDescription}.`;
      const sendHintPhrase = `Your hint for ${itemDescription} has been sent.`;

      const headingDiv = document.getElementById('u_content_heading_2');

      let h4Element = document.getElementById('dropahint-custom-info');

      if (h4Element) {
        h4Element.remove();
      }

      h4Element = document.createElement('h4');
      h4Element.id = 'dropahint-custom-info';
      h4Element.textContent = dropHintPhrase;
      headingDiv?.insertAdjacentElement('afterend', h4Element);


      return {
        dropHint: dropHintPhrase,
        sendHint: sendHintPhrase
      };
    }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      // console.debug('slate.Variants._getVariantFromOptions', { selectedValues, variants, product: this.product });

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      // console.debug('slate.Variants._getVariantFromOptions', { found });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      // console.debug('slate.Variants._onSelectChange', { originalSelectorId: this.originalSelectorId });

      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      generateHintPhrases(variant);

      updateHintConfirmation(variant);


      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._filterImages(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _filterImages: function (variant) {
      // filter images that aren´t on the current variant seleted.
      const availableOptions = {};
      this.product.variants.forEach(variant => {
        if (variant.available) {
          availableOptions[variant.option1] = true;
        }
      });
      // rigth now most of the products has 1 color, so I'm removing
      // filtering when there is only 1 color.
      if (Object.keys(availableOptions).length <= 1) {
        return;
      }

      const imageItems = document.querySelectorAll(".pdp-gallery__gallery-thumb")
      const color_variant = variant.option1;
      imageItems.forEach(item => {
        const image = item.querySelector('img');
        if (!image.alt.includes(color_variant)) {
          image.parentElement.style.display = 'none';
        }
      });
    },
    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    preorderLineProperty: '[data-preorder-line-property]',
    peorderDateText: '[data-preorder-ship-dates]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    // console.debug('theme.Product.ctr', { container });

    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));

    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    // console.debug('theme.Product.ctr end');
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      console.log('updateAddToCartState');

      var variant = evt.variant;
      var product = this.productSingleObject

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        if (product.tags.includes("flag: PREORDER")){
          var preorderExceptions = product.tags.filter(str => str.includes("flag: PREORDER-EX"))
          var exceptionsList = preorderExceptions.map(function(val){
              return val.replace("flag: PREORDER-EX-", "");
          });
          if (exceptionsList.includes(variant.option2)) {
            $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            $(selectors.preorderLineProperty, this.$container).val("");
            $(selectors.peorderDateText, this.$container).html("");
             }
          else {
            $(selectors.preorderLineProperty, this.$container).val("This is a Preorder item");
            $(selectors.addToCartText, this.$container).html('PREORDER');
            var preorderDate = product.tags.filter(str => str.includes("flag: PREORDER-D-"))
            if (preorderDate.length) {
              var AdjustedDate = preorderDate.map(function(val){
                return val.split("-");
              });
              $(selectors.peorderDateText, this.$container).html('ESTIMATED TO SHIP BETWEEN ' + AdjustedDate[0][2] + ' AND ' + AdjustedDate[0][3]);
            }
          }
        } else {
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        }
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function (e) {
    e.preventDefault();

    $newAddressForm.toggleClass('hide');

    if (!$newAddressForm.hasClass('hide')) {
      $('html, body').animate(
        {
          scrollTop: $('body').offset().top
        },
        'slow'
      );
    }
  });

  $('.address-edit-toggle').on('click', function () {
    $('.edit-address').addClass('hide');
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/*================ Global ================*/
/**
 * Utility functions to toggle a "no-scroll" state where body can't be scrolled.
 * Useful to when opening modals/minicarts, or to "contain" scrolling inside
 * them on iOS.
 *
 * @exports window.rfd.noscroll.contain()
 * @exports window.rfd.noscroll.apply()
 * @exports window.rfd.noscroll.remove()
 */

(function noScrollFunction() {
  'use strict';

  var selectors = {
    main: 'body',
    contain: '[data-scroll-contain]'
  };

  var NO_SCROLL_CLASS = 'no-scroll';
  var scrollPosition = 0;

  var stickySelector = '.sticky-container';
  var stickyFixedClass = 'is-fixed';
  var stickyMq = 'only screen and (min-width: 990px)';

  /**
   * Switches elements with position: stick to fixed position while
   * body.no-scroll is active. Fixes issue in Firefox where sticky position
   * is document relative (not viewport relative) with body "position: fixed"
   */
  function toggleStickyPositions(toggle) {
    var $stickies = $(stickySelector);

    // ignore when has inline position (Stickyfill active, no fix needed)
    if (!$stickies.length || $stickies.get(0).style.position !== '') {
      return;
    }

    if (!toggle) {
      $stickies.each(function noScrollResetStickies() {
        $(this).removeClass(stickyFixedClass).css({
          position: '',
          left: '',
          top: ''
        });
      });

      return;
    }

    if (!window.matchMedia(stickyMq).matches) {
      return;
    }

    $stickies.each(function noScrollAddStickies() {
      var offset = $(this).offset();
      var offsetTopViewport = offset.top - $(document).scrollTop();
      var offsetLeftViewport = offset.left - $(document).scrollLeft();
      var width = $(this).outerWidth(true);

      $(this).addClass(stickyFixedClass).css({
        left: offsetLeftViewport,
        top: offsetTopViewport,
        width: width
      });
    });
  }

  /**
   * Disables scrolling on the body element
   */
  function apply() {
    console.log('noscroll apply');

    toggleStickyPositions(true);

    scrollPosition = window.pageYOffset;
    $('body').addClass(NO_SCROLL_CLASS);
    $(selectors.main).css({
      top: -scrollPosition + 'px',
      position: 'relative'
    });
  }

  /**
   * Restores scrolling on the body element
   */
  function remove() {
    console.log('noscroll remove');

    toggleStickyPositions(false);

    $('body').removeClass(NO_SCROLL_CLASS);
    $(selectors.main).css({
      top: '',
      position: ''
    });
    window.scrollTo(0, scrollPosition);
  }

  /**
   * Contains scrolling within the given element. This is useful on iOS
   * to prevent the body scrolling behind an element with its own
   * overflow scrolling.
   *
   * @param {node} overlayEl - DOM node to contain scrolling within
   */
  function contain(overlayEl) {
    var yPosition = null; // remember Y position on touch start

    overlayEl.addEventListener(
      'touchstart',
      function noScrollDetectTouch(event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          yPosition = event.targetTouches[0].clientY;
        }
      },
      false
    );

    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
     */
    function isOverlayTotallyScrolled() {
      return overlayEl.scrollHeight - overlayEl.scrollTop <= overlayEl.clientHeight;
    }

    function disableRubberBand(event) {
      var clientY = event.targetTouches[0].clientY - yPosition;

      if (overlayEl.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll
        event.preventDefault();
      }

      if (isOverlayTotallyScrolled() && clientY < 0) {
        // element is at the top of its scroll
        event.preventDefault();
      }
    }

    overlayEl.addEventListener(
      'touchmove',
      function noScrollDisableRubberBand(event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          disableRubberBand(event);
        }
      },
      false
    );
  }

  function containScrollers() {
    $(selectors.contain).each(function containScrollersLoop() {
      contain(this);
    });
  }

  function init() {
    containScrollers();
  }

  init();

  window.rfd = window.rfd || {};
  window.rfd.noscroll = {};
  window.rfd.noscroll.apply = apply;
  window.rfd.noscroll.remove = remove;
  window.rfd.noscroll.contain = contain;
})();

/**
 * Open and close "off-canvas" / "slide out" / "hamburger" menus.
 *
 * Menus can be opened from links using href="#menu-id", or dynamically from JS.
 *
 * @exports window.rfd.toggleMenu()
 * @exports window.rfd.openMenu()
 * @exports window.rfd.closeMenu()
 * @exports window.rfd.closeAllMenus()
 *
 * @requires window.rfd.noscroll
 */

(function offCanvasFunction() {
  'use strict';

  var $menus = $('.off-canvas');

  var DIMMER_TRANS_LENGTH = 700;

  if (!$menus.length) {
    return;
  }

  function dimmerHide() {
    $('.off-canvas__dimmer').addClass('hide');
  }

  function dimmerShow() {
    $('.off-canvas__dimmer').removeClass('hide');
  }

  function afterClose() {
    dimmerHide();

    // if (Stickyfill && Stickyfill.refreshAll) {
    //   Stickyfill.refreshAll();
    // }
  }

  function closeMenu(menu) {
    var $fullscreenCarousels;

    document.querySelector('.site-header__basket').focus();

    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.remove();
    }

    $(menu).attr('aria-hidden', true);
    $('body').removeClass('is-offcanvas-open is-offcanvas-push-left is-offcanvas-push-right');

    setTimeout(afterClose, DIMMER_TRANS_LENGTH);
  }

  function closeAllMenus() {
    $menus.filter('[aria-hidden="false"]').each(function closeMenusLoop(i, menu) {
      closeMenu(menu);
    });
  }

  function afterOpen() {
    document.querySelector('.minicart__header .btn--close').focus();
  }

  function openMenu(menu) {
    var $fullscreenCarousels;
    var isOpenClass;
    var $sliders;
    var $focusEl;

    if ($(menu).attr('aria-hidden') === 'false') {
      // early return if menu is already open
      return;
    }

    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.apply();
    }

    if (typeof ReloadSmartWishlist !== 'undefined' && $.isFunction(ReloadSmartWishlist))
      ReloadSmartWishlist();

    // This function appears to no longer be defined
    // re-initialise upsell carousel
    // if (window.rfd && window.rfd.initUpsellSlider) {
    //   window.rfd.animateUpsellSlider();
    // }

    dimmerShow();

    isOpenClass = 'is-offcanvas-open';
    if ($(menu).is('.off-canvas--push')) {
      isOpenClass += ' is-offcanvas-push';
      if ($(menu).is('.off-canvas--right')) {
        isOpenClass += ' is-offcanvas-push-right';
      }
      if ($(menu).is('.off-canvas--small')) {
        isOpenClass += ' is-offcanvas-small';
      }
    }

    setTimeout(function openMenuTimeout() {
      $(menu).attr('aria-hidden', false);
      $('body').addClass(isOpenClass);
      setTimeout(afterOpen, DIMMER_TRANS_LENGTH);
    }, 0);

    $focusEl = $('.minicart__header .btn--close').find('.js-first-focus').first();

    if (!$focusEl.length) {
      $focusEl = $(menu).find('input, select, textarea').first();
    }
    if (!$focusEl.length) {
      $focusEl = $(menu).find('a.is-active').first();
    }
    if (!$focusEl.length) {
      $focusEl = $(menu).find('a').first();
    }

    // refire Slick sliders in off-canvas to ensure functional
    // (prev/next buttons specifically)
    $sliders = $(menu).find('.slick-initialized.slick-slider');
    if ($sliders.length && $sliders.slick) {
      console.log('Slick init');
      $sliders.find('.slick-arrow').remove();
      $sliders.slick('reinit');
    }
  }

  function toggleMenu(menu) {
    var isClosed = $(menu).attr('aria-hidden') === 'true';

    if (isClosed) {
      closeAllMenus();
      openMenu(menu);
    } else {
      closeMenu(menu);
    }
  }

  function addDimmer() {
    var $dimmer = $('<div class="off-canvas__dimmer" />');
    $('body').append($dimmer);
    $dimmer.on('click', function dimmerClick() {
      closeAllMenus();
    });
  }

  function initControls() {
    $menus.each(function initControlsLoop(index, menu) {
      var thisId = $(menu).attr('id');
      var $menuToggles = $('a[href="#' + thisId + '"]');

      $menuToggles.on('click', function menuTogglesClick(e) {
        e.preventDefault();
        toggleMenu(menu);
      });

      $(menu).on('click', '.js-offcanvas-close', function offCanvasCloseClick(e) {
        e.preventDefault();
        closeMenu(menu);
      });
    });
  }

  function init() {
    addDimmer();
    initControls();
  }

  init();

  window.rfd = window.rfd || {};
  window.rfd.closeAllMenus = closeAllMenus;
  window.rfd.closeMenu = closeMenu;
  window.rfd.openMenu = openMenu;
  window.rfd.toggleMenu = toggleMenu;
})();

/**
 * Module for showing alerts and modal/lightbox overlays.
 *
 * Alerts can be shown dynamically from anywhere in JS via:
 * window.rfd.alert(title, desc)
 *
 * Modals can be added by adding modal markup to the page, assigning .modal
 * a unique ID, then trigger by any link with an id="#modal-id"
 *
 * @exports window.rfd.modal.closeAll()
 * @exports window.rfd.modal.close()
 * @exports window.rfd.modal.open()
 * @exports window.rfd.modal.toggle()
 *
 * @requires snippets/modal-alert.liquid
 */

(function modalAlertFunction() {
  'use strict';

  var TRANS_LENGTH = 400;

  var selectors = {
    modal: '[data-modal]',
    modalInner: '.modal__inner',
    closeBtn: '.js-modal-close',
    bodyClassOpen: 'is-modal-open'
  };

  var $modals;

  function close(modal) {
    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.remove();
    }

    $('body').removeClass(selectors.bodyClassOpen);
    $(modal).attr('aria-hidden', true);

    setTimeout(function modalHideTimeout() {
      $(modal).addClass('hide');
    }, TRANS_LENGTH);

    // NOTE: DO NOT USE SLATE'S TRAPFOCUS UTILITY HERE, CAN THROW A MAXRANGE
    // ERROR WHICH CAN CRASH THE BROWSER (POTENTIALLY DURING CART CHANGES IF
    // "MAX QUANT" ERROR IS SHOWN)
  }

  function closeAll() {
    $modals.filter('[aria-hidden="false"]').each(function modalClose(i, menu) {
      close(menu);
    });
  }

  function open(modal) {
    var $focusEl = $(modal).find('.js-first-focus').first();

    if ($(modal).attr('aria-hidden') === 'false') {
      // early return if modal is already open
      return;
    }

    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.apply();
    }

    $(modal).removeClass('hide');
    $(modal).attr('aria-hidden', false);

    setTimeout(function modalAddBodyClass() {
      $('body').addClass(selectors.bodyClassOpen);
    }, 0);

    if (!$focusEl.length) {
      $focusEl = $(modal).find('input, select, textarea, button').first();
    }
    if (!$focusEl.length) {
      $focusEl = $(modal).find('a.is-active').first();
    }
    if (!$focusEl.length) {
      $focusEl = $(modal).find('a').first();
    }

    // NOTE: DO NOT USE SLATE'S TRAPFOCUS UTILITY HERE, CAN THROW A MAXRANGE
    // ERROR WHICH CAN CRASH THE BROWSER (POTENTIALLY DURING CART CHANGES IF
    // "MAX QUANT" ERROR IS SHOWN)
  }

  function toggle(modal) {
    var isClosed = $(modal).attr('aria-hidden') === 'true';

    if (isClosed) {
      closeAll();
      open(modal);
    } else {
      close(modal);
    }
  }

  function initControls() {
    console.debug('[rfd.modal] initControls', { $modals });

    $modals.each(function modalsLoop(index, modal) {
      var thisId = $(modal).attr('id');
      var $modalToggles = $('a[href="#' + thisId + '"]');
      var $modalCloseBtns = $(modal).find(selectors.closeBtn);
      var $modalInner = $(modal).find(selectors.modalInner);

      $(modal).on('click', function modalClickClose() {
        // closes modal on clicking dimmer/overlay
        close(modal);
      });

      $modalInner.on('click', function modalDontClose(e) {
        // stop propagation so clicks in body don't close modal
        e.stopPropagation();
      });

      $modalToggles.on('click', function modalToggle(e) {
        e.preventDefault();
        toggle(modal);
      });

      $modalCloseBtns.on('click', function modalClickClose(e) {
        e.preventDefault();
        close(modal);
      });
    });
  }

  function showAlert(title, desc) {
    var $globalErr = $('#global-error');

    if (!$globalErr.length) {
      console.error('No alert HTML in DOM to display error:');
    }

    if (title) {
      if (title == 'Cart Error') {
        title = 'Oops!';
      }
      $globalErr.find('.modal__title').html('<h3>' + title + '</h3>');
    }
    if (desc) {
      $globalErr.find('.modal__body').html('<p>' + desc + '</p>');
    }

    open($globalErr);
    console.info('Alert:', title, desc);
  }

  function _init() {
    console.debug('[rfd.modal] _init');

    $modals = $(selectors.modal);

    console.debug('[rfd.modal] _init', { selectors, $modals });

    if (!$modals.length) {
      return;
    }

    initControls();

    $modals.each(function modalNoScroll() {
      if (window.rfd && window.rfd.noscroll) {
        window.rfd.noscroll.contain(this);
      }
    });
  }

  _init();

  window.rfd.modal = {};
  window.rfd.modal.closeAll = closeAll;
  window.rfd.modal.close = close;
  window.rfd.modal.open = open;
  window.rfd.modal.toggle = toggle;
  window.rfd.alert = showAlert;
})();

/**
 * AJAX utility functions to enable/disable controls during requests,
 * and catch global errors.
 *
 * @exports window.rfd.enableBtns()
 * @exports window.rfd.disableBtns()
 */

(function ajaxUtilsFunction() {
  'use strict';

  var selectors = {
    control: '[data-ajax-ctrl]',
    controlTxt: '[data-ctrl-text]',
    activeControl: '[data-ajax-ctrl-active]',
    alwaysTxtChange: '[data-show-ajax-status]',
    cartCount: '[data-cart-item-count]'
  };

  var $controls = null;

  window.rfd = window.rfd || {};
  window.rfd.ajaxControlsDisabled = false;

  function handleRequestComplete(event, cart) {
    // update cart counts
    $(selectors.cartCount).html(cart.item_count);
  }

  function disable(activeBtn, loadStr, $customBtns) {
    var loadString = loadStr || theme.strings.addToCartProgress;
    var $sliders;

    // early return if controls already disabled. prevents duplicate calls which
    // can cause issues re-enablind
    if (window.rfd.ajaxControlsDisabled === true) {
      console.log('[ajax-utils] controls already disabled');
      return;
    }

    if (activeBtn) {
      $(activeBtn).attr('data-ajax-ctrl-active', true);
    }

    if (!$customBtns || !$customBtns.length) {
      $controls = $(selectors.control).filter(':not([disabled])');
    } else {
      $controls = $customBtns;
    }

    $controls.attr('disabled', 'disabled');

    // custom disable for ionRangeSliders
    $sliders = $controls.filter('.range-slider');
    $sliders.siblings('.irs').attr('disabled', 'disabled');

    $controls.each(function controlsLoopOne(i, el) {
      var $txt = $(el).find(selectors.controlTxt);

      if (!$(el).is(selectors.alwaysTxtChange) && !$(el).is(selectors.activeControl)) {
        return;
      }

      if ($txt.length) {
        $txt.data('orig-text', $txt.text());
        $txt.text(loadString);
      }
    });

    window.rfd.ajaxControlsDisabled = true;
    console.log('[ajax-utils] disable controls');
  }

  function enable() {
    var $sliders;

    if (window.rfd.ajaxControlsDisabled === false) {
      console.log('[ajax-utils] controls already enabled');
      return;
    }

    console.log('[ajax-utils] enable controls');

    $controls.each(function controlsLoopTwo(i, el) {
      var $txt = $(el).find(selectors.controlTxt);

      if (!$(el).is(selectors.alwaysTxtChange) && !$(el).is(selectors.activeControl)) {
        return;
      }

      if ($txt.length) {
        $txt.text($txt.data('orig-text'));
      }
    });
    $controls.removeAttr('data-ajax-ctrl-active').removeAttr('disabled');

    // custom enable for ionRangeSliders
    $sliders = $controls.filter('.range-slider');
    $sliders.siblings('.irs').removeAttr('disabled');

    window.rfd.ajaxControlsDisabled = false;
  }

  function handleAjaxError() {
    console.error('AJAX error, re-enabling checkout buttons.');
    enable();
  }

  function init() {
    $(document).on('cart.requestComplete', handleRequestComplete);
    $(document).ajaxError(handleAjaxError);
  }

  init();

  // export global utility functions
  window.rfd = window.rfd || {};
  window.rfd.disableBtns = disable;
  window.rfd.enableBtns = enable;
})();

/**
 * Handles adding to cart via AJAX (product forms + "Quick Add" buttons)
 *
 * @requires vendor/_cart.min.js
 */

(function cartAddFunction() {
  'use strict';

  var selectors = {
    singleOptionSelector: '[data-single-option-selector]',
    productForms: '[data-ajax-product-form]',
    quickAddBtns: '[data-quick-add-to-cart]',
    quickAddVariantIdAttr: 'data-quick-add-to-cart',
    preorderProperty: 'data-preorder-line-property',
    quickAddHolder: '[data-quick-add-holder]',
    atcTextUpdate: '[data-add-to-cart-text]'
  };

  /**
   * Takes product variant data and adds it/them to Shopify's cart via AJAX.
   * Multiple variants are added in sequence, in order they appear in array.
   *
   * @private
   * @param {Object|Object[]} data - CartJS data, or an array of CartJS data
   * @param {Number} data.variantId - Variant ID of product
   * @param {Number} data.quantity - Quantity of product
   * @param {Object} [data.customProperties] - Custom properties for cart line item
   * @param {Function} [callback] - Custom callback following completion
   */
  function ajaxAddToCart(data, callback, openModal = true) {
    Shopify.queue = [];

    // Vet data & add to queue
    if (data.variantId && data.quantity) {
      Shopify.queue.push(data);
      const addon = data.addon;
      if(addon?.variantId && addon?.quantity ) {
        Shopify.queue.push(addon);
      }
    } else if (data.length) {
      data.forEach(function vetDataLoop(d) {
        if (d.variantId && d.quantity) {
          Shopify.queue.push(d);
        } else {
          console.error('[cart-add] invalid data', d);
        }
      });
    } else {
      console.error('[cart-add] invalid data', data);
      return;
    }

    // Process the queue
    Shopify.moveAlong = function processQueue() {
      var request;

      if (window.rfd && window.rfd.cartupsellInit) {
        window.rfd.cartupsellInit();
      }

      if (Shopify.queue.length) {
        request = Shopify.queue.shift();
        request.customProperties = request.customProperties || {};

        console.log('[cart-add] adding', request);

        // Make AJAX submission
        CartJS.addItem(request.variantId, request.quantity, request.customProperties, {
          success: function cartAddAjaxSuccess(data) {
            Shopify.moveAlong();
          },
          error: function cartAddAjaxError(jqXHR, textStatus, errorThrown) {
            console.timeEnd('[cart-add]');
            console.error(jqXHR, textStatus, errorThrown);

            if (window.rfd && window.rfd.enableBtns) {
              window.rfd.enableBtns();
            }

            if (window.rfd && window.rfd.cartupsellInit) {
              window.rfd.cartupsellInit();
            }

            if (
              window.rfd &&
              window.rfd.alert &&
              jqXHR.responseJSON &&
              jqXHR.responseJSON.message &&
              jqXHR.responseJSON.description
            ) {
              window.rfd.alert(jqXHR.responseJSON.message, jqXHR.responseJSON.description);
              $.magnificPopup.instance.close(); // Close popup that is currently opened
              window.rfd.renderCart(!openModal, window.rfd.enableBtns); // Render minicart
            }
          }
        });
      } else {
        console.timeEnd('[cart-add]');

        const event = new CustomEvent('cart:updated', {})
        document.dispatchEvent(event);

        if (callback) {
          callback();
        } else {
          window.rfd.renderCart(!openModal, window.rfd.enableBtns);
        }
      }
    };

    console.time('[cart-add]');
    Shopify.moveAlong();
  }

  /**
   * Gets variant data for CartJS from a Shopify product form
   *
   * @private
   * @param {jQuery} form - <form> element output by {% form 'product' %}
   * @returns {object|null} data for CartJS submission if found, or null
   */
  function getFormData(form) {
    var id = $(form).find('[name="id"]').first().val();
    var addOnId = $(form).find('[name="addon_id"]').first().val();

    var quant = $(form).find('[name="quantity"]').first().val();

    // Find custom property fields and add to object for CartJS use
    var customProperties = {};
    var $customPropFields = $(form).find('[name^="properties"]');

    id = parseInt(id, 10);

    if (!id) {
      console.error('[cart-add] no variant id', id);
      return null;
    }

    if (!quant) {
      quant = 1;
      console.info('[cart-add] no quant found in DOM, defaulting to 1');
    }

    $customPropFields.each(function cartAddPropLoop() {
      var propVal = $(this).val();
      var propName = $(this)
        .attr('name')
        .replace(/properties\[/gi, '')
        .replace(/\]/gi, '');

      customProperties[propName] = propVal;
    });

    return {
      variantId: id,
      addon: { variantId: addOnId, quantity: 1 },
      quantity: quant,
      customProperties: customProperties
    };
  }

  function handleAddAllToCart(e){
    e.preventDefault();

    const wishlistItemsArray = wishlistItems.items.map(item => {
      return {
        variantId: item.variant_id,
        quantity: 1
      };
    });
    wishlistItemsArray.forEach((item, index) => {
      const isLastItem = index === wishlistItemsArray.length - 1;
      const thirdArgument = isLastItem ? true : false;
      ajaxAddToCart(item, null, thirdArgument);
    });
  }
  /**
   * Adds a product to cart via AJAX when product form submitted.
   *
   */
  function handleProductFormSubmit(e) {
    var formData = getFormData(this);

    e.preventDefault();

    if (window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns(this);
    }

    if (formData) {
      ajaxAddToCart(formData);
    }

    var atcTextValue = $(selectors.atcTextUpdate).text()

    $(selectors.atcTextUpdate).text('Added to bag');

    setTimeout(function () {
      $(selectors.atcTextUpdate).text(atcTextValue);
    }, 1000);
  }

  /**
   * Adds product(s) to cart via AJAX when "Quick Add" button clicked.
   */
  function handleQuickAddBtnClick(e) {
    var variantIds = $(this).attr(selectors.quickAddVariantIdAttr);
    var variantIdsArr = variantIds.split(',');
    var preorderProperty = $(this).attr(selectors.preorderProperty);
    var variantsData = [];
    var customProperties = {};

    var quantEl = $(this).closest(selectors.quickAddHolder).find('[name="quantity"]');
    var quant = 1;

    if (quantEl.length) {
      quant = quantEl.first().val();
    }

    e.preventDefault();

    if (!variantIds) {
      console.error('[cart-add] no variant IDs on add button');
      return;
    }

    customProperties['Pre-Order Item'] = preorderProperty;

    variantIdsArr.forEach(function cartAddVariantLoop(id) {
      variantsData.push({
        quantity: quant,
        variantId: parseInt(id, 10),
        customProperties: customProperties
      });
    });

    if (window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns(this);
    }

    console.log('ajax calllllll')
    ajaxAddToCart(variantsData, null, window.innerWidth >= 768);

    //close size panel.
    document.querySelectorAll('.quick-close').forEach(function(element) {
      element.parentElement.classList.add('display_none');
    });
  }

  function upsellItemVariants() {
    let variantID;
    $('body').on('click', '[data-upsell-item]', function () {
      let variant = [],
        options = $(this).parents('.options'),
        optionsID = '#' + options.data('options'),
        optionsBtn = optionsID + '-btn',
        variantElem = '';
      options.children('div').each(function () {
        if (!$(this).find('input:checked').length) return;
        variant.push($(this).find('input:checked').val());
      });

      if (!variant.length) return;

      variantElem = $(optionsID).find(`[data-variant="${variant.join(' / ')}"]`);

      if (variantElem.length) {
        if (variantElem.attr('data-available') == 'false') {
          options.find('.unavailable').removeClass('hide');
          setTimeout(function () {
            options.find('.unavailable').addClass('hide');
          }, 1500);
        } else {
          variantID = variantElem.val();
          $(optionsBtn).attr('data-quick-add-to-cart', variantID).trigger('click');
        }
      }
    });

    $('body').on('click', '.toggle-options', function () {
      $(this).toggleClass('active');
    });
  }

  function init() {
    upsellItemVariants();
    $('body').on('submit', selectors.productForms, handleProductFormSubmit);
    $('body').on('click', selectors.quickAddBtns, handleQuickAddBtnClick);
    $('#AddAllToCart').on('click', handleAddAllToCart);
  }

  init();
})();

/**
 * Handles removing from cart via AJAX (minicart "Remove" buttons)
 *
 * @requires vendor/_cart.min.js
 */

(function cartRemoveFunction() {
  'use strict';

  var selectors = {
    cartForm: '[data-cart]',
    removeBtns: '[data-cart-remove]',
    lineNumberAttr: 'data-cart-remove',
    cartItem: '[data-cart-item]',
    singlePrice: 'data-item-single-price',
    itemTitle: 'data-item-title',
    itemSKU: 'data-item-sku',
    itemType: 'data-item-type',
    itemProdId: 'data-product-id'
  };

  /**
   * Removes a line item from the cart (optionally changing remove button state)
   *
   * @param {number} lineNumber - cart line item number to be removed
   * @param {jQuery} [removeBtn] - button to change state during operation
   */
  function ajaxRemoveFromCart(lineNumber, removeBtn) {
    console.time('[cart-remove]');
    console.log('[cart-remove] removing', lineNumber);

    if (removeBtn) {
      window.rfd.disableBtns(removeBtn, window.theme.strings.removing);
    }

    var $removeBtn = $('[data-cart-remove="' + lineNumber + '"]', selectors.cartForm);
    var $quantBtn = $('[data-item-quantity="' + lineNumber + '"]', selectors.cartForm);

    var $currentLineItem = $removeBtn.closest(selectors.cartItem);
    var currentLineItemVariantID = $currentLineItem.attr('data-variant-id');
    var currentLineItemTitle = $currentLineItem.find('input').attr(selectors.itemTitle);
    var currentLineItemSKU = $currentLineItem.find('input').attr(selectors.itemSKU);
    var currentLineItemType = $currentLineItem.find('input').attr(selectors.itemType);
    var currentLineItemPrice = $currentLineItem.find('input').attr(selectors.singlePrice) / 100;
    var currentLineItemProductID = $currentLineItem.find('input').attr(selectors.itemProdId);

    CartJS.removeItem(lineNumber, {
      success: function cartRemoveSuccess() {
        console.timeEnd('[cart-remove]');
        window.rfd.renderCart(false, window.rfd.enableBtns);
        const event = new CustomEvent('cart:updated', {})
        document.dispatchEvent(event);
      },
      error: function cartRemoveError(jqXHR, textStatus, errorThrown) {
        console.error(jqXHR, textStatus, errorThrown);

        if (window.rfd && window.rfd.enableBtns) {
          window.rfd.enableBtns();
        }

        if (
          window.rfd &&
          window.rfd.alert &&
          jqXHR.responseJSON &&
          jqXHR.responseJSON.message &&
          jqXHR.responseJSON.description
        ) {
          window.rfd.alert(jqXHR.responseJSON.message, jqXHR.responseJSON.description);
        }
      }
    });

    if (currentLineItemProductID == "7581630758986" && currentLineItemPrice == 0) {
      var vesselProduct = document.querySelector("[data-variant-id='41075391463498']");
      var vesselLine = vesselProduct.getAttribute("data-variant-id");
      CartJS.removeItemById(vesselLine, {
        success: function cartRemoveSuccess() {
          console.timeEnd('[cart-remove]');
          window.rfd.renderCart(false, window.rfd.enableBtns);
          const event = new CustomEvent('cart:updated', {})
          document.dispatchEvent(event);
        },
        error: function cartRemoveError(jqXHR, textStatus, errorThrown) {
          console.error(jqXHR, textStatus, errorThrown);

          if (window.rfd && window.rfd.enableBtns) {
            window.rfd.enableBtns();
          }

          if (
            window.rfd &&
            window.rfd.alert &&
            jqXHR.responseJSON &&
            jqXHR.responseJSON.message &&
            jqXHR.responseJSON.description
          ) {
            window.rfd.alert(jqXHR.responseJSON.message, jqXHR.responseJSON.description);
          }
        }
      });
    }
  }

  /**
   * Removes item from cart on button click
   */
  function handleRemoveClick(e) {
    var lineNumber = $(this).attr(selectors.lineNumberAttr);

    if (lineNumber) {
      e.preventDefault();
      ajaxRemoveFromCart(lineNumber, this);
    } else {
      console.error('[cart-remove] invalid line number', lineNumber);
    }
  }

  function init() {
    $('body').on('click', selectors.removeBtns, handleRemoveClick);
  }

  init();
})();

function handleGwpProgress() {
  if(window.Shopify.country !== 'US') {
    return
  }

  const dataContainer = document.querySelector('#js-cart-randomised-gwp-data')
  const outputContainers = document.querySelectorAll('.gwp-progress')

  if(!dataContainer || outputContainers.length === 0) {
    return null
  }

  const data = JSON.parse(dataContainer.innerHTML)

  if(data && data.gwp && data.gwp.enabled === false) {
    return null
  }
  const currencyMultiplier = Number(window.Shopify?.currency?.rate || 1)

  const thresholdsInCents = data.gwp.thresholds.map(
    (threshold) => Number(threshold.threshold) * 100 * currencyMultiplier
  )

  const cartPriceWithoutGWPItems = data.cart.items.reduce((acc, item) => {
    if (item.properties.find(prop => prop[0] === '_free_gift')) {
      return acc
    }

    return acc + item.price * item.quantity
  }, 0)

  const passedThresholds = thresholdsInCents.filter(
    (threshold) => cartPriceWithoutGWPItems >= threshold
  )

  outputContainers.forEach((outputContainer) => {
    if(data.cart.items.length === 0) {
      outputContainer.innerHTML = ``
    }

    if(passedThresholds.length === 0) {
      const nextTreshold = thresholdsInCents[0]
      outputContainer.innerHTML = data.gwp.disabled_by_customer ? `
      <p>
        ${data.gwp.disabled_message_none
          .replace('[LEFTOVER]', slate.Currency.formatMoney(nextTreshold - cartPriceWithoutGWPItems, theme.moneyFormat))
          .replace('[THRESHOLD]', slate.Currency.formatMoney(nextTreshold, theme.moneyFormat))
        }
        <button type="button" class="js-gwp-enable">${data.gwp.gwp_opt_in_label}</button>
      </p>
      ` : `
      <p>
        ${data.gwp.message_none
          .replace('[LEFTOVER]', slate.Currency.formatMoney(nextTreshold - cartPriceWithoutGWPItems, theme.moneyFormat))
          .replace('[THRESHOLD]', slate.Currency.formatMoney(nextTreshold, theme.moneyFormat))
        }
        <button type="button" class="js-gwp-disable">${data.gwp.gwp_opt_out_label}</button>
      </p>
      `

      return
    }

    if(passedThresholds.length === data.gwp.thresholds.length) {
      outputContainer.innerHTML = data.gwp.disabled_by_customer ? `
      <p>
        ${data.gwp.disabled_message_all}
        <button type="button" class="js-gwp-enable">${data.gwp.gwp_opt_in_label}</button>
      </p>
    ` : `
      <p>
        ${data.gwp.message_all}
        <button type="button" class="js-gwp-disable">${data.gwp.gwp_opt_out_label}</button>
      </p>
    `
      return
    }

    outputContainer.innerHTML = data.gwp.disabled_by_customer ? `
      <p>
        ${data.gwp.disabled_message_some
          .replace('[LEFTOVER]', slate.Currency.formatMoney(thresholdsInCents[passedThresholds.length] - cartPriceWithoutGWPItems, theme.moneyFormat))
          .replace('[THRESHOLD]', slate.Currency.formatMoney(thresholdsInCents[passedThresholds.length], theme.moneyFormat))}
        <button type="button" class="js-gwp-enable">${data.gwp.gwp_opt_in_label}</button>
      </p>
    ` : `
      <p>
        ${data.gwp.message_some
          .replace('[LEFTOVER]', slate.Currency.formatMoney(thresholdsInCents[passedThresholds.length] - cartPriceWithoutGWPItems, theme.moneyFormat))
          .replace('[THRESHOLD]', slate.Currency.formatMoney(thresholdsInCents[passedThresholds.length], theme.moneyFormat))}
        <button type="button" class="js-gwp-disable">${data.gwp.gwp_opt_out_label}</button>
      </p>
    `
  })
}

/**
 * Update cart in DOM via AJAX
 *
 * @exports window.rfd.renderCart()
 *
 * @requires vendor/cart.min.js
 * @requires _off-canvas.js
 */

(function cartRenderFunction() {
  'use strict';

  var selectors = {
    minicart: '#minicart',
    cartForm: '[data-cart]',
    alwaysStayClosed: 'body.template-cart'
  };

  var cartAjaxTemplate = '/cart?view=ajax';
  var cartPageTemplate = '/cart?view=cart-page';

  /**
   * Updates the DOM and re-fires JavaScript as necessary
   *
   * @param {boolean} dontOpen - whether to open minicart after updating
   * @param {function} callback - callback to fire after updating
   */
  function renderCart(dontOpen, callback) {
    var $cartEls = $(selectors.cartForm);
    var chosenCartTemplate = cartAjaxTemplate;
    if ($(selectors.alwaysStayClosed).length) {
      chosenCartTemplate = cartPageTemplate;
    }

    console.log('[cart-render] updating minicart');

    if (!$cartEls.length) {
      return;
    }

    console.time('[cart-render]');

    $.get(chosenCartTemplate, function cartRenderAjax(data) {
      var doNotOpen = dontOpen;
      const formattedData = $(data).find(selectors.cartForm)[0].outerHTML;
      $(selectors.cartForm).replaceWith(formattedData);

      // re-fire resposive images polyfill for IE11
      if (picturefill) {
        picturefill();
      }

      // render the product recommendations
      //loadShopifyCartProductRecommendations();
      loadSearchSpringCartProductRecommendations()

      handleGwpProgress()

      // don't open minicart on cart template
      if ($(selectors.alwaysStayClosed).length) {
        doNotOpen = true;
      }

      if (doNotOpen !== true && window.rfd && window.rfd.openMenu) {
        // close any open modals
        if ($.magnificPopup) {
          $.magnificPopup.close();
        }

        // open the mini-cart
        window.rfd.openMenu(selectors.minicart);

        // Add spinner when updating minicart
        $('.cart__body').addClass('cart__body--updating');
        setTimeout(function () {
          $('.cart__body').removeClass('cart__body--updating');
        }, 200);
      }

      console.timeEnd('[cart-render]');

      if (callback) {
        callback();
      }
    });
  }
  handleGwpProgress()
  window.rfd.renderCart = renderCart;
})();

/**
 * Handles changing cart quantities via AJAX (minicart "Quantity" togglers)
 *
 * @requires vendor/_cart.min.js
 */

(function cartUpdateFunction() {
  'use strict';

  var selectors = {
    quant: '[data-item-quantity]',
    removeBtn: '[data-cart-remove]',
    cartItem: '[data-cart-item]',
    lineNumberAttr: 'data-item-quantity',
    currentQuantAttr: 'data-current-val',
    singlePrice: 'data-item-single-price',
    itemTitle: 'data-item-title',
    itemSKU: 'data-item-sku',
    itemType: 'data-item-type',
    itemProdId: 'data-product-id'
  };

  /**
   * Updates cart item to new quantity
   *
   * @param {number} lineNumber - cart line number to change
   * @param {number} newQuant - quantity to change to
   * @param {jQuery} [control] - element to show status text during AJAX
   */
  function updateQuant(lineNumber, newQuant, control, direction) {
    console.time('[cart-update]');
    console.log('[cart-update] updating #' + lineNumber + ' x ' + newQuant);

    if (control && window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns(control, window.theme.strings.updating);
    }

    var lineNumbers = [lineNumber]

    var $currentLineItem = control.closest(selectors.cartItem);
    var currentLineItemVariantID = $currentLineItem.attr('data-variant-id');
    var currentLineItemProductID = $currentLineItem.find('input').attr(selectors.itemProdId);
    var currentLineItemTitle = $currentLineItem.find('input').attr(selectors.itemTitle);
    var currentLineItemSKU = $currentLineItem.find('input').attr(selectors.itemSKU);
    var currentLineItemType = $currentLineItem.find('input').attr(selectors.itemType);
    var currentLineItemPrice = $currentLineItem.find('input').attr(selectors.singlePrice) / 100;

    if (currentLineItemProductID == "7581630758986" && currentLineItemPrice == 0 && direction == "down") {
      var vesselProduct = document.querySelector("[data-variant-id='41075391463498']");
      var vesselLine = vesselProduct.getAttribute("data-line-number");
      lineNumbers.push(vesselLine)
    }

    for (let i = 0; i < lineNumbers.length; i++) {
      CartJS.updateItem(
        lineNumbers[i],
        newQuant,
        {},
        {
          success: function cartUpdateAjaxSuccess() {
            console.timeEnd('[cart-update]');
            if (window.rfd && window.rfd.renderCart) {
              window.rfd.renderCart(false, window.rfd.enableBtns);
              const event = new CustomEvent('cart:updated', {})
              document.dispatchEvent(event);
            }
          },
          error: function cartUpdateAjaxError(jqXHR, textStatus, errorThrown) {
            console.timeEnd('[cart-update]');
            console.error(jqXHR, textStatus, errorThrown);

            if (window.rfd && window.rfd.enableBtns) {
              window.rfd.enableBtns();
            }

            if (
              window.rfd &&
              window.rfd.alert &&
              jqXHR.responseJSON &&
              jqXHR.responseJSON.message &&
              jqXHR.responseJSON.description
            ) {
              window.rfd.alert(jqXHR.responseJSON.message, jqXHR.responseJSON.description);
            }
          }
        }
      );
    }
  }

  /**
   * Checks quantity value and if valid, update via AJAX.
   */
  function handleQuantChange(e) {
    // get quantity info
    var $control = $(this);
    var oldQuant = parseInt($control.attr(selectors.currentQuantAttr), 10);
    var newQuant = parseInt($control.val(), 10);
    var maxQuant = $control.attr('max');
    var minQuant = $control.attr('min');
    var lineNumber = $control.attr(selectors.lineNumberAttr);

    // check for co-located "remove button", and pass this as the button to show
    // status during AJAX (quantity fields can't show status text well)
    var $removeBtn = $(this).closest(selectors.cartItem).find(selectors.removeBtn);

    e.preventDefault();

    if (maxQuant && newQuant > maxQuant) {
      console.log('[cart-update] hit max');
      newQuant = maxQuant;
    }
    if (minQuant && newQuant < minQuant) {
      console.log('[cart-update] hit min');
      newQuant = minQuant;
    }

    if (newQuant === oldQuant) {
      console.log('[cart-update] no quant change');
      return;
    }

    if (newQuant > oldQuant) {
      var direction = "up"
    }

    if (newQuant < oldQuant) {
      var direction = "down"
    }

    updateQuant(lineNumber, newQuant, $removeBtn, direction);
  }

  function init() {
    $('body').on('change', selectors.quant, handleQuantChange);
  }

  init();
})();

/**
 * Sort filter tags
 *
 * @exports window.rfd.sortTags()
 */

(function tagSortFunction() {
  var selectors = {
    tagGroup: '[data-sort-group]',
    customSortAttr: 'data-sort-group',
    tagSort: '[data-sort]',
    tagSortValAttr: 'data-sort'
  };

  function sortTags() {
    var $tagGroups = $(selectors.tagGroup);

    $tagGroups.each(function tagGroupsLoop(index, g) {
      var $tagsToSort = $(g).find(selectors.tagSort);
      var sortIndexes = [];
      var sortIndexesLetters = [
        'XXXS',
        'XXS',
        'XS',
        'S',
        'S+',
        'S++',
        'S+++',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL'
      ];
      var customSortVals = $(this).attr(selectors.customSortAttr);
      var isCustomSort = customSortVals.length;
      var isNumeric = false;
      var isNonNumeric = false;
      var i;
      var j;
      var $nextTag;

      if (isCustomSort) {
        customSortVals = customSortVals.split(',');
        customSortVals = customSortVals.map(function customSortValsMap(x) {
          // normalise values to whitespce/lowercase
          return x.trim().toLowerCase();
        });
      }

      if (!$tagsToSort.length) {
        return;
      }

      /* eslint-disable no-shadow */
      $tagsToSort.each(function tagsToSortLoop(index, t) {
        sortIndexes.push(parseFloat($(t).attr(selectors.tagSortValAttr), 10));
      });
      /* eslint-enable no-shadow */

      // if at least one value is numeric, continue with sort
      sortIndexes.forEach(function sortIndexesLoop(val) {
        if ($.isNumeric(val)) {
          isNumeric = true;
        } else {
          isNonNumeric = true;
        }
      });

      if (isNumeric) {
        sortIndexes.sort(function sortIndexesSort(a, b) {
          return b - a;
        });

        for (i = 0; i < sortIndexes.length; i += 1) {
          $nextTag = $tagsToSort.filter('[data-sort="' + sortIndexes[i] + '"]');
          $(g).prepend($nextTag);
        }
      }

      if (isNonNumeric) {
        sortIndexes = isCustomSort ? customSortVals : sortIndexesLetters;
        // reverse loop
        for (j = sortIndexes.length - 1; j >= 0; j -= 1) {
          $nextTag = $tagsToSort.filter(
            '[data-sort="' +
            sortIndexes[j].toLowerCase() +
            '"], [data-sort="' +
            sortIndexes[j].toUpperCase() +
            '"]'
          );
          $(g).prepend($nextTag);
        }
      }
    });
  }

  function _init() {
    sortTags();
  }

  _init();

  window.rfd = window.rfd || {};
  window.rfd.sortTags = sortTags;
})();

('use strict');

theme.helpers = (function () {
  var isDesktop = function isDesktop() {
    return $(window).width() >= 750;
  };

  var isMobile = function isMobile() {
    return $(window).width() < 750;
  };

  var calcCSS = function calcCSS(value1, value2) {
    return 'calc(' + value1 + 'px + ' + value2;
  };

  var foundSelectors = function foundSelectors(selectorsObj) {
    var foundSelectors = false;
    var selectors = new String();
    var $selectors;
    $.each(selectorsObj, function (index, selector) {
      selectors += selector.trim() + ',';
    });
    selectors = selectors.trim().substring(0, selectors.length - 1);
    $selectors = $(selectors).length;

    if ($selectors) {
      foundSelectors = true;
    }

    return foundSelectors;
  };

  var foundAllSelectors = function foundAllSelectors(selectorsObj) {
    var foundSelectors = false;
    var selectors = new String();
    var $selectors;
    $.each(selectorsObj, function (index, selector) {
      selectors += selector.trim() + ',';
    });
    selectors = selectors.trim().substring(0, selectors.length - 1);
    $selectors = $(selectors).length;

    if ($selectors == objSize(selectorsObj)) {
      foundSelectors = true;
    }

    return foundSelectors;
  };

  var objSize = function objSize(object) {
    var size = 0;

    for (key in object) {
      if (object.hasOwnProperty(key)) {
        size++;
      }
    }

    return size;
  };

  var parseQueryParams = function parseQueryParams(windowLocationSearch) {
    var search = windowLocationSearch.substring(1);

    if (search) {
      return JSON.parse(
        '{"' + decodeURIComponent(search.replace(/&/g, '","').replace(/=/g, '":"')) + '"}'
      );
    }

    return;
  };

  var getQueryParamByName = function getQueryParamByName(name, url) {
    if (!url) {
      url = window.location.href;
    }

    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);

    if (!results) {
      return null;
    }

    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };

  var parseSelectorDataToValue = function parseSelectorDataToValue(selector) {
    var dataset = selector.replace('[data-', '').replace(']', '').trim();
    return $(selector).data(dataset);
  };

  var dataAttrNoPrefix = function dataAttrNoPrefix(selector) {
    return selector.replace('[data-', '').replace(']', '').trim();
  };

  return {
    isDesktop: isDesktop,
    isMobile: isMobile,
    calcCSS: calcCSS,
    parseQueryParams: parseQueryParams,
    getQueryParamByName: getQueryParamByName,
    parseSelectorDataToValue: parseSelectorDataToValue,
    foundSelectors: foundSelectors,
    foundAllSelectors: foundAllSelectors,
    dataAttrNoPrefix: dataAttrNoPrefix
  };
})();

/*================ Modules ================*/
/**
 * Add .touchevents on demand (on first touch event).
 * This method is more reliable than Modernizr/relying on browser
 * reporting support for touch events.
 *
 */

$(function detectTouchEvents() {
  // on-demand touch class detection on top of Modernizr
  $('html').one('touchstart', function onTouchStart() {
    $('body').addClass('touchevents').removeClass('no-touchevents');
  });
});

/**
 * Form validation using the Constraint Validation JavaScript API
 *
 * To validate a form add [data-validate] to the <form> or its parent element,
 * then markup form fields using the native HTML5 API.
 *
 * (type, required, pattern, minlength/maxlength, min/max attributes, etc)
 *
 * Use "title" attribute on <input> to give it a unique error message, otherwise
 * the default messages below will be displayed after input in div.error-message
 *
 * Style invalid fields with input.error
 *
 * @see https://github.com/cferdinandi/bouncer
 */

(function formValidationFunction() {
  var selectors = {
    form: 'form[data-validate], [data-validate] form'
  };

  function _init() {
    var validate = new Bouncer(selectors.form, {
      // Classes & IDs
      fieldClass: 'error', // Applied to fields with errors
      errorClass: 'error-message', // Applied to the error message for invalid fields
      fieldPrefix: 'bouncer-field_', // If a field doesn't have a name or ID, one is generated with this prefix
      errorPrefix: 'bouncer-error_', // Prefix used for error message IDs

      // Patterns
      // Validation patterns for specific input types
      patterns: {
        email:
          /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$/,
        url: /^(?:(?:https?|HTTPS?|ftp|FTP):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/,
        number: /[-+]?[0-9]*[.,]?[0-9]+/,
        color: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
        date: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))/,
        time: /(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9])/,
        month: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2]))/
      },

      // Message Settings
      messageAfterField: true, // If true, displays error message below field. If false, displays it above.
      messageCustom: 'data-bouncer-message', // The data attribute to use for customer error messages
      messageTarget: 'data-bouncer-target', // The data attribute to pass in a custom selector for the field error location

      // Error messages by error type
      messages: {
        missingValue: {
          checkbox: window.theme.strings.validate.messageMissingValueCheckbox,
          radio: window.theme.strings.validate.messageMissingValueRadio,
          select: window.theme.strings.validate.messageMissingValueSelect,
          'select-multiple': window.theme.strings.validate.messageMissingValueSelectMultiple,
          default: window.theme.strings.validate.messageMissingValueDefault
        },
        patternMismatch: {
          email: window.theme.strings.validate.messagePatternMismatchEmail,
          url: window.theme.strings.validate.messagePatternMismatchUrl,
          number: window.theme.strings.validate.messagePatternMismatchNumber,
          color: window.theme.strings.validate.messagePatternMismatchColor,
          date: window.theme.strings.validate.messagePatternMismatchDate,
          time: window.theme.strings.validate.messagePatternMismatchTime,
          month: window.theme.strings.validate.messagePatternMismatchMonth,
          default: window.theme.strings.validate.messagePatternMismatchDefault
        },
        outOfRange: {
          over: window.theme.strings.validate.messageOutOfRangeOver,
          under: window.theme.strings.validate.messageOutOfRangeUnder
        },
        wrongLength: {
          over: window.theme.strings.validate.messageWrongLengthOver,
          under: window.theme.strings.validate.messageWrongLengthUnder
        }
      },

      // Form Submission
      disableSubmit: false, // If true, native form submission is suppressed even when form validates

      // Custom Events
      emitEvents: true // If true, emits custom events
    });
  }

  _init();
})();

/**
 * Module for product quantity selectors with custom +/- buttons
 *
 */

(function productQuantityFunction() {
  var selectors = {
    input: '[data-quant-input]',
    select: '[data-quant-select]',
    minus: '[data-quant-minus]',
    plus: '[data-quant-plus]',
    quickAddInput: '[data-quick-add-holder] [data-quant-input]'
  };

  /**
   * Adjusts quant input by the given amount.
   *
   * @param {object} adjustCtrl - DOM element with '[data-for]' attribute
   * @param {number} amount - positive/negative integer to adjust amount by
   * @returns {undefined} undefined
   */
  function adjustVal(adjustCtrl, amount) {
    var fieldSelector = $(adjustCtrl).attr('data-for');
    var $field = $(adjustCtrl).closest('form').find(selectors.input).filter(fieldSelector).first();
    var minVal = parseInt($field.attr('min'), 10);
    var maxVal = parseInt($field.attr('max'), 10);
    var currentVal = parseInt($field.val(), 10);
    var newVal = currentVal + amount;

    // for unavailable products where "maxVal" might be 0
    if (minVal > maxVal) {
      maxVal = minVal;
    }

    if ($field.prop('disabled') === true) {
      console.log('Quant disabled');
      return;
    }

    if (!Number.isNaN(minVal) && newVal < minVal) {
      console.log('Quant prevented from going below min');
      return;
    }

    if (!Number.isNaN(maxVal) && newVal > maxVal) {
      console.log('Quant prevented from exceeding max');
      return;
    }

    if (currentVal === newVal) {
      console.log('No quant change');
      return;
    }

    if (Number.isNaN(newVal)) {
      return;
    }

    $(adjustCtrl).closest('form').find(fieldSelector).val(newVal).trigger('change');
  }

  /**
   * Updates all quantity inputs when one changes, capping at max/min vals
   *
   * @param {object} event - event object
   * @param {booleam} isSelect - adjust behaviour for selects (which can't take arbitrary integers)
   * @returns {undefined} undefined
   */
  function handleValChange(event, isSelect) {
    var maxVal = parseInt($(this).attr('max'), 10);
    var minVal = parseInt($(this).attr('min'), 10);
    var newVal = parseInt($(this).val(), 10);

    // console.log(
    //   'isSelect',
    //   isSelect,
    //   'minVal',
    //   minVal,
    //   'maxVal',
    //   maxVal,
    //   'newVal',
    //   newVal
    // );

    if (!isSelect && maxVal && !Number.isNaN(maxVal) && newVal > maxVal) {
      console.log('Quant set to max');
      newVal = maxVal;
    }

    if (!isSelect && minVal && !Number.isNaN(minVal) && newVal < minVal) {
      console.log('Quant set to min');
      newVal = minVal;
    }

    $(this).closest('form').find(selectors.input).val(newVal);
  }

  function handleMinusClick(e) {
    e.preventDefault();
    adjustVal(this, -1);
  }

  function handlePlusClick(e) {
    e.preventDefault();
    adjustVal(this, 1);
  }

  /**
   * Prevents clicking on quant picker going to PDP due to parent <a>
   */
  function handleQuickAddClick(e) {
    e.preventDefault();
  }

  function init() {
    $(selectors.quickAddInput).on('click', handleQuickAddClick);
    $(selectors.input).on('change', handleValChange);
    $(selectors.select).on('change', function (e) {
      handleValChange.call(this, e, true);
    });
    $('body').on('click', selectors.minus, handleMinusClick);
    $('body').on('click', selectors.plus, handlePlusClick);
  }

  init();
})();

('use strict');
/**
 * Module for accordion menu.
 *
 * @exports window.rfd.menuAccordionFunction()
 */

(function menuAccordionFunction() {
  function initAccordion(el) {
    var accordion = el,
      items = accordion.querySelectorAll('.js-accordion-item'),
      itemsL = items.length,
      triggers = accordion.querySelectorAll('.js-accordion-trigger'),
      hiddenContent = accordion.querySelectorAll('.js-accordion-hidden'),
      filtersAccordion = accordion.classList.contains('filters__accordion'),
      pastItem = document.body.getAttribute('data-filter-open');
    var openEvents = []; // Vars

    var current = null,
      clearDisplayTimeout = null;

    for (var x = 0; x < itemsL; x++) {
      openEvents.push(openEvent.bind(this, x));
    } // Add Event Listeners

    for (var x = 0; x < itemsL; x++) {
      if (typeof triggers[x] != 'undefined' && triggers[x] != null) {
        triggers[x].addEventListener('click', openEvents[x]);
      }
    }

    if (pastItem) {
      openEvent(parseInt(pastItem), null);
    }

    if (filtersAccordion && pastItem) {
      openEvent(parseInt(pastItem), null, true);
      checkActiveFilters();
    }

    setTimeout(function () {
      accordion.classList.add('init');
    }, 250);

    function openEvent(x, e) {
      var preset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (e) e.preventDefault();

      if (clearDisplayTimeout) {
        clearTimeout(clearDisplayTimeout);
      }

      if (current !== null && !preset) {
        var index = current;
        items[current].classList.remove('open');
        hiddenContent[current].style.removeProperty('max-height');
        if (filtersAccordion) document.body.setAttribute('data-filter-open', '');
        clearDisplayTimeout = setTimeout(function () {
          hiddenContent[index].style.removeProperty('display');
        }, 800);

        if (x === current) {
          current = null;
          return;
        }
      }

      if (typeof hiddenContent[x] != 'undefined' && hiddenContent[x] != null) {
        hiddenContent[x].style.display = 'block';
      }
      if (typeof items[x] != 'undefined' && items[x] != null) {
        items[x].classList.add('open'); // Set the max height to the full height of the first child element
      }

      if (typeof hiddenContent[x] != 'undefined' && hiddenContent[x] != null) {
        var firstChild = hiddenContent[x].querySelector('*');
        if (firstChild) hiddenContent[x].style.maxHeight = firstChild.offsetHeight + 'px';
      }
      current = x;
      if (filtersAccordion) document.body.setAttribute('data-filter-open', current);
    }

    function capitaliseTagWords(s) {
      if (typeof s !== 'string') return ''; // If the string is less than 3 characters (e.g. xl) capitalise it all

      if (s.length < 3) return s.toUpperCase();
      var words = s.split(' '),
        capitalisedString = '';

      for (var _x = 0; _x < words.length; _x++) {
        if (words[_x].length < 3) {
          capitalisedString += words[_x];
        } else {
          capitalisedString += words[_x].charAt(0).toUpperCase() + words[_x].slice(1);
        }

        if (words.length > 1 && _x < words.length - 1) {
          capitalisedString += ' ';
        }
      } // Return with the first character capitalised

      return capitalisedString;
    }

    function checkActiveFilters() {
      for (var _x2 = 0; _x2 < itemsL; _x2++) {
        var activeItems = items[_x2].querySelectorAll('.checkboxes__checkbox.is-active');

        if (!activeItems.length) continue;
        triggers[_x2].querySelector('span').innerHTML += ' /';
        var activeList = document.createElement('span');
        activeList.innerHTML = ' ';

        for (var y = 0; y < activeItems.length; y++) {
          var tagName = activeItems[y].getAttribute('data-tag-name');
          activeList.innerHTML += capitaliseTagWords(tagName);

          if (activeItems.length > 1) {
            if (y === activeItems.length - 2) {
              activeList.innerHTML += ' and ';
            } else if (y < activeItems.length - 1) {
              activeList.innerHTML += ', ';
            }
          }
        }

        triggers[_x2].appendChild(activeList);
      }
    }
  }

  function _init() {
    var accordions = document.querySelectorAll('.js-block[data-block="accordion"]');

    for (var x = 0; x < accordions.length; x++) {
      initAccordion(accordions[x]);
    }
  }

  _init();

  window.rfd = window.rfd || {};
  window.rfd.menuAccordionFunction = menuAccordionFunction;
})();

/**
 * Module for Main Navigation
 *
 */
(function navFunction() {
  function loop() {
    var mainNavs = document.querySelectorAll('.js-block[data-block="main-nav"]');

    for (var x = 0; x < mainNavs.length; x++) {
      init(mainNavs[x]);
    }
  }

  function init(el) {
    var menu = el,
      header = document.querySelector('.site-header'),
      shopTrigger = document.querySelector('.js-shop-menu-trigger'),
      collectionsTrigger = document.querySelector('.js-collections-menu-trigger'),
      searchTrigger = document.querySelector('.js-main-menu-search-trigger'),
      skipLinks = menu.querySelectorAll('.js-access-skip'),
      searchInput = document.querySelector('.main-nav__search-form input'),
      shopLink = document.querySelector('.js-collections-shop-link');

    var open = false,
      countdown = null; // Event Listeners

    menu.addEventListener('mousemove', clearCountdownToClose);
    menu.addEventListener('focusin', clearCountdownToClose);
    menu.addEventListener('focusin', openMenu);
    menu.addEventListener('mouseleave', function(e) {
      let autocomplete = document.querySelector('.ns-autocomplete');

      if (autocomplete && autocomplete.contains(e.relatedTarget)) return;
      closeMenu();
    });
    menu.addEventListener('focusout', countdownToClose);
    shopTrigger && shopTrigger.addEventListener('mouseenter', setShopMenu);
    shopTrigger && shopTrigger.addEventListener('focusin', setShopMenuFocus);
    collectionsTrigger && collectionsTrigger.addEventListener('mouseenter', setCollectionsMenu);
    collectionsTrigger && collectionsTrigger.addEventListener('focusin', setCollectionsMenuFocus);
    collectionsTrigger && collectionsTrigger.addEventListener('click', preventCollClick);
    shopTrigger && shopTrigger.addEventListener('mouseleave', countdownToClose);
    shopTrigger && shopTrigger.addEventListener('focusout', countdownToClose);
    collectionsTrigger && collectionsTrigger.addEventListener('mouseleave', countdownToClose);
    collectionsTrigger && collectionsTrigger.addEventListener('focusout', countdownToClose);
    searchTrigger && searchTrigger.addEventListener('click', setSearchMenu);
    shopLink && shopLink.addEventListener('mouseenter', closeMenu);
    shopLink && shopLink.addEventListener('focusin', closeMenu);

    function countdownToClose() {
      countdown = setTimeout(closeMenu, 1500);
    }

    function clearCountdownToClose() {
      if (countdown) clearTimeout(countdown);
    }

    function setShopMenuFocus() {
      setShopMenu();
      // Check for access button and focus it
      focusAccessKey(0);
    }

    function setShopMenu() {
      // If a countdown to close exists clear it
      clearCountdownToClose();
      // Set the correct menu 'tab'
      setMenu('shop');
      // Open menu if it's closed
      if (!open) openMenu();
    }

    function setCollectionsMenuFocus() {
      setCollectionsMenu();
      // Check for access button and focus it
      focusAccessKey(1);
    }

    function preventCollClick(e) {
      e.preventDefault();
    }

    function setCollectionsMenu() {
      // If a countdown to close exists clear it
      clearCountdownToClose();
      // Set the correct menu 'tab'
      setMenu('collections');
      // Open menu if it's closed
      if (!open) openMenu();
    }

    function setSearchMenu() {
      // If a countdown to close exists clear it
      clearCountdownToClose();
      // Set the correct menu 'tab'
      setMenu('search');
      // Open menu if it's closed
      if (!open) openMenu();
      // Check for access button and focus it
      // searchInput.focus();
    }

    function setMenu(menuName) {
      header.setAttribute('data-menu', menuName);
      menu.setAttribute('data-menu', menuName);
    }

    function clearMenu() {
      header.setAttribute('data-menu', '');
      menu.setAttribute('data-menu', '');
    }

    function focusAccessKey(x) {
      console.log(skipLinks[x]);
      const accessBtn = skipLinks[x];
      if (accessBtn) accessBtn.focus();
    }

    function openMenu() {
      open = true;
      header.classList.add('open');
      menu.classList.add('open');
    }

    function closeMenu() {
      open = false;
      header.classList.remove('open');
      menu.classList.remove('open');
      countdown = null;
      clearMenu();
    }
  }

  loop();
})();

('use strict');


(function headerSticky() {
  const announceBar = document.querySelector('.js-announce-bar');
  if (!announceBar) return;

  const height = announceBar.offsetHeight;

  document.documentElement.style.setProperty(
    '--announce-bar-height',
    `-${height}px`
  );
})();

(function nostoSearchHeight() {
  const isDesktop = () => window.matchMedia('(min-width: 1240px)').matches;

  const header = document.querySelector('.site-header');
  if (!header) return;

  // Set correct top on every .ns-autocomplete so none of them overlap the header.
  const applyTopToAll = () => {
    const all = document.querySelectorAll('.ns-autocomplete');
    if (!isDesktop()) {
      all.forEach((el) => el.style.removeProperty('top'));
      return;
    }
    const height = header.offsetHeight + 'px';
    document.documentElement.style.setProperty('--ns-h-height', height);
    document.documentElement.style.setProperty('--ns-sh-height', '0px');
    all.forEach((el) => el.style.setProperty('top', height, 'important'));
  };

  const closeAll = () => {
    document.querySelectorAll('.ns-autocomplete').forEach((el) => {
      const btn = el.querySelector('.ns-close-search-btn');
      if (btn) btn.click();
      else if (el.parentElement) el.parentElement.style.display = 'none';
    });
  };

  // Set up per-element observers. Uses a data attribute to avoid double-init.
  const initAutocomplete = (el) => {
    if (el.dataset.cgInit) return;
    el.dataset.cgInit = '1';

    new MutationObserver(applyTopToAll).observe(el, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    el.addEventListener('mouseleave', (e) => {
      if (isDesktop() && !header.contains(e.relatedTarget)) closeAll();
    });
  };

  new MutationObserver(() => {
    document.querySelectorAll('.ns-autocomplete').forEach(initAutocomplete);
    applyTopToAll();
  }).observe(document.body, { childList: true, subtree: true });

  new ResizeObserver(applyTopToAll).observe(header);

  document.querySelectorAll('.site-header__menu-link').forEach((link) => {
    link.addEventListener('mouseenter', () => { if (isDesktop()) closeAll(); });
  });

  window.addEventListener('resize', applyTopToAll);

  document.querySelectorAll('.ns-autocomplete').forEach(initAutocomplete);
  applyTopToAll();
})();


/**
 * Module for Mobile Navigation
 *
 */
(function mobNavFunction() {
  function loop() {
    var mobileNavs = document.querySelectorAll('.js-block[data-block="mobile-nav"]');

    for (var x = 0; x < mobileNavs.length; x++) {
      init(mobileNavs[x]);
    }
  }

  function init(el) {
    // Elements
    var menu = el,
      openTrigger = document.querySelector('.js-mobile-menu-open-trigger'),
      closeTrigger = menu.querySelector('.js-mobile-menu-close-trigger'),
      searchTrigger = document.querySelector('.js-mobile-menu-search-trigger'),
      searchInput = menu.querySelector('.mobile-nav__search-form #mobile-search'),
      backTrigger = menu.querySelector('.js-mobile-menu-back-trigger'),
      shopTrigger = menu.querySelector('.js-mobile-menu-shop-trigger'),
      collectionsTrigger = menu.querySelector('.js-mobile-menu-collection-trigger');

    var open = false; // Event Listeners

    openTrigger.addEventListener('click', openMenu);
    closeTrigger.addEventListener('click', closeMenu);
    searchTrigger.addEventListener('click', showSearch);
    backTrigger.addEventListener('click', showPrimary);
    shopTrigger.addEventListener('click', showShop);
    collectionsTrigger.addEventListener('click', showCollections); // Set display
    window.addEventListener('resize', closeOnResize);

    menu.style.display = 'block';

    function showSearch() {
      menu.setAttribute('data-menu', 'search');
      setTimeout(function () {
        searchInput.focus();
      }, 500);
      openMenu();
    }

    function showPrimary() {
      menu.setAttribute('data-menu', 'primary');
    }

    function showShop() {
      menu.setAttribute('data-secondary', 1);
      showSecondary();
    }

    function showCollections() {
      menu.setAttribute('data-secondary', 2);
      showSecondary();
    }

    function showSecondary() {
      menu.setAttribute('data-menu', 'secondary');
    }

    function openMenu() {
      if (open) return;
      open = true;
      menu.classList.add('open');
      document.querySelector('body').setAttribute('data-modal-open', true);
    }

    function closeMenu() {
      if (!open) return;
      open = false;
      menu.classList.remove('open');
      setTimeout(showPrimary, 400);
      document.querySelector('body').setAttribute('data-modal-open', false);
    }

    //run close function if window resizes and is bigger than tabletL. Makes sure that data-modal-open is removed so that scroll works
    function closeOnResize() {
      if (window.innerWidth > 1024) closeMenu();
    }
  }

  loop();
})();

window.theme.mediaQuery = (function mediaQuery() {
  var breakpoints = {
    xsmall: 375,
    small: 550,
    medium: 768,
    large: 990,
    widescreen: 1400
  };

  var mediaStrings = {
    xxsmall: '(max-width: ' + (breakpoints.xsmall - 1) + 'px)',
    small: '(max-width:  ' + (breakpoints.medium - 1) + 'px)',
    'medium-up': '(min-width: ' + breakpoints.medium + 'px)',
    'large-up': '(min-width: ' + breakpoints.large + 'px)',
    widescreen: '(min-width: ' + breakpoints.widescreen + 'px)'
  };

  /**
   * Tests a Slate-formatted media query label
   *
   * @param {string} label - the media query to test e.g. 'medium-up'
   * @return {boolean} whether the MQ matches
   */
  function test(label) {
    var string = mediaStrings[label];

    if (!string) {
      return false;
    }

    return window.matchMedia(string).matches;
  }

  return test;
})();

/**
 * Lazy-loaded pagination via Infinite Scroll
 *
 * @see https://infinite-scroll.com/options.html
 * @requires vendor/infinite-scroll.pkgd.min.js
 */

(function modLazyPag() {
  var selectors = {
    module: '.lazy-pag',
    grid: '.lazy-pag__grid',
    pag: '.lazy-pag__next',
    item: '.lazy-pag__item',
    gridCount: '[data-grid-count]'
  };

  var $grid;

  /**
   * Updates grid count in collection header
   */
  function updateGridCount() {
    var $gridCount = $(selectors.gridCount);
    var count = $grid.find(selectors.item).length;
    $gridCount.text(count);
  }

  function updateGridCount() {
    var count = $(selectors.filterResults).find('.product-grid__item').length;

    var noResultsMsge =
      '<div class="empty-selection">Your filter selection did not yield results.</div>';

    if (count == 0) {
      $(selectors.filterResults).append(noResultsMsge);
    }
  }

  function handleAppend(event, response, path, items) {
    const paginationContainer = document.querySelector('.js-pagination-wrapper')
    const paginationElement = response.querySelector('.js-pagination-wrapper');

    if (paginationContainer) {
      paginationContainer.innerHTML = paginationElement.innerHTML || '';
    }

    // eslint-disable-next-line no-console
    console.log('[lazy-pag] appended ' + items.length);
    console.log('[lazy-pag] appended ', event, response, path, items)
    updateGridCount();

    if (window.rfd && window.rfd.orderGrid) {
      window.rfd.orderGrid($grid[0], items);
    }

    if (window.rfd && window.rfd.reinitQuickAdd) {
      window.rfd.reinitQuickAdd();
    }

    if (window.rfd && window.rfd.reinitListingVideo) {
      window.rfd.reinitListingVideo();
    }

    if (typeof ReloadSmartWishlist !== 'undefined' && $.isFunction(ReloadSmartWishlist))
      ReloadSmartWishlist();

    if (typeof collectionPageMobileCarousel !== 'undefined' && $.isFunction(collectionPageMobileCarousel))
      collectionPageMobileCarousel();
  }

  function handleRequest(event, path) {
    // eslint-disable-next-line no-console
    console.log('[lazy-pag] loading page: ' + path);
  }

  function handleLast() {
    // eslint-disable-next-line no-console
    console.log('[lazy-pag] last page loaded');
  }

  function init() {
    $grid = $(selectors.grid).infiniteScroll({
      append: selectors.item,
      scrollThreshold: 600,
      path: selectors.pag,
      checkLastPage: true,
      history: false
    });

    // "live" collection of grid items (stays up to date post-AJAX)
    // var gridItemsLive = document.getElementsByClassName('lazy-pag__item');

    // @see https://infinite-scroll.com/events.html
    $grid.on('append.infiniteScroll', handleAppend);
    $grid.on('request.infiniteScroll', handleRequest);
    $grid.on('last.infiniteScroll', handleLast);
  }

  if (!$(selectors.pag).length) {
    // eslint-disable-next-line no-console
    console.log('[lazy-pag] disabled (no next page link)');
    return;
  }

  /**
   * Reinitialises lazy pag.
   * Exported as global function below to call from anywhere. Useful when pag
   * links have been manually updated e.g. filters change results.
   */
  function reinit() {
    if ($grid && $grid.data('infiniteScroll')) {
      $grid.infiniteScroll('destroy');
    }
    init();
    console.log('[lazy-pag] reinit');
  }

  function loadNextPage() {
    $grid.infiniteScroll('loadNextPage');
  }

  init();

  window.rfd = window.rfd || {};
  window.rfd.lazyPagReinit = reinit;
  window.rfd.loadNextPage = loadNextPage;
})();

/**
 * Cookie banner.
 * Does not set data-modal-open. Mobile nav and gallery zoom still use that flag.
 */

(function cookieBannerFunction() {
  function initcookieBanner() {
    var cookie = document.querySelector('.cookie-policy');
    if (!cookie) return;

    var cookie_bar = document.querySelector('.cookie-policy__bar');
    var closeButton = cookie.querySelector('.btn--accept');
    var xButton = cookie.querySelector('.btn--close');

    var open = true;
    cookie.style.display = 'block';

    if (closeButton) closeButton.addEventListener('click', closeCookieBar);
    if (xButton) xButton.addEventListener('click', closeCookieBar);

    if (window.localStorage.getItem('accept_cookies')) {
      open = false;
      cookie.setAttribute('data-open', false);
      cookie.style.display = 'none';
      if (cookie_bar) cookie_bar.style.display = 'none';
    }

    function closeCookieBar() {
      open = false;
      window.localStorage.setItem('accept_cookies', true);
      cookie.setAttribute('data-open', false);
      cookie.style.display = 'none';
    }
  }

  initcookieBanner();
})();

/**
 * Module to update max value on product quantity depending on variant selected.
 *
 */

(function productInventoryFunction() {
  var selectors = {
    singleOptionSelector: '[data-single-option-selector]',
    originalSelectorId: '[data-product-select]',
    input: '.product-quantity__num',
    inventoryDisplay: '[inventory-display]', // For Jack1t's inventory display
    showInventory: 'data-threshold',
    inventoryDisplayNumber: '[inventory-display-number]',
    inventoryMessage: '.variant-inventory__message',
    inventoryLastOne: '.variant-inventory__last-one',
    progressBar: '.progress-bar__progress'
  };

  var $inventoryDisplay = $(selectors.inventoryDisplay);
  var showInventory = $inventoryDisplay.attr(selectors.showInventory);

  function inventoryDisplayUpdate(currentInventory) {
    var progress;

    if (showInventory > currentInventory) {
      if (currentInventory === 1) {
        $(selectors.inventoryMessage).addClass('hide');
        $(selectors.inventoryLastOne).removeClass('hide');
      } else {
        $(selectors.inventoryMessage).removeClass('hide');
        $(selectors.inventoryLastOne).addClass('hide');
      }

      $(selectors.inventoryDisplayNumber).text(currentInventory);
      progress = Math.floor((currentInventory / showInventory) * 100);
      $(selectors.progressBar).css('width', progress + '%');

      $inventoryDisplay.slideDown();
    } else {
      $inventoryDisplay.slideUp();
    }
  }

  function handleValChange() {
    // console.debug('productInventoryFunction.handleValChange');

    var $closestForm = $(this).closest('form');

    setTimeout(function productInventoryTimeout() {
      var $selectedVariant = $closestForm.find(selectors.originalSelectorId + ' option:selected');

      var $variantInventory = $selectedVariant.data('max');

      if ($selectedVariant.data('max')) {
        $selectedVariant.closest('form').find($(selectors.input)).attr('max', $variantInventory);

        if ($selectedVariant.closest('form').find($(selectors.input)).val() > $variantInventory) {
          console.log('Too many');
          $selectedVariant.closest('form').find($(selectors.input)).val($variantInventory);
        }

        inventoryDisplayUpdate($variantInventory);
      } else {
        $selectedVariant.closest('form').find($(selectors.input)).removeAttr('max');

        $inventoryDisplay.slideUp();
      }
    }, 50);
  }

  function _init() {
    $(selectors.singleOptionSelector).on('change', handleValChange);
  }

  _init();
})();

/**
 * Activate :active states for buttons & links
 *
 */

(function mobileActiveStates() {
  function init() {
    if (document.addEventListener && true) {
      // enables :active states on mobile safari
      document.addEventListener('touchstart', function () { }, false);
    }

    // adds class confirming touch event support (for use in CSS)
    document.addEventListener(
      'touchstart',
      function addtouchclass(e) {
        document.documentElement.classList.add('is-touch');
        document.removeEventListener('touchstart', addtouchclass, false);
      },
      false
    );
  }

  init();
})();

/**
 * Module to render cart when using the browser back button
 *
 */

(function reloadFunction() {
  function _init() {
    var selectors = {
      cartCount: '[data-cart-item-count]'
    };

    if (performance.navigation.type == 2) {
      window.rfd.renderCart(true, window.rfd.enableBtns);
      $(selectors.cartCount).html(window.theme.cartJSON.item_count);
      console.log('[Browser back] render cart');
    }
  }

  _init();
})();

/**
 * Functions for updating collection filter results over AJAX
 */

$(function collectionFiltersFunction() {
  'use strict';

  var selectors = {
    module: '[data-filters]',
    // "selectors.group" acts as an OPTIONAL "wrapper" element tying together
    // filters & sort menus that should interact with each other despite being
    // in separate sections (can help achieve certain designs)
    filterDrawer: '.collection-filters',
    group: '[data-filters-group]',
    filterResults: '[data-filters-results]',
    filterPag: '[data-filters-pag]',
    filterGroup: '.filter-group',
    filterGroupList: '.filter-group__list',
    filterGroupItem: '.filter-group__item',
    filterLinks: '[data-filter-link]',
    filterLinksValAttr: 'data-tag-value',
    // only target sort menu links with parent filters container. allows them to
    // be included as a standalone menu acting as regular links, if needed
    filterSort: '[data-filters] [data-filter-sort], [data-filters-group] [data-filter-sort]',
    filterSummary: '[data-filter-summary]',
    filterSummaryActive: '[data-filter-summary-active]',
    sortUi: '[data-sort-ui]',
    sortBtn: '[data-sort-btn-text]',
    collectionLinks: '[data-collection-link]',
    resetBtn: '[data-filters-reset]',
    applyBtn: '[data-filters-apply]',
    // exclude collection links as there is no reliable "remove" URL to use
    summaryLink: '[data-filter-link]:not([data-collection-link])',
    active: '.is-active',
    selectToggle: '[data-select-toggle]',
    slider: '[data-filter-slider]',
    sliderIdAttr: 'data-filter-slider',
    checkbox: '[data-filter-checkbox]',
    checkboxes: '[data-filter-checkboxes]',
    checkboxesIdAttr: 'data-filter-checkboxes',
    gridCount: '[data-grid-count]',
    accordionItem: '.js-accordion-item',
    emptyResults: '.empty-selection'
  };

  function filtersFunction() {
    function loop() {
      var filters = document.querySelectorAll('.js-block[data-block="filters"]');

      for (var x = 0; x < filters.length; x++) {
        init(filters[x]);
      }
    }

    function init(el) {
      // Elements
      var filters = el,
        siteHeader = document.querySelector('.site-header'),
        toggleTrigger = filters.querySelector('.js-filters-toggle-trigger'),
        closeTrigger = filters.querySelector('.js-filters-close-trigger'),
        nextFocusItem = document.querySelector('.layout-sort__column-count-trigger--gallery'),
        applyBtn = filters.querySelector('.js-apply-filters-btn'),
        clearBtn = filters.querySelector('.js-clear-filters-btn'),
        currentState = document.body.classList.contains('filters-open');

      var open = currentState; // Add Events

      // Add Events
      filters?.addEventListener('focusin', checkFiltersOpen);
      nextFocusItem?.addEventListener('focusin', checkFiltersClosed);
      toggleTrigger?.addEventListener('click', toggleFilters);
      closeTrigger?.addEventListener('click', closeFilters);
      if (applyBtn) applyBtn?.addEventListener('click', closeFilters);
      if (window.innerWidth <= 1024) clearBtn?.addEventListener('click', closeFilters);

      function checkFiltersOpen() {
        if (!open && window.innerWidth > 1024) setTimeout(openFilters, 100);
      }

      function checkFiltersClosed() {
        if (open && window.innerWidth > 1024) closeFilters();
      }

      function toggleFilters() {
        if (open) {
          closeFilters();
        } else {
          openFilters();
        }
      }

      function openFilters() {
        open = true;
        siteHeader.classList.add('mobile-hidden');
        document.body.classList.add('filters-open');
      }

      function closeFilters() {
        open = false;
        siteHeader.classList.remove('mobile-hidden');
        document.body.classList.remove('filters-open');
      }
    }

    loop();
  }

  filtersFunction();

  var sliderVals = {};
  var checkboxesVals = {};
  var filteredUrl = null;
  var defaultSelectText = $(selectors.selectToggle).text();

  var sort = {
    query: null,
    cleared: false
  };

  /**
   * Updates grid count in collection header
   */

  function updateGridCount() {
    var $gridCount = $(selectors.gridCount);
    var count = $(selectors.filterResults).find('.product-grid__item').length;

    var noResultsMsge =
      '<div class="empty-selection">Your filter selection did not yield results.</div>';

    if (count == 0) {
      console.log('[filters] Grid count is EMPTY');
      $(selectors.filterResults).append(noResultsMsge);
    } else {
      $gridCount.append('(' + count + ' Items)');
    }
  }

  /**
   * Hides filter groups that have an empty list.
   */
  function hideEmptyFilters() {
    $(selectors.filterGroup).each(function filterGroupLoop() {
      var $slider = $(this).find(selectors.slider);
      var $list = $(this).find(selectors.filterGroupList);
      var $items = $(this).find(selectors.filterGroupItem);
      if (($list.length && !$items.length) || (!$slider.length && !$list.length)) {
        $(this).hide();
      }
    });
  }

  function getFiltersAjaxUrl(url) {
    var ajaxUrl = url;

    if (!ajaxUrl) {
      ajaxUrl = window.location.pathname;
    }
    if (ajaxUrl.indexOf('view=filters-only') === -1) {
      if (ajaxUrl.indexOf('?') === -1) {
        return ajaxUrl + '?view=filters-only';
      }
      return ajaxUrl.replace('?', '?view=filters-only&');
    }
    return ajaxUrl;
  }

  function setSortActiveState() {
    var $filterSorts = $(selectors.filterSort);

    // set active sort based on selections made (used following AJAX DOM updates)
    if (sort.query) {
      console.log('[filters] restore active sort');

      $filterSorts
        .filter('[href="' + sort.query + '"]')
        .addClass('is-active')
        .closest(selectors.filterGroupItem)
        .addClass('is-active');

      return;
    }
    if (sort.cleared) {
      console.log('[filters] restore cleared sort');
      $filterSorts.removeClass('is-active');
      return;
    }

    // set active sort based on URL (used on initial page load)
    var sortVal = window.location.search.match(/\?(sort_by=.*?)(&|$|#)/i);
    if (sortVal && sortVal.length) {
      sortVal = sortVal[1];
      console.log('[filters] sort value', sortVal);
    } else {
      return;
    }

    var $activeSort = $filterSorts.filter('[href*="' + sortVal + '"]');

    if ($activeSort.length) {
      $filterSorts
        .removeClass('is-active')
        .closest(selectors.filterGroupItem)
        .removeClass('is-active');

      $activeSort.addClass('is-active').closest(selectors.filterGroupItem).addClass('is-active');

      console.log('[filters] set active sort');

      $(selectors.selectToggle).text($activeSort.text());
    }
  }

  /**
   * Shopify doesn't set "link.active" on "All" collection when tags are in URL,
   * so we check and add manually.
   */
  function fixCollectionsActiveState() {
    var $collectionLinks = $(selectors.collectionLinks);
    if ($collectionLinks.filter('.is-active').length === 0) {
      $collectionLinks.each(function collectionLinksLoop() {
        var urlMatch = window.location.href.indexOf($(this).attr('href'));
        if (urlMatch !== -1) {
          $(this).addClass('is-active').closest(selectors.filterGroupItem).addClass('is-active');
        }
      });
    }
  }

  /**
   * Updates given slider element to given value. Useful for programatically
   * setting slider values (e.g. following AJAX updates to DOM).
   */
  function setSliderVal(slider, sliderVal) {
    var sliderData = $(slider).data('ionRangeSlider');
    var vals = sliderVal.split(';');
    var fromIndex;
    var toIndex;

    if (!$.isFunction(sliderData.update)) {
      // eslint-disable-next-line no-console
      console.error('[filters] no update method', this);
      return;
    }

    // only update if not already matching (prevents infinite update event
    // callback loop)
    if ($(slider).val() === sliderVal) {
      return;
    }

    fromIndex = sliderData.options.p_values.indexOf(vals[0]);
    toIndex = sliderData.options.p_values.indexOf(vals[1]);

    if (fromIndex < 0 || toIndex < 0) {
      // eslint-disable-next-line no-console
      console.log('[filters] price range no longer valid');
      return;
    }

    sliderData.update({
      from: fromIndex,
      to: toIndex
    });

    // eslint-disable-next-line no-console
    console.log('[filters] price range restored');
  }

  /**
   * Restore all sliders from sliderVals object (populated by handleRangeUpdate)
   */
  function restoreSliderVals() {
    var sliderId;
    var slidersSelector;
    var $sliders;

    for (sliderId in sliderVals) {
      // eslint-disable-line
      if (sliderVals.hasOwnProperty(sliderId)) {
        // eslint-disable-line
        slidersSelector = '[' + selectors.sliderIdAttr + '="' + sliderId + '"]';
        $sliders = $(selectors.slider).filter(slidersSelector);
        /* eslint-disable no-loop-func */
        $sliders.each(function slidersLoop() {
          /* eslint-enable no-loop-func */
          setSliderVal(this, sliderVals[sliderId]);
        });
      }
    }
  }

  /**
   * Sort filters don't work using the search template, so we need to hide that
   * part of the UI when the "OR" state is toggled.
   */
  function toggleSortMenus(toggle) {
    var $sortUI = $(selectors.sortUi);
    $sortUI.toggle(toggle);
  }

  /**
   * Check for "OR" filters like sliders and checkboxes. This is used to
   * determine where to send AJAX queries for filtered results (collection
   * / search template).
   *
   * Note: "OR" controls store their values in .data('value') by convention.
   */
  function getOrState(module) {
    var $module = module ? $(module) : $(selectors.module);
    var $sliders = $module.find(selectors.slider);
    var $checkboxes = $module.find(selectors.checkboxes);
    var $orControls = $sliders.add($checkboxes);

    var orState = false;

    $orControls.each(function orControlsLoop() {
      var value = $(this).data('value');

      if (value && value.length > 1) {
        // eslint-disable-next-line no-console
        console.log('[filters] orState true', value);
        orState = true;
      }
    });

    // eslint-disable-next-line no-console
    console.log('[filters] orState', orState);
    return orState;
  }

  /**
   * Fire anything that needs re-initialised following filters AJAX updates here
   */
  function filtersPostAjax() {
    var $clone;
    var orState;

    addCheckboxCounts();
    hideEmptyFilters();
    // setSortActiveState();
    fixCollectionsActiveState();

    if (window.rfd && window.rfd.initSliders) {
      window.rfd.initSliders($(selectors.slider));
    }

    if (window.rfd && window.rfd.initCheckboxes) {
      window.rfd.initCheckboxes($(selectors.checkboxes));
    }

    // NOTE: needs to be called after slider init above
    restoreSliderVals();

    if (window.rfd && window.rfd.sortTags) {
      window.rfd.sortTags();
    }
    if (window.rfd && window.rfd.enableBtns) {
      window.rfd.enableBtns();
    }
    // Show VIP prices
    if (window.rfd && window.rfd.vipSale) {
      window.rfd.vipSale();
    }
    // re-initialise infinite scroll
    if (window.rfd && window.rfd.lazyPagReinit) {
      window.rfd.lazyPagReinit();
    }

    if (window.rfd && window.rfd.reinitQuickAdd) {
      window.rfd.reinitQuickAdd();
    }

    // Add sort to desktop again
    $clone = $('.desktop-sortby').clone();
    $('.desktop-sortby-placeholder').html($clone);

    // eslint-disable-next-line no-console
    console.log('[filters] add sort back');

    orState = getOrState();

    if (orState) {
      toggleSortMenus(false);
    } else {
      toggleSortMenus(true);
    }
  }

  /**
   * Simple utility function returning a random number
   * Used to assign unique IDs
   */
  function getRandom() {
    return Math.floor(Math.random() * 99999);
  }

  /**
   * Updates the summary of active filters based on the current filter nav state.
   */
  function updateSummary() {
    var $module = $(selectors.module).first();
    var $summary = $module.find(selectors.filterSummary);
    var $summaryActive = $module.find(selectors.filterSummaryActive);
    var $activeFilters = $module
      .find('[data-filter-checkbox], [data-filter-link]')
      .filter('.is-active');
    var $sliders = $module.find(selectors.slider);

    var activeSliders = false;
    $sliders.each(function updateSummarySlidersLoop() {
      var $sum = $(this).closest('.filter-group__slider').find('.range-slider__selection-val');
      if (
        this.value &&
        this.value.length &&
        (!$sum.length || $sum.text().trim() !== $sum.attr('data-none-val').trim())
      ) {
        activeSliders = true;
      }
    });

    $summaryActive.empty();

    if (!activeSliders && !$activeFilters.length) {
      $summary.attr('aria-hidden', true);
      return;
    }

    $summary.attr('aria-hidden', false);

    $activeFilters.each(function activeFiltersLoop() {
      // store a unique ID that will link the active filter to the summary link
      // when the summary link is clicked to remove, this is used to trigger
      // a click on the original summary link
      var uniqueId = 'filter-' + getRandom();
      var tagName = $(this).attr('data-tag-name');
      var activeLink =
        '<a class="link--tag capitalize display-inline-block" href="#' +
        uniqueId +
        '">' +
        tagName +
        '</a>';
      $(this).attr('id', uniqueId);
      $summaryActive.append(activeLink);
    });

    $sliders.each(function summarySlidersLoop() {
      var uniqueId = 'filter-' + getRandom();
      var prefix = $(this).attr('data-prefix-char');
      var val = $(this).val();
      var $sum = $(this).closest('.filter-group__slider').find('.range-slider__selection-val');

      var rangeVals = val.split(';');
      var rangeStr = prefix + rangeVals[0] + ' - ' + prefix + rangeVals[1];
      var $clearBtn = $(this).parent().find('.range-slider__clear');
      var activeLink =
        '<a class="link--tag capitalize display-inline-block" href="#' +
        uniqueId +
        '">' +
        rangeStr +
        '</a>';

      // Due to the way sliders need to be reset, we need to also check
      // manually the slider summary does not display the "None" value to ensure
      // it has an active range of values set
      if (
        !val.length ||
        ($sum.length && $sum.text().trim() === $sum.attr('data-none-val').trim())
      ) {
        return;
      }

      $clearBtn.attr('id', uniqueId);
      $summaryActive.append(activeLink);
    });
  }

  function ajaxUpdateFilters(callback) {
    var $currentFilters = $(selectors.module);
    var ajaxUrl = getFiltersAjaxUrl(filteredUrl);

    if (window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns();
    }

    // eslint-disable-next-line no-console
    console.log('[filters] updating filters...', ajaxUrl);
    // eslint-disable-next-line no-console
    console.time('[filters] update filters');

    $.get(ajaxUrl, function ppdateFiltersAjaxCall(filterHtmlStr) {
      var $updatedFilters = $(filterHtmlStr).find(selectors.module);

      // note: this updates all filters on the page ($currentFilters can contain
      // multiple filters)
      $currentFilters.replaceWith($updatedFilters);

      var $filtersDrawer = $(selectors.filterDrawer);
      //var $currentFilterGroup = $(selectors.filterGroup);
      $filtersDrawer.addClass('open');
      //$currentFilterGroup.addClass('open');

      if (window.rfd && window.rfd.menuAccordionFunction) {
        window.rfd.menuAccordionFunction();
      }

      if (window.rfd && window.rfd.reinitQuickAdd) {
        window.rfd.reinitQuickAdd();
      }

      // re-initialise infinite scroll
      if (window.rfd && window.rfd.lazyPagReinit) {
        window.rfd.lazyPagReinit();
      }

      filtersFunction();
      filtersPostAjax();
      updateSummary();

      // eslint-disable-next-line no-console
      console.timeEnd('[filters] update filters');

      if ($.isFunction(callback)) {
        callback();
      }
    });
  }

  /**
   * Constructs & returns URL for search results AJAX call
   */
  function getSearchURL(module) {
    var searchUrl = '/search?type=product&view=filter-results';
    var queryVal = '';
    var excludeTag = '';
    var sortStr = '';
    var allowedSorts = [
      'created-descending',
      'price-ascending',
      'price-descending',
      'title-ascending',
      'title-descending'
    ];
    var collectionHandle;
    var $activefilterLinks;
    var $sliders = $(module).find(selectors.slider);
    var sliderVals; // eslint-disable-line no-shadow
    var $checkboxGroups = $(module).find(selectors.checkboxes);
    var checkboxVals;

    // transform sort query e.g. "?sort_by=title-descending" into value string
    // to select correct search template
    if (sort && sort.query) {
      allowedSorts.forEach(function allowedSortsLoop(val) {
        if (sort.query.search(val) !== -1) {
          sortStr = val;
        }
      });
    }

    if (sortStr) {
      // NOTE: disabled this as it doesn't work on serch templates past page 2
      // searchUrl += '-' + sortStr;
    }

    searchUrl += '&q=';

    // if we are on a collection other than "all", start the query with that
    collectionHandle = window.location.href.match(/collections\/([\w-]*)/)[1];
    if (collectionHandle !== 'all') {
      queryVal =
        'tag%3A%22collection:' +
        collectionHandle +
        '%22+OR+tag%3A%22collection:%20' +
        collectionHandle +
        '%22';
      // queryVal =
      //   '%28tag%3A%22collection:' +
      //   collectionHandle +
      //   '%22+OR+tag%3A%22collection:%20' +
      //   collectionHandle +
      //   '%22%29';
    }

    // add regular tag values (no OR) from filteredUrl
    $activefilterLinks = $(module).find(selectors.filterLinks).filter('.is-active');

    $activefilterLinks.each(function activefilterLinksLoop() {
      var tagVal = $(this).attr('data-tag-value');
      if (!tagVal) {
        return;
      }
      if (queryVal) {
        queryVal += '+AND+';
      }
      queryVal += 'tag%3A%22' + tagVal + '%22';
    });

    // add sliders vals (only desktop filters to prevent dupe vals)
    $sliders.each(function addSlidersLoop() {
      sliderVals = $(this).data('value');

      if (!Array.isArray(sliderVals)) {
        return;
      }

      sliderVals.forEach(function addSlidersValsLoop(tagVal, index) {
        // need to percent-encode spaces
        var tagValEncoded = tagVal.replace(' ', '%20');
        if (index === 0) {
          if (queryVal) {
            queryVal += '+AND+';
          }
          queryVal += 'tag%3A%22' + tagValEncoded + '%22';
        } else {
          if (queryVal) {
            queryVal += '+OR+';
          }
          queryVal += 'tag%3A%22' + tagValEncoded + '%22';
        }
      });
    });

    // add checkbox group vals (only desktop filters to prevent dupe vals)
    $checkboxGroups.each(function checkboxGroupsLoop() {
      checkboxVals = $(this).data('value');

      if (!Array.isArray(checkboxVals)) {
        return;
      }

      checkboxVals.forEach(function checkboxValsLoop(tagVal, index, arr) {
        // need to percent-encode spaces
        var tagValEncoded = tagVal.replace(' ', '%20');
        if (index === 0) {
          if (queryVal) {
            queryVal += '+AND+';
            // queryVal += '%28';
          }
          queryVal += 'tag%3A%22' + tagValEncoded + '%22';
        } else {
          if (queryVal) {
            queryVal += '+OR+';
          }
          queryVal += 'tag%3A%22' + tagValEncoded + '%22';
        }
        if (index === arr.length - 1) {
          if (queryVal) {
            // queryVal += '%29';
          }
        }
      });
    });

    // if we have no selected filters, return false
    if (queryVal === '') {
      return queryVal;
    }

    if (excludeTag) {
      queryVal += '+NOT+tag%3A' + excludeTag;
    }

    // eslint-disable-next-line no-console
    console.log(
      '[filters] collectionHandle, sliderVals, checkboxVals',
      collectionHandle,
      sliderVals,
      checkboxVals
    );

    return searchUrl + queryVal;
  }

  /**
   * Constructs & returns URL for collection results AJAX call
   */
  function getCollectionURL() {
    var destinationUrl;

    // no selections made, so return original URL sans filters
    if (!sort.query && !filteredUrl && !sort.cleared) {
      // eslint-disable-next-line no-console
      console.log('[filters] selection reset');
      destinationUrl = window.location.pathname;
      return destinationUrl;
    }

    // sort cleared & no other filter selections
    if (!filteredUrl && sort.cleared) {
      // eslint-disable-next-line no-console
      console.log('[filters] clear sort');
      destinationUrl = window.location.href.replace(/\??&?sort_by=.*?(&|$)/gi, '');
      return destinationUrl;
    }

    // sort cleared as part of other selections
    if (sort.cleared) {
      filteredUrl = filteredUrl.replace(/\??&?sort_by=.*?(&|$)/gi, '');
    }

    // only sort selection made
    if (sort.query && !filteredUrl) {
      destinationUrl = window.location.pathname + sort.query;
      // eslint-disable-next-line no-console
      console.log('[filters] only change sort', destinationUrl);
      return destinationUrl;
    }

    // filter selections made
    destinationUrl = filteredUrl.replace(/\??&?view=filters-only&?/gi, '');

    if (sort.query) {
      if (destinationUrl.indexOf('sort_by=') === -1) {
        if (destinationUrl.indexOf('?') === -1) {
          // eslint-disable-next-line no-console
          console.log('[filters] append sort');
          destinationUrl += sort.query;
        } else {
          // eslint-disable-next-line no-console
          console.log('[filters] add sort');
          sort.query = sort.query.replace('?', '&');
          destinationUrl += sort.query;
        }
      } else {
        // already contains "sort_by": replace instead of append
        // eslint-disable-next-line no-console
        console.log('[filters] replace sort');
        sort.query = sort.query.replace('?', '');
        destinationUrl = destinationUrl.replace(/sort_by=.*?(&|$)/gi, sort.query + '$1');
      }
    }

    return destinationUrl;
  }

  /**
   * Fire anything that needs re-initialised following results AJAX updates here
   */
  function resultsPostAjax() {
    var sections;

    // re-fire resposive images polyfill for IE11
    if (window && window.picturefill) {
      window.picturefill();
      // eslint-disable-next-line no-console
      console.log('[filters] refire picturefill');
    }

    // re-fire object-fit polyfill
    if (window && window.objectFitPolyfill) {
      window.objectFitPolyfill();
      // eslint-disable-next-line no-console
      console.log('[filters] refire objectFitPolyfill');
    }

    if (window.rfd && window.rfd.enableBtns) {
      window.rfd.enableBtns();
    }

    // re-fire product.js so product form in collection grid works
    sections = new slate.Sections();
    sections.register('product', window.theme.Product);

    // eslint-disable-next-line no-console
    console.log('[filters] refire product.js');

    if (window.rfd && window.rfd.reinitQuickAdd) {
      window.rfd.reinitQuickAdd();
    }

    if (typeof collectionPageMobileCarousel !== 'undefined' && $.isFunction(collectionPageMobileCarousel))
      collectionPageMobileCarousel();
  }

  /**
   * Gets filtered results from query URL supplied
   */
  function getFilteredResults(queryUrl, callback) {
    // log absolute URLs of search query for easy query debugging
    var siteUrl = window.location.href
      .replace(window.location.pathname, '')
      .replace(window.location.search, '')
      .replace(window.location.hash, '');
    var queryUrlDefaultView = queryUrl.replace(/view=.*?&/, '');

    if (!queryUrl) {
      // eslint-disable-next-line no-console
      console.error('[filters] no valid queryUrl supplied');
      return;
    }

    if (window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns();
    }

    // eslint-disable-next-line no-console
    console.log('[filters] fetching results', siteUrl + queryUrlDefaultView);
    console.log('[filters] queryUrl', queryUrl);
    // console.log(siteUrl + queryUrlDefaultView);

    $.get(queryUrl, function filteredResultsCallback(data) {
      if ($.isFunction(callback)) {
        callback(data);
      }

      resultsPostAjax();
    });
  }

  /**
   * Update results on page with data supplied
   */
  function setFilteredResults(newHtml) {
    var $newHtml = $(newHtml);
    var $results = $(selectors.filterResults);
    var $pag = $(selectors.filterPag);
    var $newResults = $newHtml.find(selectors.filterResults);
    var $newPag = $newHtml.find(selectors.filterPag);
    var orState = getOrState();

    $results.replaceWith($newResults);

    // classname to amend layout when filtered (e.g. hide collection header)
    var filterCount = $('.filter-group .is-active:not([data-default-selected])').length;
    if (filterCount > 0) {
      $('body').addClass('is-filtered');
    } else {
      $('body').removeClass('is-filtered');
    }
    console.log(sort.query, filteredUrl, checkboxesVals, sliderVals);

    // update grid count in header to reflect filtered items
    updateGridCount();

    if ($newPag.length) {
      $pag.html($newPag.html());
    }

    // eslint-disable-next-line no-console
    console.log('[filters] updated results');

    if (orState) {
      toggleSortMenus(false);
    } else {
      toggleSortMenus(true);
    }

    // re-initialise lazy pag to pull in new pag links
    if (window.rfd && window.rfd.lazyPagReinit) {
      window.rfd.lazyPagReinit();
    }

    if (window.rfd && window.rfd.layoutGrid) {
      window.rfd.layoutGrid();
    }

    // Run matchHeight again on product card
    $('.product-grid__item').addClass('filtered-item');
  }

  /**
   * Check if an element is on canvas. Used to check if "apply" button is hidden
   * in a closed off-canvas menu, despite being ":visible"
   */
  function isOnCanvas(elem) {
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.left >= 0 &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  /**
   * Check if there is a visible "Apply" button in filters. This is used to
   * determine whether to immediately update the results on filter selections.
   */
  function getApplyBtnState(module) {
    var applyState = false;
    var $applyBtn = $(module).find(selectors.applyBtn);
    if ($applyBtn.length && $applyBtn.is(':visible') && isOnCanvas($applyBtn.get(0))) {
      applyState = true;
    }
    // console.log('[filters] apply button', applyState);
    return applyState;
  }

  /**
   * Find the actual filter link referred to and trigger a click on it.
   */
  function handleSummaryActiveClick(e) {
    var sourceLink = $(this).attr('href');
    e.preventDefault();
    $(sourceLink).trigger('click');
  }

  /**
   * Binds click events to the summary "remove" links.
   */
  function initSummary() {
    $(document).on('click', '[data-filter-summary-active] a', handleSummaryActiveClick);
  }

  /**
   * Returns the appropriate URL to send the AJAX query to for retrieving
   * filtered results (collection / search template).
   */
  function getDestinationUrl(module) {
    var $module = $(module);
    var destinationUrl;
    var orState = getOrState($module);

    // if (orState) {
    //   destinationUrl = getSearchURL($module);
    // } else {
      destinationUrl = getCollectionURL();
    // }

    // eslint-disable-next-line no-console
    console.log('[filters] destination url', destinationUrl);

    return destinationUrl;
  }

  /**
   * Get results & update them on the page
   */
  function updateResults(module) {
    var $module = $(module);
    var destinationUrl = getDestinationUrl($module);

    if (!destinationUrl) {
      // eslint-disable-next-line no-console
      console.log('[filters] no query url', destinationUrl);
      return;
    }

    // eslint-disable-next-line no-console
    console.time('[filters] fetch results');

    getFilteredResults(destinationUrl, function getFilteredResultsFunction(data) {
      // eslint-disable-next-line no-console
      console.timeEnd('[filters] fetch results');
      setFilteredResults(data);
      updateSummary();
    });
  }

  /**
   * Check for a visible "Apply" button in filters. If not, update results
   * immediately.
   */
  function updateResultsIfNoApply($module) {
    var isApplyBtn = getApplyBtnState($module);
    if (!isApplyBtn) {
      updateResults($module);
    }
  }

  /**
   * Updates given checkbox element to given value.
   */
  function setCheckboxVal(checkboxGroup, checkboxVal) {
    var $checkboxGroup = $(checkboxGroup);

    // update the data value in DOM
    $checkboxGroup.data('value', checkboxVal);

    // update the active state on checkbox items
    checkboxVal.forEach(function checkboxValLoop(val) {
      $checkboxGroup
        .find('[data-tag-value="' + val + '"]')
        .addClass('is-active')
        .closest('.filter-group__item')
        .addClass('is-active');
    });
  }

  /**
   * Matches other instances of the given filter slider to the same value.
   */
  function setSliderCounterparts(slider) {
    var sliderId = $(slider).attr(selectors.sliderIdAttr);
    var sliderSelector = '[' + selectors.sliderIdAttr + '="' + sliderId + '"]';
    var $sliderCounterparts = $(sliderSelector).not(slider);
    var sliderVal = $(slider).val();

    $sliderCounterparts.each(function sliderCounterpartsLoop() {
      setSliderVal(this, sliderVal);
    });
  }

  /**
   * Matches other instances of the given checkbox group to the same value.
   */
  function setCheckboxesCounterparts(checkboxGroup) {
    var id = $(checkboxGroup).attr(selectors.checkboxesIdAttr);
    var value = $(checkboxGroup).data('value');
    var allSelector = '[' + selectors.checkboxesIdAttr + '="' + id + '"]';
    var $counterparts = $(allSelector).not(checkboxGroup);

    // eslint-disable-next-line no-console
    console.log('[filters] updating counterparts', allSelector, $counterparts);

    $counterparts.each(function counterpartsLoop() {
      setCheckboxVal(this, value);
    });
  }

  function handleRangeUpdate() {
    var $module = $(this).closest(selectors.module);
    var sliderId = $(this).attr(selectors.sliderIdAttr);
    var sliderVal = $(this).val();
    var orState = getOrState($module);
    var isApplyBtn = getApplyBtnState($module);

    sliderVals[sliderId] = sliderVal;

    setSliderCounterparts(this);

    if (orState) {
      toggleSortMenus(false);
    } else {
      toggleSortMenus(true);
    }

    // update results immediately if no visible Apply button
    if ($module.length && !isApplyBtn) {
      updateResults($module);
    }
  }

  function handleCheckboxesUpdate(e) {
    var $module = $(this).closest(selectors.module);
    var checkboxesId = $(this).attr(selectors.checkboxesIdAttr);
    var checkboxesVal = $(this).data('value');
    var orState = getOrState($module);
    var isApplyBtn = getApplyBtnState($module);

    e.preventDefault();

    checkboxesVals[checkboxesId] = checkboxesVal;
    setCheckboxesCounterparts(this);

    if (orState) {
      toggleSortMenus(false);
    } else {
      toggleSortMenus(true);
    }

    // update results immediately if no visible Apply button
    if ($module.length && !isApplyBtn) {
      updateResults($module);
    }
  }

  function handleSortSelect(e) {
    var $allLinks = $(selectors.filterSort).filter('[data-href="' + $(this).attr('data-href') + '"]');
    var $filterGroup = $allLinks.closest(selectors.filterGroup);
    var sortVal = $(this).text();
    var $module = $(this).closest(selectors.module);

    e.preventDefault();

    if ($(this).hasClass('is-active')) {
      // remove sort from query
      $allLinks.removeClass('is-active');
      sort.query = null;
      sort.cleared = true;

      // Reset select toggle
      $filterGroup.find(selectors.selectToggle).text(defaultSelectText);
      $(selectors.sortBtn).text(defaultSelectText);
      $filterGroup.find('.filter-group__select').removeClass('is-open');

      return;
    }

    sort.cleared = false;
    sort.query = $(this).attr('data-href');

    $filterGroup.find('.is-active').removeClass('is-active');

    $allLinks.addClass('is-active');

    // Update select toggle
    $filterGroup.find(selectors.selectToggle).text(sortVal);
    $(selectors.sortBtn).text(sortVal);

    // Close select
    $filterGroup.find('.filter-group__select').removeClass('is-open');

    // eslint-disable-next-line no-console
    console.log('[filters]', sort.query);

    // NOTE: this is a bit hacky. on Arran we need to separate sortby & filter
    // menus (since they appear in separate mobile offcanvas menus), so if sort
    // link has no filter parent [data-filters], look for "group" element parent
    // [data-filters-group], then find filter inside it
    if (!$module.length) {
      $module = $(this).closest(selectors.group).find(selectors.module);
    }
    if ($module.length) {
      updateResultsIfNoApply($module);
    }

    // Override the Apply button and fire on click
    handleApplyClick(e);
  }

  /**
   * Updates filteredUrl on checkbox click, so when only one checkbox is
   * selected we can still disable orState & use regular AJAX query.
   */
  function handleCheckboxClick(e) {
    e.preventDefault();
    filteredUrl = $(this).attr('data-href');
    ajaxUpdateFilters();

    handleApplyClick(e);
  }

  function handleFilterClick(e) {
    // Find all versions of this filter link on the page (via its unique
    // [data-tag-value] attr). If there are multiple versions of filters in the
    // markup (e.g. mobile, desktop), we need to update all at the same time to
    // reliably maintain state.
    var tagVal = $(this).attr('data-tag-value');
    var allLinksSelector = '[' + selectors.filterLinksValAttr + '="' + tagVal + '"]';
    var $allLinks = $(selectors.filterLinks).filter(allLinksSelector);
    var $module = $(this).closest(selectors.module);

    e.preventDefault();

    filteredUrl = $(this).attr('href');

    // immediately update filter group active state (AJAX will update shortly after)
    $allLinks.each(function allLinksLoop() {
      var $filterGroup = $(this).closest(selectors.filterGroup);
      $filterGroup.find('.is-active').removeClass('is-active');
      $(this).addClass('is-active');
    });

    ajaxUpdateFilters();

    updateResultsIfNoApply($module);
  }

  function handleApplyClick(e) {
    var $module = $(this).closest(selectors.module);
    e.preventDefault();
    updateResults($module);
    if ($('body').hasClass('is-offcanvas-open')) {
      setTimeout(function () {
        $('.js-offcanvas-close').click();
      }, 1000);
    } else {
      setTimeout(function () {
        $('[data-toggle-target="#filters-dropdown"]').click();
      }, 1000);
    }

    // re-initialise lazy pag to pull in new pag links
    if (window.rfd && window.rfd.lazyPagReinit) {
      window.rfd.lazyPagReinit();
    }
  }

  function handleResetClick(e) {
    var $module = $(this).closest(selectors.module);

    e.preventDefault();

    // eslint-disable-next-line no-console
    console.log('[filters] reset');

    // remove active state from all filter links
    $(selectors.filterLinks).removeClass('is-active');
    $(selectors.filterGroupItem).removeClass('is-active');

    // reset sort to default
    $(selectors.sortUi)
      .find('.is-active')
      .removeClass('is-active')
      .find('[data-default-selected]')
      .addClass('is-active');

    // reset select toggle
    $(selectors.selectToggle).text(defaultSelectText);
    $(selectors.sortBtn).text(defaultSelectText);

    sort.query = null;
    filteredUrl = null;
    checkboxesVals = {};
    sliderVals = {};

    // update filters via AJAX
    ajaxUpdateFilters(function afterFiltersUpdate() {
      updateResults($module);
      //$(selectors.applyBtn)
      //  .get(0)
      //  .trigger('click');
    });
  }

  function addCheckboxCounts() {
    var THRESHOLD = 7;
    $('.filter-group__list').each(function () {
      var count = $(this).find('.filter-group__item').length;
      $(this).toggleClass('is-small-list', count < THRESHOLD);
    });
  }

  function init() {
    if (!$(selectors.module).length) {
      return;
    }

    hideEmptyFilters();
    setSortActiveState();
    fixCollectionsActiveState();
    initSummary();
    addCheckboxCounts();

    $(document).on('click', selectors.filterLinks, handleFilterClick);
    $(document).on('click', selectors.checkbox, handleCheckboxClick);
    $(document).on('click', selectors.filterSort, handleSortSelect);
    $(document).on('click', selectors.resetBtn, handleResetClick);
    $(document).on('click', selectors.applyBtn, handleApplyClick);
    $(document).on('rangeSliderUpdate', selectors.slider, handleRangeUpdate);
    $(document).on('checkboxesUpdate', selectors.checkboxes, handleCheckboxesUpdate);
  }

  init();
});

/**
 * Functions to show and store checkbox values
 *
 * @exports window.rfd.initCheckboxes()
 */

(function checkboxesFunction() {
  var selectors = {
    checkboxes: '[data-checkboxes]',
    checkbox: '[data-checkbox]',
    activeClass: 'is-active',
    tagValueAttr: 'data-tag-value',
    summary: '[data-checkboxes-summary]',
    summaryList: '[data-checkboxes-summary-list]',
    count: '[data-checkboxes-count]',
    clear: '[data-checkboxes-clear]'
  };

  function updateSummary(checkboxGroup) {
    var $checkboxGroup = $(checkboxGroup);
    var currentVal = $checkboxGroup.data('value');
    var $summary = $checkboxGroup.find(selectors.summary);
    var $summaryList = $checkboxGroup.find(selectors.summaryList);
    var $count = $checkboxGroup.find(selectors.count);

    $count.text(currentVal.length);
    $summaryList.empty();

    if (!currentVal.length) {
      $summary.attr('aria-hidden', true);
      return;
    }

    $summary.attr('aria-hidden', false);

    currentVal.forEach(function checkboxesAddToList(val, ind, arr) {
      var valStr = val.replace(/^.*?:/, '').trim();
      $summaryList.append('<span class="capitalize">' + valStr + '</span>');

      if (ind < arr.length - 1) {
        $summaryList.append(', ');
      }
    });

    console.log('[checkboxes] updated summary');
  }

  function setValFromDOM(checkboxGroup) {
    var $checkboxGroup = $(checkboxGroup);
    var currentVal = [];
    var $checkboxBoxes = $checkboxGroup.find(selectors.checkbox);

    $checkboxBoxes.filter('.is-active').each(function checkboxesFilterTagged() {
      currentVal.push($(this).attr('data-tag-value'));
    });

    $checkboxGroup.data('value', currentVal);
    updateSummary($checkboxGroup);

    console.log('[checkboxes] set value to', currentVal);

    $('filters__active-list').text(currentVal);
  }

  function updateVal($checkboxGroup, value) {
    // update value in DOM
    $checkboxGroup.data('value', value);

    updateSummary($checkboxGroup);

    // send custom update event (used to hook into higher-level functionality
    // that needs to respond to value changes, like collection filters JS)
    $checkboxGroup.trigger('checkboxesUpdate');
  }

  function toggleVal(checkboxGroup, value) {
    var $checkboxGroup = $(checkboxGroup);
    var currentVal = $checkboxGroup.data('value');
    var valueIndex;
    var toggle;

    if (!$.isArray(currentVal)) {
      console.error('[checkboxes] invalid value (should be Array)', currentVal);
      return;
    }

    valueIndex = currentVal.indexOf(value);

    // set toggle direction -- true when value doesn't exist
    toggle = valueIndex < 0;

    if (toggle) {
      // add value to existing values array
      currentVal.push(value);
    } else {
      // remove value from existing
      currentVal.splice(valueIndex, 1);
    }

    updateVal($checkboxGroup, currentVal);

    console.log('[checkboxes] set value to', $checkboxGroup.data('value'));
  }

  function clearVal(checkboxGroup) {
    var $checkboxGroup = $(checkboxGroup);
    updateVal($checkboxGroup, []);
    $checkboxGroup.find('.is-active').removeClass('is-active');
  }

  function handleCheckboxClick(e) {
    var $checkboxGroup = $(this).closest(selectors.checkboxes);
    var checkboxVal = $(this).attr(selectors.tagValueAttr);

    e.preventDefault();

    $(this).toggleClass(selectors.activeClass);
    // hack: also togggle state on parent filter group items while we're at it
    // (aids styling)
    $(this).closest('.filter-group__item').toggleClass(selectors.activeClass);

    //toggleVal($checkboxGroup, checkboxVal);
  }

  function handleClearClick(e) {
    var $checkboxGroup = $(this).closest(selectors.checkboxes);
    e.preventDefault();
    clearVal($checkboxGroup);
  }

  function initCheckboxes(checkboxes) {
    var $checkboxes;

    if (!checkboxes) {
      $checkboxes = $(selectors.checkboxes);
    } else {
      $checkboxes = $(checkboxes);
    }

    $checkboxes.each(function checkboxesAssignFunctions() {
      setValFromDOM(this);
      $checkboxes = $(this).find(selectors.checkbox);
      $checkboxes.on('click', handleCheckboxClick);
      $(this).find(selectors.clear).on('click', handleClearClick);
    });
  }

  function init() {
    var $checkboxes = $(selectors.checkboxes);

    if (!$checkboxes.length) {
      return;
    }

    initCheckboxes($checkboxes);
  }

  $(document).on('ready', init);

  window.rfd = window.rfd || {};
  window.rfd.initCheckboxes = initCheckboxes;
})();

/**
 * Gallery module.
 *
 */

(function galleryFunction() {
  gsap.registerPlugin(ScrollToPlugin);

  function initGallery() {
    var galleries = document.querySelectorAll('.js-block[data-block="gallery"]');

    galleries.forEach(function (galleryMod) {
      'use strict';

      // Elements
      var gallery = galleryMod,
        header = document.querySelector('.pdp-header'),
        headerBackLink = document.querySelector('.pdp-header__back'),
        main = document.querySelector('.pdp-col--main'),
        title = main.querySelector('.pdp-main__title'),
        close = main.querySelector('.js-main-pdp-close-trigger'),
        btns = main.querySelector('.pdp-main__btns'),
        addBtn = btns.querySelector('.pdp-main__add-btn'),
        touchGallery = gallery.querySelector('.pdp-gallery__gallery'),
        list = gallery.querySelector('.pdp-gallery__gallery-list'),
        items = gallery.querySelectorAll('.pdp-gallery__gallery-item'),
        itemsL = items.length,
        dots = gallery.querySelector('.pdp-gallery__gallery-dots'),
        sizeGuideBtn = document.querySelector('.js-size-guide-trigger'), // Vars
        galeryWrap = document.querySelector('.pdp-gallery__desktop-wrap'),
        galeryZoomButton = document.querySelectorAll('.pdp-header .js-zoom, .mobile-nav__close'),
        mobileGalery = document.querySelector('.pdp-col--gallery'),
        mobileGaleryFigures = mobileGalery.querySelectorAll('figure'),
        mainInner = main.querySelector('.pdp-main__inner');

      var initialised = false,
        scrolling = false,
        scrollTimeout = null,
        zooming = false,
        zoomStart = { scale: 1, deltaX: 0, deltaY: 0 },
        zoomImageElementScale = 1,
        zoomImageElement = galeryWrap.querySelector('.pdp-gallery__gallery-item:nth-child(1) figure img'),
        current = 0,
        scroll = {
          prev: 0,
          current: 0,
          start: 0,
          new: 0,
          max: 0
        },
        touchScrollPos = {
          prev: 0,
          new: 0
        },
        scrollThreshold = 50,
        toNext = true,
        itemHeight = items[0].offsetHeight,
        calculatedGalleryHeight = 0,
        animFrame = null,
        animating = false,
        anchorScrollGsap = null,
        galleryOpen = true,
        pageWidth = 0;
      scroll.max = itemHeight * (itemsL - 1); // Reset scroll

      checkBackLink();

      window.onbeforeunload = function () {
        window.scrollTo(0, 0);
      }; // Add Font Listener

      var font = new FontFaceObserver('SURT', {
        weight: 700
      }); // Add Event Listeners

      touchGallery.addEventListener('touchmove', mobileEvent);
      touchGallery.addEventListener('touchend', stopScrolling);
      window.addEventListener('touchstart', startPageTouch);
      window.addEventListener('touchend', stopPageTouch);
      window.addEventListener('resize', setSizes);
      close.addEventListener('click', showGallery);
      btns.addEventListener('click', checkAddBtn);
      if (sizeGuideBtn) sizeGuideBtn.addEventListener('click', hideGallery);
      galeryWrap.addEventListener('touchstart', startZoom);
      galeryWrap.addEventListener('touchmove', changeZoom);
      galeryWrap.addEventListener('touchend', stopZoom);

      galeryZoomButton.forEach((el) => {
        el.addEventListener('click', () => {
          zoomStart.scale = 1;
          setImageTransform(0, 0, 1);
          document.querySelector('body').classList.toggle("zoom-mode");
          setTimeout(startScrolling, 300);
          setTimeout(anchorScroll, 310);
          setTimeout(() => scrolling = false, 350);
        });
      });

      font.load().then(function () {
        // Setup
        if (window.innerWidth < 1023) {
          setSizes();
        } else {
          pageWidth = window.innerWidth;
        }
      }, null);

      // Calculate distance between two fingers
      const distance = (event) => {
        return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
      };

      const setImageTransform = (deltaX, deltaY, scale) => {
        const isScaling = scale !== false;
        let realScale = scale;
        if (isScaling) {
          zoomStart.maxDeltaX = (((zoomImageElement.offsetWidth * scale) - zoomImageElement.offsetWidth) / 2);
          zoomStart.maxDeltaY = (((zoomImageElement.offsetHeight * scale) - zoomImageElement.offsetHeight) / 2);
        } else {
          realScale = zoomStart.scale;
        }

        let realDeltaX = deltaX === false ? zoomStart.deltaX || 0 : deltaX;
        let realDeltaY = deltaY === false ? zoomStart.deltaY || 0 : deltaY;

        if (Math.abs(realDeltaX) > zoomStart.maxDeltaX) {
          if (!isScaling) return;
          realDeltaX = Math.sign(realDeltaX) * zoomStart.maxDeltaX;
        }

        if (Math.abs(realDeltaY) > zoomStart.maxDeltaY) {
          if (!isScaling) return;
          realDeltaY = Math.sign(realDeltaY) * zoomStart.maxDeltaY;
        }

        const transform = `translate3d(${realDeltaX || 0}px, ${realDeltaY || 0}px, 0) scale(${realScale})`;
        zoomImageElement.style.display = "block";
        zoomImageElement.style.transform = transform;
        zoomImageElement.style.WebkitTransform = transform;

        zoomStart.lastDeltaX = realDeltaX;
        zoomStart.lastDeltaY = realDeltaY;
        zoomStart.lastScale = realScale;
      }

      function startZoom(event) {
        zoomImageElement = galeryWrap.querySelector(`.pdp-gallery__gallery-item:nth-child(${current + 1}) figure img`);

        if (event.touches.length === 2 && document.querySelector('body').classList.contains("zoom-mode")) {
          event.preventDefault(); // Prevent page scroll
          zooming = true;
          // galeryWrap.querySelector(`.pdp-gallery__gallery-item:nth-child(${current + 1}) figure img:nth-child(1)`).style.opacity = 0.4;

          zoomStart.distance = distance(event);
        } else {
          if (event.touches.length === 1 && document.querySelector('body').classList.contains("zoom-mode")) {
            zoomStart.startX = event.touches[0].pageX;
            zoomStart.startY = event.touches[0].pageY;
          }
        }
      }

      function stopZoom(event) {
        zooming = false;

        zoomStart.deltaX = zoomStart.lastDeltaX || 0;
        zoomStart.deltaY = zoomStart.lastDeltaY || 0;
        zoomStart.scale = zoomStart.lastScale || 1;

        if (zoomStart.scale > 2.5) {
          zoomStart.scale = 2.5;
          setImageTransform(zoomStart.deltaX, zoomStart.deltaY, zoomStart.scale);
        }
      }

      function changeZoom(event) {
        if (event.touches.length === 2 && zooming) {
          event.preventDefault();

          // Safari provides event.scale as two fingers move on the screen
          // For other browsers just calculate the scale manually
          let scale;
          if (event.scale) {
            scale = event.scale;
          } else {
            const deltaDistance = distance(event);
            scale = deltaDistance / zoomStart.distance;
          }
          zoomImageElementScale = Math.min(Math.max(scale * zoomStart.scale, 1), 4);

          setImageTransform(false, false, zoomImageElementScale);
        } else {
          if (document.querySelector('body').classList.contains("zoom-mode")) {
            if (zoomStart.scale != 1) {
              event.preventDefault();
              const moveX = event.touches[0].pageX - zoomStart.startX;
              const moveY = event.touches[0].pageY - zoomStart.startY;
              const deltaX = zoomStart.deltaX + moveX;
              const deltaY = zoomStart.deltaY + moveY;

              setImageTransform(deltaX, deltaY, false);
            }
          }
        }
      }

      function checkBackLink() {
        if (!document.referrer.includes('https://cultgeia.com')) {
          headerBackLink.setAttribute('href', 'https://cultgeia.com/collections/all');
        }
      }

      function setSizes() {
        // Page didn't change width
        if (pageWidth === window.innerWidth) return;
        pageWidth = window.innerWidth;

        if (pageWidth >= 1024) {
          stopAnimate();
          list.style.removeProperty('transform');
          main.style.removeProperty('margin-top');
          gallery.style.removeProperty('height');
          gallery.classList.remove('hidden');
          return;
        }

        var pageHeight = window.innerHeight,
          titleHeight = title.offsetHeight,
          btnsHeight = btns.offsetHeight,
          btnsMargin = 16;
        calculatedGalleryHeight = pageHeight - titleHeight - btnsHeight - btnsMargin;

        main.style.marginTop = calculatedGalleryHeight + 'px';
        gallery.style.height = calculatedGalleryHeight + 'px';
        if (!initialised) setTimeout(enforceScroll, 100);
      }

      function enforceScroll() {
        initialised = true;
        window.scrollTo(0, 0);
      }

      function startScrolling(startY) {
        if (zooming || zoomStart.scale != 1) {
          stopAnimate();
          return;
        }
        if (anchorScrollGsap) anchorScrollGsap.kill();
        scrolling = true;
        itemHeight = items[0].offsetHeight;
        scroll.max = itemHeight * (itemsL - 1);
        scroll.prev = scroll.current;
        scroll.start = startY;
        animating = true;
        animFrame = window.requestAnimationFrame(animate);
      }

      function stopScrolling() {
        if (pageWidth < 1024) {
          scrolling = false;
          scroll.current = scroll.new;
          var newCurrent = scroll.current / itemHeight,
            difference = newCurrent - current;

          if (difference > -0.1 && difference < 0.1) {
            anchorScroll();
          } else {
            if (difference > 0 && toNext && current < itemsL - 1) {
              current = Math.ceil(newCurrent);
            } else if (difference > 0 && toNext && current >= itemsL - 1) {
              // Next triggered on last item so close gallery
              hideGallery();
            } else if (difference < 0 && !toNext && current > 0) {
              current = Math.floor(newCurrent);
            }

            anchorScroll();
          }
        }
      }

      function startPageTouch(e) {
        if (pageWidth >= 1024) return;
        touchScrollPos.prev = window.pageYOffset;
      }

      function stopPageTouch(e) {
        if (pageWidth >= 1024) return;
        var pageScroll = window.pageYOffset;

        if (galleryOpen) {
          if (pageScroll > 0 && pageScroll < scrollThreshold) {
            showGallery();
          } else if (pageScroll >= scrollThreshold && pageScroll < calculatedGalleryHeight) {
            hideGallery();
          }
        } else {
          if (touchScrollPos.prev > pageScroll && pageScroll < 1) {
            showGallery();
          }
        }

        touchScrollPos.prev = pageScroll;
      }

      function showGallery(e) {
        if (e) e.preventDefault();

        if (pageWidth < 1024) {
          header.classList.remove('scrollable');
          gallery.classList.remove('hidden');
          main.classList.remove('open');
          gsap.to(gallery, {
            y: 0,
            duration: 0.5
          });
          gsap.to(main, {
            marginTop: calculatedGalleryHeight,
            duration: 0.5,
            ease: 'power2.out'
          });
          gsap.to(window, {
            scrollTo: {
              y: 0
            },
            duration: 0.5,
            ease: 'power2.out'
          });
          galleryOpen = true;
        }
      }

      function hideGallery() {
        if (pageWidth < 1024 && !document.querySelector('body').classList.contains("zoom-mode")) {
          header.classList.add('scrollable');
          gallery.classList.add('hidden');
          main.classList.add('open');
          gsap.to(main, {
            marginTop: 0,
            duration: 0.5,
            ease: 'power2.out'
          });
          gsap.to(window, {
            scrollTo: {
              y: 0
            },
            duration: 0.5,
            ease: 'power2.out',
            onComplete: stopAnimate
          });
          galleryOpen = false;
        }
      }

      window.addEventListener('scroll', function() {
        if (pageWidth >= 1024) return;
        if (!mainInner) return;
        if (!galleryOpen || mainInner.getBoundingClientRect().top <= 0) {
          gallery.classList.add('hidden');
          gallery.style.visibility = 'hidden';
        } else {
          gallery.style.visibility = '';
          gallery.classList.remove('hidden');
        }
      }, false);

      function mobileEvent(e) {
        if (zooming || zoomStart.scale != 1) {
          stopAnimate();
          return;
        }
        if (pageWidth < 1024) {
          if (!scrolling) startScrolling(e.touches[0].clientY);
          scroll.new = scroll.prev + (scroll.start - e.touches[0].clientY);
          toNext = scroll.new > scroll.current;
        }
      }

      function checkAddBtn(e) {
        // If the user clicked the disabled button
        // and the gallery is open, hide it
        if (e.target === btns && addBtn.getAttribute('disabled') && galleryOpen && pageWidth < 1024)
          hideGallery();
      }

      function anchorScroll() {
        dots.setAttribute('data-current', current);
        anchorScrollGsap = gsap.to(scroll, {
          new: current * itemHeight,
          duration: 0.5
        });
      }

      function animate() {
        // Interpolate value
        scroll.current += (scroll.new - scroll.current) * 0.3; // Stop infinite interpolation

        scroll.current = scroll.current > 1 ? scroll.current : 0; // Enforce end break

        scroll.current = scroll.current < scroll.max - 1 ? scroll.current : scroll.max; // Apply transform

        list.style.transform = 'translateY(-' + scroll.current + 'px)';
        if (animating) animFrame = window.requestAnimationFrame(animate);
      }

      function stopAnimate() {
        animating = false;
        if (animFrame) window.cancelAnimationFrame(animFrame);
      }
    });
  }

  initGallery();
})();

/**
 * Collection Page Mobile Carousel.
 *
 */

 function checkScrollDirection(lastScrollTop) {
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st < lastScrollTop) {
    if (st < 1 && !galleryOpen) {
      showGallery();
    }
  }
  lastScrollTop = st <= 0 ? 0 : st;
}

function collectionPageMobileCarousel() {
  gsap.registerPlugin(ScrollToPlugin);

  function initGallery(galleries) {
    galleries.forEach(function (galleryMod) {
      'use strict';

      // Elements
      var gallery = galleryMod,
        touchGallery = gallery.querySelector('ul.gallery'),
        items = gallery.querySelectorAll('ul.gallery li'),
        itemsL = items.length,
        dots = gallery.querySelector('ul.dots');
      gallery.classList.add('initialized');

      var scrolling = false,
        touching = false,
        current = 0,
        scroll = {
          prev: 0,
          current: 0,
          start: 0,
          new: 0,
          max: 0
        },
        touchScrollPos = {
          prev: 0,
          new: 0
        },
        toNext = true,
        itemWidth = items[0].offsetWidth,
        animFrame = null,
        animating = false,
        anchorScrollGsap = null,
        pageWidth = 0;
      scroll.max = itemWidth * (itemsL - 1); // Reset scroll

      let lastScrollTop = 0;

      touchGallery.addEventListener('touchmove', mobileEvent);
      touchGallery.addEventListener('touchend', stopScrolling);
      touchGallery.addEventListener('touchstart', startPageTouch);
      window.addEventListener('scroll', checkScrollDirection(lastScrollTop), false);


      function startScrolling(startX) {
        if (anchorScrollGsap) anchorScrollGsap.kill();
        stopAnimate();
        scrolling = true;
        itemWidth = items[0].getBoundingClientRect ? items[0].getBoundingClientRect().width : items[0].offsetWidth;
        scroll.max = itemWidth * (itemsL - 1);
        scroll.prev = scroll.current;
        scroll.start = startX;
        animating = true;
        touching = true;
        window.collectionAnimFrame = window.requestAnimationFrame(animate);
      }

      function stopScrolling() {
        if (pageWidth < 1024) {
          scrolling = false;
          scroll.current = scroll.new;
          var newCurrent = scroll.current / itemWidth,
            difference = newCurrent - current;

          if (difference > -0.1 && difference < 0.1) {
            anchorScroll();
          } else {
            if (difference > 0 && toNext && current < itemsL - 1) {
              current = Math.ceil(newCurrent);
            } else if (difference > 0 && toNext && current >= itemsL - 1) {
              // Next triggered on last item so close gallery
            } else if (difference < 0 && !toNext && current > 0) {
              current = Math.floor(newCurrent);
            }

            anchorScroll();
          }
        }
      }

      function startPageTouch(e) {
        if (pageWidth >= 1024) return;
        touching = true;
        touchScrollPos.prev = window.pageXOffset;
      }

      function stopPageTouch(e) {
        if (pageWidth >= 1024) return;
        touching = false;
      }

      function mobileEvent(e) {
        if (pageWidth < 1024) {
          if (!scrolling) startScrolling(e.touches[0].clientX);
          scroll.new = scroll.prev + (scroll.start - e.touches[0].clientX);
          toNext = scroll.new > scroll.current;
        }
      }

      function anchorScroll() {
        dots.setAttribute('data-current', current);
        anchorScrollGsap = gsap.to(scroll, {
          new: current * itemWidth,
          duration: 0.2
        });
      }

      function animate() {
        // Interpolate value
        scroll.current += (scroll.new - scroll.current) * 0.5; // Stop infinite interpolation
        scroll.current = scroll.current > 1 ? scroll.current : 0; // Enforce end break
        scroll.current = scroll.current < scroll.max - 1 ? scroll.current : scroll.max; // Apply transform

        touchGallery.style.transform = 'translateX(-' + scroll.current + 'px)';

        if (scroll.current == scroll.prevScrollValue && !touching) {
          if (anchorScrollGsap) anchorScrollGsap.kill();
          stopAnimate();

          if (scroll.current == scroll.max) {
            touchGallery.style.transform = null;
            scroll.current = 0;
            current = 0;
            dots.setAttribute('data-current', current);
          }
          return;
        }

        scroll.prevScrollValue = scroll.current;

        if (animating) window.collectionAnimFrame = window.requestAnimationFrame(animate);
      }

      function stopAnimate() {
        animating = false;
        if (window.collectionAnimFrame) window.cancelAnimationFrame(window.collectionAnimFrame);
      }
    });
  }

  const galleries = document.querySelectorAll('.product-grid__item .js-collection-carousel:not(.initialized), .template-search__grid-item .js-collection-carousel:not(.initialized)');
  if (galleries.length) {
    initGallery(galleries);
  }
};

collectionPageMobileCarousel();

window.rfd = window.rfd || {};
window.rfd.collectionPageMobileCarouselReinit = collectionPageMobileCarousel;

/**
 * Product selector button functions
 *
 */

(function modProdSelectorBtns() {
  function init() {
    $(document).on(
      'touchstart click',
      '.template-product .shopify-product-form .variant-wrapper--content input[type="radio"]',
      function handleClickTouchstart(e) {
        var radio = $('.variant-wrapper--content input[type="radio"]:checked');
        var value = $(radio).val();
        var parent = $('.pdp-main__variation--size .pdp-main__selected-variation');

        $(parent).text(value);
      }
    );
  }

  init();
})();

/**
 * Lazy product selectors (select size before clicking "add to cart")
 *
 */

(function modSelectorsLazy() {
  var selectors = {
    module: '[data-lazy-selectors]',
    option: '[data-lazy-selectors-option]',
    group: '[data-lazy-selectors-group]',
    optionPriceAttr: 'data-lazy-selectors-option-price',
    variantIdAttr: 'data-lazy-selectors-option',
    addBtn: 'button[data-quick-add-to-cart]',
    addBtnIdAttr: 'data-quick-add-to-cart',
    activeClass: 'is-active',
    addToCartText: '[data-ctrl-text]',
    fakeOption: '[data-fake-lazy-selectors-option]',
    fakeGroup: '[data-fake-lazy-selectors-group]',
    fakeVariantIdAttr: 'data-fake-lazy-selectors-option'
  };

  function toggleGroupOption(option) {
    var $option = $(option);
    var $group = $option.closest(selectors.group);
    var $groupOptions = $group.find(selectors.option);
    var $module = $option.closest(selectors.module);
    var $addBtn = $module.find(selectors.addBtn);
    var $groups = $module.find(selectors.group);
    var alteredMoneyFormat = window.theme.moneyFormat;
    var variantIds = '';
    var subtotal = 0;
    var $selectedVariantId = $option.attr(selectors.variantIdAttr);
    var $fakeGroup = $(selectors.fakeGroup);
    var $fakeGroupOptions = $fakeGroup.find(selectors.fakeOption);

    if ($option.hasClass(selectors.activeClass)) {
      $groupOptions.removeClass(selectors.activeClass);
      $('[' + selectors.fakeVariantIdAttr + '="' + $selectedVariantId + '"]').removeClass(
        selectors.activeClass
      );
    } else {
      $groupOptions.removeClass(selectors.activeClass);
      $option.addClass(selectors.activeClass);
      $('[' + selectors.fakeVariantIdAttr + '="' + $selectedVariantId + '"]')
        .addClass(selectors.activeClass)
        .parent()
        .siblings()
        .children()
        .removeClass(selectors.activeClass);
    }

    $groups.each(function eachGroup(index) {
      var $thisGroupOptions = $(this).find(selectors.option);
      var $active = $thisGroupOptions.filter('.' + selectors.activeClass);
      var price = $active.attr(selectors.optionPriceAttr);
      if ($active.length) {
        variantIds += index > 0 ? ',' : '';
        variantIds += $active.attr(selectors.variantIdAttr);
        if (price) {
          subtotal += parseInt(price, 10);
        }
      }
    });

    alteredMoneyFormat = alteredMoneyFormat.replace('amount_with_comma_separator', 'amount');
    alteredMoneyFormat = alteredMoneyFormat.replace('amount_with_apostrophe_separator', 'amount');

    $addBtn.attr(selectors.addBtnIdAttr, variantIds);

    if (!variantIds) {
      $addBtn.html(window.theme.strings.selectSizes);
    } else {
      $addBtn.html(
        window.theme.strings.addToCart +
        ' - Total: ' +
        slate.Currency.formatMoney(subtotal, alteredMoneyFormat)
      );
    }
  }

  function toggleSingleOption(option) {
    var $option = $(option);
    var variantId = $option.attr(selectors.variantIdAttr);
    var $module = $option.closest(selectors.module);
    var $addBtn = $module.find(selectors.addBtn);
    var $options = $module.find(selectors.option);

    if ($option.hasClass(selectors.activeClass)) {
      $option.removeClass(selectors.activeClass);
      $addBtn
        .attr(selectors.addBtnIdAttr, '')
        .prop('disabled', true)
        .children(selectors.addToCartText)
        .html(window.theme.strings.selectSize);
      return;
    }

    $options.removeClass(selectors.activeClass);
    $option.addClass(selectors.activeClass);
    $addBtn
      .attr(selectors.addBtnIdAttr, variantId)
      .prop('disabled', false)
      .children(selectors.addToCartText)
      .html(window.theme.strings.addToCart);

    // Add Pre-Order to ATC button and show dispatch date
    if ($option.data('pre-order') !== undefined) {
      $addBtn.children(selectors.addToCartText).html(window.theme.strings.preOrder);
    }
  }

  function toggleFakeGroupOption(option) {
    var $option = $(option);
    var $group = $option.closest(selectors.fakeGroup);
    var $groupOptions = $group.find(selectors.fakeOption);
    var $selectedVariantId = $option.attr(selectors.fakeVariantIdAttr);

    if ($option.hasClass(selectors.activeClass)) {
      $groupOptions.removeClass(selectors.activeClass);
    } else {
      $groupOptions.removeClass(selectors.activeClass);
      $option.addClass(selectors.activeClass);
    }
    $('[' + selectors.variantIdAttr + '="' + $selectedVariantId + '"]').click();
  }

  function handleOptionClick(e) {
    var $group = $(this).closest(selectors.group);

    e.preventDefault();

    if ($group.length) {
      toggleGroupOption(this);
    } else {
      toggleSingleOption(this);
    }
  }

  function handleFakeClick(e) {
    e.preventDefault();

    toggleFakeGroupOption(this);
  }

  function init() {
    $('body').on('click', selectors.option, handleOptionClick);
    $('body').on('click', selectors.fakeOption, handleFakeClick);
  }

  init();
})();

(function scrollFunction() {
  // Debounce
  function debounce(func) {
    var _arguments = arguments,
      _this = this;

    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var immediate = arguments.length > 2 ? arguments[2] : undefined;
    var timeout;
    return function () {
      var context = _this,
        args = _arguments;

      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // Init func
  function initScroll() {
    var cont = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var body = document.body,
      win = window;
    var els = cont.querySelectorAll('[data-view]'),
      lazyImages = cont.querySelectorAll('[data-lazy]');
    var isHeaderNotFixed = body.classList.contains('header-not-fixed');

    function scrollWatcher() {
      var defaultOffsetPercentage = 20;
      var offsets = [],
        points = [],
        lazyPoints = [],
        lazyImageSrcs = [];

      var scrollValue = 0,
        prevScrollValue = 0,
        scrolled = false,
        scrolledUp = false,
        scrollAnim = null,
        pageHeight = window.innerHeight;

      var initialGetVars = function initialGetVars() {
        scrollValue = win.pageYOffset;

        for (var x = 0; x < els.length; x++) {
          var customOffset =
            els[x].getAttribute('data-view-offset') !== null
              ? parseInt(els[x].getAttribute('data-view-offset'))
              : defaultOffsetPercentage;
          var customPercentage = customOffset / 100; // Convert to a decimal to use as percentage

          offsets.push(customPercentage);
          points.push(
            scrollValue + els[x].getBoundingClientRect().top + pageHeight * customPercentage
          );
        }

        for (var _x = 0; _x < lazyImages.length; _x++) {
          lazyPoints.push(
            Math.round(scrollValue) + lazyImages[_x].getBoundingClientRect().top - pageHeight
          );
          lazyImageSrcs.push(lazyImages[_x].getAttribute('data-lazy'));
        }
      };

      var getVars = function getVars() {
        pageHeight = window.innerHeight;
        points = [];
        lazyPoints = [];
        scrollValue = win.pageYOffset;

        for (var x = 0; x < els.length; x++) {
          points.push(scrollValue + els[x].getBoundingClientRect().top + pageHeight * offsets[x]);
        }

        for (var _x2 = 0; _x2 < lazyImages.length; _x2++) {
          lazyPoints.push(
            Math.round(scrollValue) + lazyImages[_x2].getBoundingClientRect().top - pageHeight
          );
        }
      };

      initialGetVars();
      window.addEventListener('resize', debounce(getVars, 500));
      var tracker = [];
      var lazyTracker = [];

      for (var x = 0; x < els.length; x++) {
        tracker.push(0);
      }

      for (var _x3 = 0; _x3 < lazyImages.length; _x3++) {
        lazyTracker.push(0);
      }

      var maxFps = 15;
      var now, delta;
      var then = Date.now(),
        interval = 1000 / maxFps;

      var watchScroll = function watchScroll() {
        now = Date.now();
        delta = now - then;

        if (delta > interval) {
          scrollValue = win.pageYOffset;
          var scroll = scrollValue + pageHeight;
          var scrollLazy = scrollValue;

          for (var _x4 = 0; _x4 < tracker.length; _x4++) {
            if (tracker[_x4] !== 1 && scroll >= points[_x4]) {
              tracker[_x4] = 1;

              els[_x4].setAttribute('data-view', true);
            }
          }

          for (var _x5 = 0; _x5 < lazyTracker.length; _x5++) {
            if (lazyTracker[_x5] !== 1 && scrollLazy >= lazyPoints[_x5]) {
              lazyTracker[_x5] = 1;

              lazyImages[_x5].setAttribute('src', lazyImageSrcs[_x5]);

              lazyImages[_x5].removeAttribute('data-lazy');
            }
          }

          if (!isHeaderNotFixed) {
            if (scrolled && scrollValue < 10) {
              scrolled = false;
              body.classList.remove('scrolled');
            } else if (!scrolled && scrollValue >= 10) {
              scrolled = true;
              body.classList.add('scrolled');
            }

            if (scrollValue > prevScrollValue) {
              prevScrollValue = scrollValue;

              if (scrolledUp) {
                scrolledUp = false;
                body.classList.remove('scrolled-up');
              }
            } else if (!scrolledUp && scrollValue < prevScrollValue - 20) {
              scrolledUp = true;
              body.classList.add('scrolled-up');
            } else if (scrolledUp) {
              prevScrollValue = scrollValue;
            }
          }

          then = now - (delta % interval);
        }

        scrollAnim = requestAnimationFrame(watchScroll);
      };

      scrollAnim = requestAnimationFrame(watchScroll);
    }

    return scrollWatcher();
  }

  // Reset
  function resetScrollElements() {
    var els = document.querySelectorAll('[data-view]');
    var length = els.length;

    for (var i = 0; i < length; i++) {
      els[i].setAttribute('data-view', false);
    }
  } // left: 37, up: 38, right: 39, down: 40

  var keys = {
    37: 1,
    38: 1,
    39: 1,
    40: 1
  };

  // Disable
  function disableScroll() {
    if (window.addEventListener) window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard

    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE

    window.ontouchmove = preventDefault; // mobile

    document.onkeydown = preventDefaultForScrollKeys;
  }

  function enableScroll() {
    if (window.removeEventListener)
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
  }

  function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault) e.preventDefault();
    e.returnValue = false;
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  initScroll();
  resetScrollElements();
  disableScroll();
  enableScroll();
})();

('use strict');

(function sizeGuideFunction() {
  function sizeGuideInit() {
    var sizeGuideBlocks = document.querySelectorAll('.js-block[data-block="size-guide"]');
    sizeGuideBlocks.forEach(function (sizeMod) {
      // Elements
      var sizeGuide = sizeMod,
        trigger = sizeGuide.querySelector('.js-size-guide-trigger'),
        categories = sizeGuide.querySelectorAll('.pdp-main__size-guide-category button'),
        guideWrapper = sizeGuide.querySelector('.pdp-main__size-guide-chart-wrap'),
        wraps = sizeGuide.querySelectorAll('.pdp-main__size-guide-table-wrap'),
        inners = sizeGuide.querySelectorAll('.pdp-main__size-guide-table-inner'),
        tables = sizeGuide.querySelectorAll('.pdp-main__size-guide-table-scroll'),
        tablesL = tables.length,
        scrollbars = sizeGuide.querySelectorAll('.pdp-main__size-guide-scrollbar span'),
        closeBtn = sizeGuide.querySelector('.pdp-main__size-guide-close'),
        maxCategories = categories.length; // Events

      var clickEvents = [],
        scrollEvents = [];
      var activeGuide = 0; // Set inital max height for transition between guides
      // Set inital max height for transition between guides

      inners[activeGuide].style.height = tables[activeGuide].offsetHeight - 40 + 'px';
      guideWrapper.style.height = wraps[activeGuide].offsetHeight + 'px';

      for (var x = 0; x < maxCategories; x++) {
        clickEvents.push(changeCategory.bind(this, x));
      } // Add Event Listeners

      for (var x = 0; x < maxCategories; x++) {
        scrollEvents.push(updateScroll.bind(this, x));
      }

      for (var _x = 0; _x < maxCategories; _x++) {
        categories[_x].addEventListener('click', clickEvents[_x]);
      }

      for (var x = 0; x < tablesL; x++) {
        tables[x].addEventListener('scroll', scrollEvents[x]);
      }

      for (var x = 0; x < tablesL; x++) {
        wraps[x].addEventListener('click', scrollOnClick);
      }

      trigger.addEventListener('click', openSizeGuide);
      closeBtn.addEventListener('click', closeSizeGuide);
      checkScrollableTables();
      window.addEventListener('resize', checkScrollableTables);

      function changeCategory(x) {
        if (x === activeGuide) return;
        sizeGuide.setAttribute('data-active-guide', x);
        activeGuide = x;
        inners[activeGuide].style.height = tables[activeGuide].offsetHeight - 40 + 'px';
        guideWrapper.style.height = wraps[activeGuide].offsetHeight + 'px';
      }

      function checkScrollableTables() {
        for (var _x2 = 0; _x2 < tablesL; _x2++) {
          wraps[_x2].setAttribute(
            'data-no-scroll',
            tables[_x2].scrollWidth <= tables[_x2].clientWidth
          );
        }
      }

      function updateScroll(x) {
        var maxScroll = tables[activeGuide].scrollWidth - tables[activeGuide].clientWidth,
          currentScroll = tables[activeGuide].scrollLeft,
          scrollDecimal = currentScroll / maxScroll;
        scrollbars[activeGuide].style.transform = 'scaleX(' + scrollDecimal + ')';
      }

      function openSizeGuide(e) {
        if (e) e.preventDefault();
        activeGuide = 0;
        setTimeout(function () {
          categories[0].focus();
        }, 200);
        sizeGuide.setAttribute('data-active-guide', activeGuide);
        sizeGuide.setAttribute('data-size-guide', 'true');
        inners[activeGuide].style.height = tables[activeGuide].offsetHeight - 40 + 'px';
        guideWrapper.style.height = wraps[activeGuide].offsetHeight + 'px';
      }

      function closeSizeGuide(e) {
        if (e) e.preventDefault();
        activeGuide = 0;
        setTimeout(function () {
          trigger.focus();
        }, 200);
        sizeGuide.setAttribute('data-active-guide', 0);
        sizeGuide.setAttribute('data-size-guide', 'false');
        guideWrapper.style.height = '0px';
      }

      function scrollOnClick(e) {
        const scrollElement = e.currentTarget.querySelector('.pdp-main__size-guide-table-scroll');
        const ksScrollElement = e.currentTarget.querySelector('.ks-table-wrapper');
        var maxScroll = scrollElement.clientWidth;
        var scrollPercentage = maxScroll / 2;
        var ksMaxScroll = scrollElement.clientWidth;
        var ksScrollPercentage = ksMaxScroll / 2;

        if (scrollElement) {
          scrollElement.scrollBy({
            top: 0,
            left: +scrollPercentage,
            behavior: 'smooth'
          })
        }

        if (ksScrollElement) {
          ksScrollElement.scrollBy({
            top: 0,
            left: +ksScrollPercentage,
            behavior: 'smooth'
          })
        }
      }
    });
  }

  sizeGuideInit();
})();

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts && parts.length === 2) {
    return parts.pop().split(';').shift();
  } else {
    return ''
  }
};


const getPersonalizationParams = () => {
  const shopper = getCookie('shopperId')
  const cart = getCookie('shopify_cart_products')
  const lastViewed = getCookie('shopify_last_viewed')
  const params = {
    cart: cart,
    lastViewed: lastViewed
  }
  if (shopper) {
    params.shopper = shopper
  }
  return params

};


('use strict');
/**
 * Upsell function
 * @exports window.rfd.upsellToggleReinit()
 */

(function upsellFunction() {
  function upsellInit(fetchWearWith = true) {
    var upsells = document.querySelectorAll('.js-block[data-block="upsell"]');

    upsells.forEach(function (upsellMod) {
      var upsell = upsellMod,
        triggers = upsell.querySelectorAll('.js-upsell-trigger'),
        triggersL = triggers.length; // Events

      var setActiveEvents = []; // Vars

      var current = 0; // Add Events

      for (var x = 0; x < triggersL; x++) {
        setActiveEvents.push(setActiveEvent.bind(this, x));
      } // Add Event Listeners

      for (var _x = 0; _x < triggersL; _x++) {
        triggers[_x].addEventListener('click', setActiveEvents[_x]);
      }

      const wearWithContainer = document.querySelector('.js-wear-with-container');

      if (wearWithContainer && fetchWearWith) {

        const personalizedParams = getPersonalizationParams();

        const baseParams = new URLSearchParams({
          siteId: 'zcq50k',
          ...personalizedParams,
        }).toString();

        const wearWithContainerProductId = wearWithContainer.dataset.productId
        const existingProductsList = wearWithContainer.getAttribute('data-existing-products')
        fetch(`https://zcq50k.a.searchspring.io/boost/zcq50k/recommend?${baseParams}&tags=cross-sell&products=${wearWithContainerProductId}&blockedItems=${existingProductsList}`)
          .then(response => response.json())
          .then(data => {
            const results = data[0].results

            if(results.length === 0) {
              return
            }

            const recommendationUrls = results.map(result => result.mappings.core.url)

            const TEMPLATE_KEY = 'ajax-product-upsell-card'
            Promise.all(
              recommendationUrls
              .splice(0, 10)
              .map(url => {
                return fetch(url + `?sections=${TEMPLATE_KEY}`)
                  .then(response => response.json())
                  .then(response => response[TEMPLATE_KEY])
                  .then(htmlAsString => {
                    const parsedState = new DOMParser().parseFromString(
                      htmlAsString,
                      'text/html'
                    )
                    const sectionContents = parsedState.querySelector(
                      `.shopify-section`
                    ).innerHTML

                    return sectionContents
                  })
              })
            )
            .then(markups => markups.filter(Boolean))
            .then(markups => {
              wearWithContainer.innerHTML = wearWithContainer.innerHTML + markups.join('')

              setTimeout(() => {
                if (window.rfd && window.rfd.dragCarouselReinit) {
                  window.rfd.dragCarouselReinit();
                }
              }, 500)
            })
          })
      }

      function setActiveEvent(x, e) {
        if (e) e.preventDefault();

        if (x === current) return;
        triggers[current].classList.remove('active');
        triggers[x].classList.add('active');
        upsell.setAttribute('data-upsell-carousel', x + 1);
        current = x;
      }
    });
  }

  function upsellToggleReinit(fetchWearWith = false) {
    upsellInit(fetchWearWith);
  }

  upsellInit(false);

  window.rfd = window.rfd || {};
  window.rfd.upsellToggleReinit = upsellToggleReinit;
})();

var loadProductRecommendationsIntoSection = function () {
  console.debug('loadProductRecommendationsIntoSection');

  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector('.product-recommendations');
  if (productRecommendationsSection === null) {
    return;
  }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl =
    '/recommendations/products?section_id=product-recommendations&limit=' +
    limit +
    '&product_id=' +
    productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open('GET', requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement('div');
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(
        '.product-recommendations'
      ).innerHTML;
    }

    if (window.rfd && window.rfd.upsellToggleReinit) {
      window.rfd.upsellToggleReinit(true);
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener('shopify:section:load', function (event) {
  if (event.detail.sectionId === 'product-recommendations') {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

const loadShopifyCartProductRecommendations = function () {
  console.log('RAAN - loadCartProductRecommendations');
  const recslimit = 10;
  const sectionId = 'product-recommendations-cart';
  const sectionSelector = '.minicart-upsells';
  console.debug('loadCartProductRecommendations');

  const sectionEl = document.querySelector(sectionSelector);
  if (!sectionEl) return;

  const mostRecentlyAddedProductId = document.querySelector('[data-cart-item]')?.dataset.productId;
  if (!mostRecentlyAddedProductId) return;

  const fetchUrl =
    window.Shopify.routes.root +
    `recommendations/products?section_id=${sectionId}&limit=${recslimit}&product_id=${mostRecentlyAddedProductId}`;
  console.debug('loadCartProductRecommendations loading', { sectionEl, fetchUrl });
  fetch(fetchUrl)
    .then((response) => response.text())
    .then((text) => {
      console.debug('loadCartProductRecommendations building new html from response');

      const newContainerEl = document.createElement('div');
      newContainerEl.innerHTML = text;
      const newSectionEl = newContainerEl.querySelector(sectionSelector);

      if (newSectionEl && newSectionEl.innerHTML.trim().length) {
        sectionEl.innerHTML = newSectionEl.innerHTML;
      }

      console.debug('loadCartProductRecommendations re-initializing carousels');
      if (window.rfd && window.rfd.dragCarouselReinit) {
        window.rfd.dragCarouselReinit();
      }

      // Don't believe this is used here
      // if (window.rfd && window.rfd.upsellToggleReinit) {
      //   window.rfd.upsellToggleReinit();
      //}
    })
    .catch((e) => {
      console.error(e);
    });
};

const loadSearchSpringCartProductRecommendations = function () {
  const sectionSelector = '.js-minicart-upsells-content';
  console.debug('loadSearchSpringCartProductRecommendations');

  const sectionEl = document.querySelector(sectionSelector);
  if (!sectionEl) return;

  const mostRecentlyAddedProductId = document.querySelector('[data-cart-item]')?.dataset.productId;
  if (!mostRecentlyAddedProductId) return;

  const miniCartSearchspringSettings = document.querySelector('.js-mini-cart-searchspring-settings')

  if(!miniCartSearchspringSettings) {
    return
  }

  const rawMiniCartSearchspringSettings = miniCartSearchspringSettings.innerHTML
  const parsedMiniCartSearchspringSettings = JSON.parse(rawMiniCartSearchspringSettings)

  const personalizedParams = getPersonalizationParams();

  const baseParams = new URLSearchParams({
    siteId: 'zcq50k',
    ...personalizedParams,
  }).toString();

  const searchSpringEndpoint = new URL(`https://${parsedMiniCartSearchspringSettings.searchspring_id}.a.searchspring.io/boost/${parsedMiniCartSearchspringSettings.searchspring_id}/recommend?${baseParams}`);


  searchSpringEndpoint.searchParams.append('tags', parsedMiniCartSearchspringSettings.searchspring_tag);
  searchSpringEndpoint.searchParams.append('limit', '10');

  fetch(searchSpringEndpoint.toString())
    .then(response => response.json())
    .then(data => {
      const results = data[0].results

      if(results.length === 0) {
        return
      }

      const recommendationUrls = results.map(result => result.mappings.core.url)

      const TEMPLATE_KEY = 'ajax-mini-cart-upsell-product'
      Promise.all(
        recommendationUrls
        .splice(0, 10)
        .map(url => {
          return fetch(url + `?sections=${TEMPLATE_KEY}`)
            .then(response => response.json())
            .then(response => response[TEMPLATE_KEY])
            .then(htmlAsString => {
              const parsedState = new DOMParser().parseFromString(
                htmlAsString,
                'text/html'
              )
              const sectionContents = parsedState.querySelector(
                `.shopify-section`
              ).innerHTML

              return sectionContents
            })
        })
      )
      .then(markups => markups.filter(Boolean))
      .then(markups => {
        const combinedMarkup = markups.join('')
        sectionEl.innerHTML = combinedMarkup;

        console.debug('loadCartProductRecommendations re-initializing carousels');
        if (window.rfd && window.rfd.dragCarouselReinit) {
          window.rfd.dragCarouselReinit();
        }
      })
    })
};

document.addEventListener('shopify:section:load', function (event) {
  if (event.detail.sectionId === 'cart') {
    //loadShopifyCartProductRecommendations();
    loadSearchSpringCartProductRecommendations();
  }
});

//loadShopifyCartProductRecommendations();
loadSearchSpringCartProductRecommendations();

('use strict');

/**
 * Module for Quick add
 *
 * @exports window.rfd.reinitQuickAdd()
 */

(function quickAddFunction() {
  function quickAddInit() {
    var quickAddBlocks = document.querySelectorAll('.js-block[data-block="quick-add"]');
    var quickAddBlocksContainer = document.querySelectorAll('.products')[0];

    quickAddBlocks.forEach(function (quickAddMod) {
      // Elements
      var quickAddBlock = quickAddMod;
      var addBtn = quickAddBlock.querySelector('.products__listing-add-btn');
      var quickAddOption = quickAddBlock.querySelector(
        '.products__listing-quick-add-item:first-child a'
      );
      var productDetails = quickAddBlock.querySelector('.products__listing-details a');
      var saveBtn = quickAddBlock.querySelector('.products__listing-save-btn');
      var closeBtn = quickAddBlock.querySelector('.products__listing-quick-add-title button');
      var open = 'false'; // Add event listeners

      if (typeof addBtn != 'undefined' && addBtn != null) {
        addBtn.addEventListener('click', openQuickOptions);
      }

      if (typeof quickAddBlock != 'undefined' && quickAddBlock != null) {
        quickAddBlock.addEventListener('mouseleave', resetQuickAdd); // unctions
      }

      if (typeof productDetails != 'undefined' && productDetails != null) {
        productDetails.addEventListener('focusin', resetQuickAdd);
      }

      if (typeof saveBtn != 'undefined' && saveBtn != null) {
        saveBtn.addEventListener('focusin', resetQuickAdd);
      }

      if (typeof closeBtn != 'undefined' && closeBtn != null) {
        closeBtn.addEventListener('click', resetQuickAdd);
      }

      function openQuickOptions(e) {
        e.preventDefault();

        if (open === 'false') {
          open = 'true';
          quickAddBlock.setAttribute('data-quick-add', open);
          quickAddBlocksContainer.setAttribute('data-quick-add-list', open);
          quickAddOption.focus();
        }
      }

      function resetQuickAdd() {
        open = 'false';
        quickAddBlock.setAttribute('data-quick-add', open);
        quickAddBlocksContainer.setAttribute('data-quick-add-list', open);
        closeSelectSizeModal();
      }
    });
  }

  function reinitQuickAdd() {
    quickAddInit();
  }

  quickAddInit();

  window.rfd = window.rfd || {};
  window.rfd.reinitQuickAdd = reinitQuickAdd;
})();

('use strict');

/**
 * Module for Cart upsells
 *
 * @exports window.rfd.cartupsellFunction()
 */

(function cartupsellFunction() {
  function cartupsellInit() {
    var cartUpsells = document.querySelectorAll('.js-block[data-block="cart-upsell"]');

    cartUpsells.forEach(function (upsellMod) {
      if (typeof cartUpsells != 'undefined' && cartUpsells != null) {
        upsellMod.addEventListener('click', function (event) {
          upsellMod.classList.add('active');
          Shopify.Cart.GiftWrap.set();
        });
      }
    });
  }

  cartupsellInit();

  window.rfd = window.rfd || {};
  window.rfd.cartupsellFunction = cartupsellFunction;
})();

('use strict');
/**
 * Drag carousel
 * @exports window.rfd.dragCarouselReinit()
 * @exports window.rfd.dragCarouselInit()
 * @import gsap from 'gsap';
 */

(function dragCarousel() {
  function dragCarouselInitSingle(dragMod) {
    'use strict';

    var carousel = dragMod,
      inner = carousel.querySelector('.carousel__inner'),
      carouselRows = parseInt(carousel.getAttribute('data-carousel-rows'), 10),
      edgeResistance = parseInt(carousel.getAttribute('data-edge-resistance'), 10),
      list = inner.querySelector('.carousel__list'),
      dragIcon = carousel.querySelector('.carousel-drag'),
      prevButton = carousel.querySelector('.carousel-arrows__arrow--prev'),
      nextButton = carousel.querySelector('.carousel-arrows__arrow--next'),
      progressbar = carousel.querySelector('.carousel-progress__bar'),
      arrows = carousel.querySelector('.carousel-arrows'),
      snap = carousel.getAttribute('data-snap') === 'true';

    var draggable = null,
      listWidth = 0,
      maxX = 0,
      current = 0,
      start = true,
      end = false,
      snapPoints = [],
      items = list.querySelectorAll(':scope > li'),
      itemsL = items.length,
      images = list.querySelectorAll('.pdp-upsell__listing-image img'),
      imagesL = images.length;

    var dragIconFollowing = false,
      dragIconVisible = false,
      dragIconAnimFrame = null,
      position = {
        current: {
          x: window.innerWidth * 0.7,
          y: 140,
          top: 0
        },
        next: {
          x: 0,
          y: 0,
          top: 0
        }
      };
    updateAttributes();
    setTimeout(setWidth, 1000);
    window.addEventListener('resize', debounce(setWidth, 500)); // Observer to account for lazy loaded/ajaxed items

    var observer = new MutationObserver(setWidth);
    observer.observe(list, {
      attributes: false,
      childList: true,
      subtree: false
    });

    for (var x = 0; x < imagesL; x++) {
      observer.observe(images[x], {
        attributes: true,
        childList: false,
        subtree: false
      });
    }

    function setWidth() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      // Kill the carousel if it exists
      if (draggable) {
        if (dragIcon) {
          if (dragIconAnimFrame) window.cancelAnimationFrame(dragIconAnimFrame);
          list.removeEventListener('mousemove', setDragPos);
          list.removeEventListener('mouseleave', hideDrag);
          if (prevButton) prevButton.removeEventListener('click', movePrevious);
          if (nextButton) nextButton.removeEventListener('click', moveNext);
        }

        draggable[0].kill();
        draggable = null;
      }

      if (carousel.offsetParent === null) {
        return;
      }

      if (mutations) {
        if (mutations[0]) {
          if (mutations[0].type === 'childList') {
            // Reset these as changes have been made to the DOM
            items = list.querySelectorAll('li');
            itemsL = items.length;
          } else if (mutations[0].type === 'attributes') {
            // An image attribute changed (e.g. Lazyload)
          }
        }
      }

      listWidth = 0;
      snapPoints = [];

      if (snap) {
        snapPoints.push(0);
      }

      for (var _x = 0; _x < itemsL; _x++) {
        var _style = window.getComputedStyle
          ? getComputedStyle(items[_x], null)
          : items[_x].currentStyle,
          itemWidth =
            items[_x].offsetWidth + parseInt(_style.marginLeft) + parseInt(_style.marginRight);

        if (snap) {
          snapPoints.push((listWidth + itemWidth) * -1);
        }

        if (window.innerWidth < 768) {
          // we are forcing a 3x1 grid when the list has 4 or less items and more than 1 row was set.
          if ( itemsL < 3){
            carouselRows = 1
          }
          if ( itemsL > 2 && itemsL < 5 && carouselRows > 1) {
            listWidth = itemWidth * 3
          }
          else if (_x < itemsL / (carouselRows || 1)) {
            listWidth += itemWidth;
          }
        } else {
          listWidth += itemWidth;
        }
      }

      if (window.innerWidth > listWidth) {
        //console.log("ESTO:",arrows);
        if (arrows != null) {
          arrows.classList.add('hidden');
        }
      } else {
        //console.log("ESTO:",arrows);
        if (arrows != null) {
          arrows.classList.remove('hidden');
        }
      }

      var style = window.getComputedStyle ? getComputedStyle(inner, null) : inner.currentStyle;
      listWidth += parseInt(style.paddingLeft) + parseInt(style.paddingRight);
      list.style.width = listWidth + 'px';
      //console.log(list.style.width);
      createDraggable();
    }

    function createDraggable() {
      maxX = inner.offsetWidth - listWidth; // Doesn't need carousel

      if (maxX > 0) {
        // Set init to false to hide progress bar
        carousel.setAttribute('data-init', false);
        return;
      }

      if (dragIcon) {
        list.addEventListener('mousemove', setDragPos);
        list.addEventListener('mouseleave', hideDrag);
      }

      if (prevButton) prevButton.addEventListener('click', movePrevious);
      if (nextButton) nextButton.addEventListener('click', moveNext); // Set init to true to show progress bar

      carousel.setAttribute('data-init', true);

      if (snap) {
        snapPoints.push(maxX);
        snapPoints.sort(function (a, b) {
          return b - a;
        });
      }

      draggable = Draggable.create(list, {
        type: 'x',
        edgeResistance: (edgeResistance || 0.8),
        bounds: {
          minX: 0,
          maxX: maxX
        },
        inertia: true,
        snap: snap ? snapPoints : false,
        onDrag: drag,
        onDragEnd: dragEnd
      });
    }

    function drag() {
      if (dragIconFollowing) stopDrag();
      if (progressbar)
        gsap.to(progressbar, {
          scaleX: this.x / maxX,
          duration: 0.6
        });
    }

    function dragEnd() {
      if (progressbar)
        gsap.to(progressbar, {
          scaleX: this.endX / maxX,
          duration: 0.6
        });
      if (snap) current = closestIndex(snapPoints, this.endX);
      start = false;
      end = false;

      if (this.endX === 0 || this.endX === -0) {
        start = true;
      } else if (this.endX / maxX === 1) {
        end = true;
      }

      updateAttributes();
    }

    function showDrag() {
      dragIconVisible = true;
      dragIcon.classList.add('visible');
      if (!dragIconAnimFrame) dragIconAnimFrame = window.requestAnimationFrame(updateDragPos);
    }

    function hideDrag() {
      dragIconVisible = false;
      dragIcon.classList.remove('visible');
      if (dragIconAnimFrame) window.cancelAnimationFrame(dragIconAnimFrame);
      dragIconAnimFrame = null;
    }

    function startDrag() {
      dragIconFollowing = true;
      dragIconVisible = true;
      dragIconAnimFrame = window.requestAnimationFrame(updateDragPos);
      dragIcon.classList.add('visible');
    }

    function stopDrag() {
      dragIconFollowing = false;
      list.removeEventListener('mousemove', setDragPos);
      list.removeEventListener('mouseleave', hideDrag);
      if (dragIconAnimFrame) window.cancelAnimationFrame(dragIconAnimFrame);
      dragIconAnimFrame = null;
      dragIcon.classList.remove('visible');
    }

    function setDragPos(e) {
      if (!dragIconFollowing) startDrag();
      if (!dragIconVisible) showDrag();
      var mPos = {
        x: e.clientX,
        y: e.clientY
      };
      position.next = mPos;
    }

    function updateDragPos() {
      var rect = carousel.getBoundingClientRect();
      position.next.top = rect.top;
      position.current.x += (position.next.x - rect.left - position.current.x) * 0.15;
      position.current.y += (position.next.y - position.current.y) * 0.15;
      position.current.top += (position.next.top - position.current.top) * 0.15;
      dragIcon.style.transform =
        'translateX(' +
        position.current.x +
        'px) translateY(' +
        (position.current.y - position.current.top) +
        'px)';
      dragIconAnimFrame = window.requestAnimationFrame(updateDragPos);
    }

    function movePrevious() {
      start = false;
      end = false;

      if (current > 0) {
        current--;
        gsap.to(list, {
          x: snapPoints[current],
          duration: 0.6
        });
        if (progressbar)
          gsap.to(progressbar, {
            scaleX: snapPoints[current] / maxX,
            duration: 0.6
          });

        if (current === 0) {
          start = true;
        }
      }

      updateAttributes();
    }

    function moveNext() {
      start = false;
      end = false;

      if (snapPoints[current + 1] > maxX) {
        current++;
        gsap.to(list, {
          x: snapPoints[current],
          duration: 0.6
        });
        if (progressbar)
          gsap.to(progressbar, {
            scaleX: snapPoints[current] / maxX,
            duration: 0.6
          });
      } else if (!end) {
        end = true;
        current++;
        gsap.to(list, {
          x: maxX,
          duration: 0.6
        });
        if (progressbar)
          gsap.to(progressbar, {
            scaleX: 1,
            duration: 0.6
          });
      }

      updateAttributes();
    }

    function updateAttributes() {
      carousel.setAttribute('data-start', start);
      carousel.setAttribute('data-end', end);
    }

    function closestIndex(array, num) {
      var i = 0;
      var minDiff = 1000;
      var ans;

      for (i in array) {
        var m = Math.abs(num - array[i]);

        if (m < minDiff) {
          minDiff = m;
          ans = parseInt(i);
        }
      }

      return ans;
    }

    function debounce(func) {
      var _arguments = arguments,
        _this = this;

      var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
      var immediate = arguments.length > 2 ? arguments[2] : undefined;
      var timeout;
      return function () {
        var context = _this,
          args = _arguments;

        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  }

  function dragCarouselInit() {
    gsap.registerPlugin(Draggable);
    gsap.registerPlugin(InertiaPlugin);
    var dragCarousel = document.querySelectorAll('.js-block[data-block="drag-carousel"]');

    dragCarousel.forEach((x) => dragCarouselInitSingle(x));
  }

  function dragCarouselReinit() {
    dragCarouselInit();

    var quick_buttons = document.querySelectorAll(".open_quick_button");
    var quick_close_buttons = document.querySelectorAll(".quick-close");
    quick_buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        document.querySelectorAll('.quick-close').forEach(function(element) {
          element.parentElement.classList.add('display_none');
        });

        var valorData = button.dataset.id;
        quick_pop = document.querySelector("#q_" + valorData);

        var _style = window.getComputedStyle
          ? getComputedStyle(quick_pop, null)
          : quick_pop.currentStyle,
          itemHeight =
          quick_pop.offsetHeight;
          //quick_pop.style.bottom =  itemHeight + 'px';
          console.log(itemHeight);

        quick_pop.classList.remove("display_none");
      })
    });

    quick_close_buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var valorData = button.dataset.id;
        quick_pop = document.querySelector("#q_" + valorData);
        quick_pop.classList.add("display_none");
      })
    });

  }

  dragCarouselInit();

  window.rfd = window.rfd || {};
  window.rfd.dragCarouselInit = dragCarouselInit;
  window.rfd.dragCarouselReinit = dragCarouselReinit;

})();


('use strict');
/**
 * Manifesto
 *
 *
 */

(function manifesto() {
  function manifestoInit() {
    var manifestos = document.querySelectorAll('.js-block[data-block="manifesto"]');

    manifestos.forEach(function (manifestoMod) {
      // Elements
      var manifesto = manifestoMod,
        gallery = manifesto.querySelector('.manifesto__gallery'),
        list = manifesto.querySelector('.manifesto__list'),
        items = manifesto.querySelectorAll('.manifesto__item'),
        itemsL = items.length; // Vars

      var visible = false,
        animating = false,
        animFrame = null,
        position = {
          current: {
            x: window.innerWidth / 2,
            y: 400,
            top: 0
          },
          next: {
            x: 0,
            y: 0,
            top: 0
          }
        }; // Events

      var updateGalleryEvents = []; // Add Events

      for (var x = 0; x < itemsL; x++) {
        updateGalleryEvents.push(updateGallery.bind(void 0, x));
      } // Add Event Listeners

      list.addEventListener('mouseenter', showGallery);
      list.addEventListener('mouseleave', hideGallery);
      manifesto.addEventListener('mousemove', setGalleryPos);

      for (var _x = 0; _x < itemsL; _x++) {
        items[_x].addEventListener('mouseenter', updateGalleryEvents[_x]);
      }

      function showGallery() {
        if (visible) return;

        if (!animating) startAnimating();
        visible = true;
        gallery.classList.add('visible');
      }

      function hideGallery() {
        if (!visible) return;

        if (animating) stopAnimating();
        visible = false;
        gallery.classList.remove('visible');
      }

      function updateGallery(x, e) {
        gallery.setAttribute('data-current', x + 1);
      }

      function setGalleryPos(e) {
        var mPos = {
          x: e.clientX,
          y: e.clientY
        };
        position.next = mPos;
      }

      function startAnimating() {
        animating = true;
        animFrame = window.requestAnimationFrame(setPosition);
      }

      function stopAnimating() {
        animating = false;
        if (animFrame) window.cancelAnimationFrame(animFrame);
        animFrame = null;
      }

      function setPosition() {
        position.next.top = manifesto.getBoundingClientRect().top;
        position.current.x += (position.next.x - position.current.x) * 0.03;
        position.current.y += (position.next.y - position.current.y) * 0.03;
        position.current.top += (position.next.top - position.current.top) * 0.1;
        gallery.style.transform =
          'translateX(' +
          position.current.x +
          'px) translateY(' +
          (position.current.y - position.current.top) +
          'px)';
        animFrame = window.requestAnimationFrame(setPosition);
      }
    });
  }

  manifestoInit();
})();

('use strict');
/**
 * Layout sort
 *
 * @exports window.rfd.layoutSort()
 */

(function layoutSort() {
  function layoutSortInit() {
    var layoutSort = document.querySelectorAll('.js-block[data-block="layout-sort"]');

    layoutSort.forEach(function (layoutSortMod) {
      // Elements
      var layoutSort = layoutSortMod,
        selectElementWrap = layoutSort.querySelector('.layout-sort__select-element'),
        selectElement = selectElementWrap.querySelector('#layout-sort'),
        selectOptions = selectElement.querySelectorAll('option[value]'),
        selectOptionsL = selectOptions.length,
        dropdown = layoutSort.querySelector('.layout-sort__dropdown'),
        dropdownItems = dropdown.querySelectorAll('li'),
        dropdownItemsL = dropdownItems.length;

      var currentSortIndex = layoutSort.getAttribute('data-sort');

      // Add Event Listeners
      selectElementWrap.addEventListener('click', openDropdown);
      dropdown.addEventListener('mouseleave', closeDropdown);
      selectElement.addEventListener('change', applyNewSortingMethod);

      function openDropdown() {
        if (window.innerWidth < 1240) return;
        layoutSort.classList.add('open');
      }

      function closeDropdown() {
        layoutSort.classList.remove('open');
      }

      const handleSortClick = (e) => {
        var index = e.target.getAttribute('data-index'); // Already using this sort method

        if (currentSortIndex === index) {
          closeDropdown();
          return;
        }

        selectElement.value = selectOptions[index].value;
        currentSortIndex = index;
        console.log({ currentSortIndex, selectOptions, index, layoutSort });
      }

      for (let x = 0; x < dropdownItemsL; x++) {
        // dropdownItems[x].addEventListener('click', handleSortClick);
      }

      function update() {
        layoutSort.setAttribute('data-sort', currentSortIndex);
        applyNewSortingMethod();
      }

      function applyNewSortingMethod() {
        closeDropdown();
      }
    });
  }

  layoutSortInit();

  window.rfd = window.rfd || {};
  window.rfd.layoutSort = layoutSort;
})();

('use strict');
/**
 * Layout grid
 *
 * @exports window.rfd.layoutGrid()
 */

(function layoutGrid() {
  function layoutGridInit() {
    var layoutGrid = document.querySelectorAll('.js-block[data-block="layout-grid"]');
    layoutGrid.forEach(function (layoutGridMod) {
      // Elements
      var layoutGrid = layoutGridMod,
        trigger2Grid = layoutGrid.querySelector('.layout-sort__column-count-trigger--2'),
        trigger3Grid = layoutGrid.querySelector('.layout-sort__column-count-trigger--3'),
        trigger4Grid = layoutGrid.querySelector('.layout-sort__column-count-trigger--4'),
        triggerGalleryGrid = layoutGrid.querySelector(
          '.layout-sort__column-count-trigger--gallery'
        ),
        products = document.querySelector('.products__inner > .cols'); // Vars

      var currentGrid = products?.getAttribute('data-d-cols'),
        urlString = window.location.search,
        urlParams = new URLSearchParams(urlString),
        currentGridOverride = urlParams.get('cols') || document.body.getAttribute('data-d-cols');

      if (!currentGridOverride) {
        currentGridOverride = sessionStorage.currentGrid;

        if(currentGridOverride === 'gallery') {
          currentGridOverride = '2';
        }
      }

      if (!sessionStorage.currentGrid) {
        currentGrid = '4';
        sessionStorage.currentGrid = '4';
        update();
      }

      // If a layout was set in the grid apply that
      if (currentGridOverride && !currentGrid)
        document.body.setAttribute('data-d-cols', currentGridOverride);

      trigger2Grid.addEventListener('click', e => setToGrid(e, '2'));
      trigger3Grid?.addEventListener('click', e => setToGrid(e, '3'));
      trigger4Grid?.addEventListener('click', e => setToGrid(e, '4'));
      triggerGalleryGrid.addEventListener('click', setToGalleryGrid);


      function setToGrid(e, columns) {
        const targetElementType = e.currentTarget.tagName.toLowerCase();
        if (targetElementType === 'a') {
          sessionStorage.currentGrid = columns;
          return
        }

        e.preventDefault();
        currentGrid = columns;
        sessionStorage.currentGrid = columns;
        update();
      }

      function once(fn, context) {
        var result;

        return function () {
          if (fn) {
            result = fn.apply(context || this, arguments);
            fn = null;
          }

          return result;
        };
      }

      var runLazyPagOnce = (function () {
        var executed = false;
        return function () {
          if (!executed) {
            executed = true;
            if (window.rfd && window.rfd.loadNextPage) {
              window.rfd.loadNextPage();
            }
          }
        };
      })();

      function setToGalleryGrid(e) {
        const targetElementType = e.currentTarget.tagName.toLowerCase();
        if (targetElementType === 'a') {
          // sessionStorage.currentGrid = 'gallery';
          return
        }

        currentGrid = 'gallery';
        sessionStorage.currentGrid = 'gallery';

        runLazyPagOnce();
        update();
      }

      function update() {
        document.body.setAttribute('data-d-cols', currentGrid);
        document.querySelector('.select-size-open')?.classList.remove('select-size-open');
      }
    });
  }

  layoutGridInit();
  window.rfd = window.rfd || {};
  window.rfd.layoutGrid = layoutGrid;
})();

('use strict');
/**
 * Split Heading
 *
 *
 */

(function SplitHeading() {
  gsap.registerPlugin(SplitText);

  function SplitHeadingInit() {
    heading = document.querySelectorAll('.js-block[data-block="split-heading"]');

    heading.forEach(function (headingMod) {
      var heading = headingMod,
        splitType = heading.getAttribute('data-split'),
        fontFace = heading.getAttribute('data-fontface'),
        nested = heading.getAttribute('data-nested') === 'true';
      var splitHeading = null,
        splitHeadingNested = null; // Add Event Listener

      var font = new FontFaceObserver(fontFace, {
        weight: 400
      });

      window.addEventListener('resize', debounce(resetSplits, 1000));

      font.load().then(function () {
        applyHeadingSplit();
      }, null);

      function applyHeadingSplit() {
        splitHeading = new SplitText(heading, {
          type: splitType
        });

        if (nested) {
          splitHeadingNested = new SplitText(heading, {
            type: splitType
          });
        }

        setTimeout(function () {
          heading.classList.add('split');
        }, 50);
      }

      function resetSplits() {
        splitHeading?.split();
        if (splitHeadingNested) splitHeadingNested.split();
      }

      function debounce(func) {
        var _arguments = arguments,
          _this = this;

        var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var immediate = arguments.length > 2 ? arguments[2] : undefined;
        var timeout;
        return function () {
          var context = _this,
            args = _arguments;

          var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };

          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      }
    });
  }

  SplitHeadingInit();
})();

('use strict');
/**
 * Forms
 *
 *
 */

(function forms() {
  function formsInit() {
    var forms = document.querySelectorAll('.js-block[data-block="form"]');

    forms.forEach(function (formMod) {
      function handleInputEdit() {
        var form = this.block;
        var editBtns = form.querySelectorAll('.js-input-edit');

        for (var i = 0; i < editBtns.length; i++) {
          var editBtn = editBtns[i];
          editBtn.addEventListener('click', function (e) {
            var btn = e.currentTarget;
            var btnType = btn.getAttribute('data-type');
            var input = btn.previousElementSibling;
            var disabledState = input.disabled;
            e.preventDefault();
            input.disabled = !disabledState;
            btn.textContent = disabledState ? 'Save' : 'Edit';

            if (disabledState) {
              input.focus();
            }

            if (btnType === 'password') {
              input.type = disabledState ? 'text' : 'password';
            }
          });
        }
      }

      function handleAddressEdit() {
        var form = this.block;
        var editBtns = form.querySelectorAll('.js-address-edit');
        var deleteBtns = form.querySelectorAll('.js-address-delete');

        for (var i = 0; i < editBtns.length; i++) {
          var editBtn = editBtns[i];
          editBtn.addEventListener('click', function (e) {
            var btn = e.currentTarget;
            var addressEl = btn.parentNode.parentNode;
            var textarea = addressEl.querySelector('.js-address-input');
            var paragraph = addressEl.querySelector('.js-address-text');
            var disabledState = textarea.disabled;
            var addressValue = textarea.value.replace(/\n/g, '<br/>');
            textarea.disabled = !disabledState;
            btn.textContent = disabledState ? 'Save' : 'Edit';

            if (disabledState) {
              textarea.focus();
            } else {
              paragraph.innerHTML = addressValue;
            }
          });
        }

        for (var _i = 0; _i < deleteBtns.length; _i++) {
          var deleteBtn = deleteBtns[_i];
          deleteBtn.addEventListener('click', function (e) {
            alert('Are you sure you want to delete this address?');
          });
        }
      }

      handleInputEdit();
      handleAddressEdit();
    });
  }

  formsInit();
})();

/**
 * Module for Listing video
 *
 * @exports window.rfd.reinitListingVideo()
 */

// (function listingVideoFunction() {
//   function listingVideoInit() {
//     var listingVideoBlocks = document.querySelectorAll('.js-block[data-block="listing-video"]');

//     listingVideoBlocks.forEach(function (videoMod) {
//       var listingVideoBlock = videoMod,
//         video = listingVideoBlock.querySelector('video');

//       var open = false; // Add event listeners

//       if (typeof video != 'undefined' && video != null) {
//         listingVideoBlock.addEventListener('mouseenter', showVideo);
//         listingVideoBlock.addEventListener('mouseleave', hideVideo);
//       }

//       function showVideo() {
//         if (open) return;
//         open = true;
//         listingVideoBlock.setAttribute('data-video', open);
//         video.play(0);
//       }

//       function hideVideo() {
//         if (!open) return;
//         open = false;
//         listingVideoBlock.setAttribute('data-video', open);
//         video.pause();
//       }
//     });
//   }

//   listingVideoInit();

//   function reinitListingVideo() {
//     listingVideoInit();
//   }

//   window.rfd = window.rfd || {};
//   window.rfd.reinitListingVideo = reinitListingVideo;
// })();

$(function () {
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('form[action="/search"]').each(function () {
    // Grabbing text input.
    var form = $(this).closest('form');
    var input = $(this).find('input[name="q"]');
    var resultsList = form.find('.main-nav__result-list');
    var mobileList = form.find('.mobile-nav__result-list');
    var resultsStacked = form.find('.main-nav__list--search');
    var resetBtn = $(this).find('button[type="reset"]');
    var headers = $(this).find('p.tag');
    var top = $(this).find('.main-nav__col--search');
    var term = $(this).val();

    $(resetBtn).click(function () {
      resultsList.hide();
      resultsStacked.hide();
      $(headers).hide();
      $(top).hide();
      $('[js-predictive-search-results-list]')?.html('');
      $('[js-search-results-grid]')?.html('');
      $('[js-search-results-status]')?.html('');
      $('[js-search-no-results]')?.html('');
      $('[js-search-view-more-btn]')?.hide();
    });

    // Adding a list for showing search results.
    var offSet = input.position().top + input.innerHeight();
    $('<ul class="search-results"></ul>').appendTo($(this)).hide();

    $(headers).hide();
    $(top).hide();

    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function () {
      // What's the search term?
      var term = $(this).val();
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=product&q=' + term;
      // What's the search results list?
      var resultsList = form.find('.main-nav__result-list');
      var mobileList = form.find('.mobile-nav__result-list');
      var mobileCarousel = form.find('.mobile-nav__search-results .js-block');
      var resultsStacked = form.find('.main-nav__list--search');
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != $(this).attr('data-old-term')) {
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function (data) {
          // Reset results.
          resultsList.empty();
          mobileList.empty();
          resultsStacked.empty();
          // If we have no results.
          if (data.results_count == 0) {
            $(top).show();
            resultsList.html('<p class="xs upper">No results found for "' + term + '" </p>');
            mobileCarousel.html('<p class="xs upper">No results found for "' + term + '" </p>');
            resultsList.fadeIn(200);
            //resultsList.hide();
            //resultsStacked.hide();
          } else {
            if (window.rfd && window.rfd.dragCarouselReinit) {
              window.rfd.dragCarouselReinit();
            }
            // If we have results.
            $(headers).show();
            $(top).show();
            $.each(data.results, function (index, item) {
              var link = $('<a></a>').attr('href', item.url);
              var stack = $('<a></a>').attr('href', item.url);
              link.append(
                '<img class="lazyloaded loadbox" alt="' +
                item.title +
                '" width="120" height="178" alt="' +
                item.title +
                '" src="' +
                item.thumbnail +
                '" />'
              );
              link.append('<p class="xs upper">' + item.title + '<br />' + item.price + '</p>');
              stack.append(item.title);
              link.wrap('<li></li>');
              stack.wrap('<li></li>');
              resultsList.append(link.parent());
              mobileList.append(link.parent());
              resultsStacked.append(stack.parent());
            });
            // The Ajax request will return at the most 10 results.
            // If there are more than 10, let's link to the search results page.
            if (data.results_count > 8) {
              resultsList.append(
                '<div class="main-nav__search-count"><a href="' +
                searchURL +
                '" class="breadcrumb">See all results (' +
                data.results_count +
                ')</a></div>'
              );
            }
            //if (data.results_count > 4) {
            //  resultsStacked.append(
            //    '<div class="main-nav__search-count"><a href="' +
            //      searchURL +
            //      '" class="breadcrumb">See all results (' +
            //      data.results_count +
            //      ')</a></div>'
            //  );
            //}

            if (data.results_count > 4) {
              mobileCarousel.append(
                '<div class="main-nav__search-count"><a href="' +
                searchURL +
                '" class="breadcrumb">See all results (' +
                data.results_count +
                ')</a></div>'
              );
            }
            resultsList.fadeIn(550);
            mobileList.fadeIn(550);
            resultsStacked.fadeIn(550);
          }
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  $('body').bind('click', function () {
    $('.search-results').hide();
  });
});

('use strict');
/**
 * Video
 *
 *
 */

(function videoFunc() {
  function videoFuncInit() {
    var videos = document.querySelectorAll('.js-block[data-block="video"]');

    videos.forEach(function (videoMod) {
      var video = videoMod,
        vimeoID = video.getAttribute('data-id'),
        vimeoMobileID = video.getAttribute('data-mobile-id'),
        embed = video.querySelector('.js-video-embed'),
        play = video.querySelector('.js-video-play'),
        fullScreen = video.querySelector('.js-video-full-screen'),
        sound = video.querySelector('.js-video-sound'); // Vars

      if (vimeoID == 0) return;

      var vimeoInstance = null,
        videoPlaying = false,
        videoMuted = true,
        videoAspectRatio = 0; // Events

      play.addEventListener('click', toggleVideo);
      fullScreen.addEventListener('click', setfullScreen);
      sound.addEventListener('click', toggleSound);
      createEmbed();

      function createEmbed() {
        vimeoInstance = new Vimeo.Player(embed, {
          controls: false,
          id: window.innerWidth < 768 && vimeoMobileID ? vimeoMobileID : vimeoID,
          width: window.innerWidth,
          loop: true,
          background: true,
          muted: true
        });

        video.classList.add('muted');

        Promise.all([vimeoInstance.getVideoWidth(), vimeoInstance.getVideoHeight()]).then(function (
          dimensions
        ) {
          var width = dimensions[0];
          var height = dimensions[1];
          videoAspectRatio = width / height;

          vimeoInstance
            .play()
            .then(function (play) {
              videoPlaying = true;
              setTimeout(() => {
                video.classList.add('playing');
              }, 1000);
            })
            .catch(function (error) {
              switch (error.name) {
                case 'NotAllowedError':
                  console.log('cant autoplay');
                  break;
                default:
                  // Some other error occurred
                  break;
              }
            });

          maintainAspectRatio();
          window.addEventListener('resize', debounce(maintainAspectRatio, 500));
        });
      }

      function setfullScreen() {
        vimeoInstance.requestFullscreen();
      }

      function toggleSound() {
        videoMuted = !videoMuted;
        vimeoInstance.setMuted(videoMuted);

        if (videoMuted) {
          video.classList.add('muted');
        } else {
          video.classList.remove('muted');
        }
      }

      function toggleVideo() {
        if (videoPlaying) {
          stopVideo();
        } else {
          playVideo();
        }
      }

      function playVideo() {
        videoPlaying = true;
        video.classList.add('playing');
        vimeoInstance.play();
      }

      function stopVideo() {
        videoPlaying = false;
        video.classList.remove('playing');
        vimeoInstance.pause();
      }

      function maintainAspectRatio() {
        var parentWidth = embed.parentNode.offsetWidth,
          parentHeight = embed.parentNode.offsetHeight;

        if (parentWidth > parentHeight * videoAspectRatio) {
          embed.style.height = parentWidth / videoAspectRatio + 'px';
          embed.style.width = parentWidth + 'px';
          embed.style.marginLeft = '0';
          embed.style.marginTop = (parentHeight - parentWidth / videoAspectRatio) / 2 + 'px';
        } else {
          embed.style.height = parentHeight + 'px';
          embed.style.width = parentHeight * videoAspectRatio + 'px';
          embed.style.marginLeft = (parentWidth - parentHeight * videoAspectRatio) / 2 + 'px';
          embed.style.marginTop = '0';
        }
      }

      function debounce(func) {
        var _arguments = arguments,
          _this = this;

        var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var immediate = arguments.length > 2 ? arguments[2] : undefined;
        var timeout;
        return function () {
          var context = _this,
            args = _arguments;

          var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };

          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      }
    });
  }

  videoFuncInit();
})();

(function AccessibilityHandler() {
  function init() {
    // Elements
    var skipLinks = document.querySelectorAll('.js-access-skip'),
      skipLinksL = skipLinks.length; // Vars

    var accessMode = false; // Event Listeners

    document.addEventListener('keyup', checkKeyEvent);

    for (var x = 0; x < skipLinksL; x++) {
      skipLinks[x].addEventListener('keydown', skipToTarget);
    }

    function checkKeyEvent(e) {
      if (e.keyCode !== 9 && !accessMode) return; // Check if tab

      accessMode = true;
      document.body.classList.add('access');
    }

    function clickEvent() {
      if (accessMode) return;
      accessMode = false;
      document.body.classList.remove('access');
    }

    function skipToTarget(e) {
      if (e.keyCode !== 13 && e.keyCode !== 32) return; // Wasn't a confirmation key

      e.preventDefault();
      var selector = e.target.getAttribute('data-next'),
        target = document.querySelector(selector);
      target.focus();
    }
  }

  init();
})();

('use strict');

/**
 * Newsletter form module.
 *
 */
(function newsletterFunction() {
  function initNewsletter() {
    var newsletterform = document.querySelectorAll('.js-block[data-block="newsletter-form"]');
    newsletterform.forEach(function (formMod) {
      var newsletterform = formMod,
        emailInput = newsletterform.querySelector('#footer-newsletter-email'); // Vars

      var LIST_ID = 'QfRKEE'; // Add Event Listeners

      newsletterform.addEventListener('submit', submitForm);

      function submitForm(e) {
        e.preventDefault();
        var formData = {
          api_key: '250d2827bc1a3b4a60ee237328f854d2',
          profiles: [
            {
              email: emailInput.value
            }
          ]
        };
        $.ajax({
          type: 'POST',
          url: 'https://a.klaviyo.com/api/v2/list/' + LIST_ID + '/subscribe',
          data: formData,
          processData: true,
          contentType: 'application/json',
          success: function success(response) {
            console.log(response);
          },
          dataType: 'application/json'
        });
      }
    });
  }

  initNewsletter();
})();

(function modRegisterBirthday() {
  function init() {
    var $daySelect = $('#register-dob-day');
    var $monthSelect = $('#register-dob-month');
    var $yearSelect = $('#register-dob-year');
    var $bdayInput = $('#birthday-date');
    var $bdayTag = $('#birthday-date-tag');

    function updateBday() {
      var day = $daySelect.val();
      var month = $monthSelect.val();
      var year = $yearSelect.val();

      if (day !== 'day' && month !== 'month' && year !== 'year') {
        if (day.length === 1) {
          day = '0' + day.toString();
        }
        if (month.length === 1) {
          month = '0' + month.toString();
        }
        $bdayInput.val(day.toString() + '/' + month.toString() + '/' + year.toString());
        $bdayTag.val('DOB:' + day.toString() + '/' + month.toString() + '/' + year.toString());
      }
    }

    $('#register-dob-day, #register-dob-month, #register-dob-year').on(
      'change',
      function handleChange() {
        updateBday();
      }
    );
  }

  $(document).ready(init);
})();

('use strict');
/**
 * Video
 *
 *
 */

(function videoFunc() {
  function videoFuncInit() {
    var heroVideos = document.querySelectorAll('.js-block[data-block="hero-video"]');

    heroVideos.forEach(function (videoMod) {
      var heroVideo = videoMod,
        vimeoID = heroVideo.getAttribute('data-id'),
        vimeoMobileID = heroVideo.getAttribute('data-mobile-id'),
        videoNative = heroVideo.getAttribute('data-video-native'),
        embed = heroVideo.querySelector('.js-video-embed'),
        sound = heroVideo.querySelector('.js-video-sound');

      if (vimeoID == 0 && !videoNative) return;

      // Vars
      var vimeoInstance = null,
        nativeEl = null,
        videoPlaying = false,
        videoMuted = true,
        videoAspectRatio = 0; // Events

      if (vimeoID != 0) {
        createEmbed();
        sound.addEventListener('click', toggleSoundVimeo);
      } else {
        registerNative();
        sound.addEventListener('click', toggleSoundNative);
      }

      function createEmbed() {
        vimeoInstance = new Vimeo.Player(embed, {
          controls: false,
          id: window.innerWidth < 768 && vimeoMobileID ? vimeoMobileID : vimeoID,
          width: window.innerWidth,
          loop: true,
          background: true
        });
        vimeoInstance.on('play', function () {
          videoPlaying = true;
          heroVideo.setAttribute('data-playing', true);
        });
        Promise.all([vimeoInstance.getVideoWidth(), vimeoInstance.getVideoHeight()]).then(function (
          dimensions
        ) {
          var width = dimensions[0];
          var height = dimensions[1];
          videoAspectRatio = width / height;
          maintainAspectRatio();
          window.addEventListener('resize', debounce(maintainAspectRatio, 200));
        });
      }

      function registerNative() {
        heroVideo.querySelectorAll('.video_native').forEach((el) => {
          console.debug('videoFunc.registerNative forEach', { el });

          if (window.innerWidth < 768 && el.classList.contains('video_native_desktop')) {
            el.remove();
            return;
          } else if (window.innerWidth >= 768 && el.classList.contains('video_native_mobile')) {
            el.remove();
            return;
          }

          nativeEl = el;

          // Unfortunately there appears to be no reliable event that informs us when size data is loaded.
          // https://stackoverflow.com/questions/4129102/html5-video-dimensions
          const interval = setInterval(() => {
            console.debug('videoFunc.registerNative interval', { nativeEl });

            if (nativeEl.videoWidth) {
              // Resize with window
              videoAspectRatio = nativeEl.videoWidth / nativeEl.videoHeight;
              maintainAspectRatio();
              window.addEventListener('resize', debounce(maintainAspectRatio, 200));

              // Show
              videoPlaying = true;
              heroVideo.setAttribute('data-playing', true);

              clearInterval(interval);
            }
          }, 100);
        });
      }

      function toggleSoundVimeo() {
        videoMuted = !videoMuted;
        vimeoInstance.setMuted(videoMuted);

        if (videoMuted) {
          heroVideo.classList.add('muted');
        } else {
          heroVideo.classList.remove('muted');
        }
      }

      function toggleSoundNative() {
        nativeEl.muted = !nativeEl.muted;

        if (nativeEl.muted) {
          heroVideo.classList.add('muted');
        } else {
          heroVideo.classList.remove('muted');
        }
      }

      /* Unused vimeo funcs, need to update to include local video if decide to use
      function toggleVideo() {
        if (videoPlaying) {
          stopVideo();
        } else {
          playVideo();
        }
      }

      function playVideo() {
        videoPlaying = true;
        heroVideo.classList.add('playing');
        vimeoInstance.play();
      }

      function stopVideo() {
        videoPlaying = false;
        heroVideo.classList.remove('playing');
        vimeoInstance.pause();
      }
      */

      function maintainAspectRatio() {
        var parentWidth = window.innerWidth,
          parentHeight = window.innerHeight;

        var parentWidth = embed.parentNode.offsetWidth,
          parentHeight = embed.parentNode.offsetHeight;

        if (parentWidth > parentHeight * videoAspectRatio) {
          embed.style.height = parentWidth / videoAspectRatio + 'px';
          embed.style.width = parentWidth + 'px';
          embed.style.marginLeft = '0';
          embed.style.marginTop = (parentHeight - parentWidth / videoAspectRatio) / 2 + 'px';
        } else {
          embed.style.height = parentHeight + 'px';
          embed.style.width = parentHeight * videoAspectRatio + 'px';
          embed.style.marginLeft = (parentWidth - parentHeight * videoAspectRatio) / 2 + 'px';
          embed.style.marginTop = '0';
        }
      }

      function debounce(func) {
        var _arguments = arguments,
          _this = this;

        var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var immediate = arguments.length > 2 ? arguments[2] : undefined;
        var timeout;
        return function () {
          var context = _this,
            args = _arguments;

          var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };

          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      }
    });
  }

  videoFuncInit();
})();

('use strict');
/**
 * Video
 *
 *
 */

// Sets the height attr of the Home Hero section each resize to window.innerHeight if width is between 768 and 1024.
// Why? No idea. Seems to have some interactions with the video element's maintainAspectRatio function.
(function homeVideoFunc() {
  function homeVideoFuncInit() {
    var homeHeros = document.querySelectorAll('.js-block[data-block="home-hero"]');

    homeHeros.forEach(function (videoMod) {
      var homeHero = videoMod;

      // Vars
      var width = 0;
      maintainAspectRatio();
      window.addEventListener('resize', debounce(maintainAspectRatio, 200));

      function maintainAspectRatio() {
        var newWidth = window.innerWidth,
          newHeight = window.innerHeight;

        if (newWidth > 1024) {
          homeHero.style.removeProperty('height');
          return;
        }

        if (newWidth === width || window.innerWidth < 768) return;
        console.log('did resize x1b');
        width = newWidth;
        homeHero.style.height = newHeight + 'px';
      }

      function debounce(func) {
        var _arguments = arguments,
          _this = this;

        var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var immediate = arguments.length > 2 ? arguments[2] : undefined;
        var timeout;
        return function () {
          var context = _this,
            args = _arguments;

          var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };

          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      }
    });
  }

  homeVideoFuncInit();
})();

('use strict');

/**
 * Gallery module.
 *
 */
(function pdpgalleryFunction() {
  gsap.registerPlugin(ScrollToPlugin);

  function initGallery() {
    var galleries = document.querySelectorAll('.js-block[data-block="desktop-gallery"]');
    galleries.forEach(function (galleryMod) {
      'use strict'; // Elements

      var gallery = galleryMod,
        items = gallery.querySelectorAll('.pdp-gallery__gallery-item'),
        itemsL = items.length,
        thumbItems = gallery.querySelectorAll('.pdp-gallery__gallery-thumb a'); // Vars

      var current = 0; // Add Events

      var setCurrentEvents = [];

      for (var x = 0; x < itemsL; x++) {
        setCurrentEvents.push(setCurrent.bind(this, x));
      } // Add Event Listeners

      for (var x = 0; x < itemsL; x++) {
        thumbItems[x].addEventListener('click', setCurrentEvents[x]);
      }

      function setCurrent(x, e) {
        e.preventDefault();
        gallery.setAttribute('data-current', x);
      }
    });
  }

  initGallery();
})();

/**
 * Gallery module.
 *
 */

(function MobilePDPBtns() {
  function initMobilePDPBtns() {
    var btns = document.querySelectorAll('.js-block[data-block="mobile-pdp-btns"]');

    btns.forEach(function (btnsMod) {
      var wrap = btnsMod,
        wrapInner = wrap.querySelector('.pdp-main__size-and-cart__inner'),
        closeBtn = wrapInner.querySelector('.js-pdp-pricing-close-trigger'),
        addToCartBtn = wrapInner.querySelector('.pdp-main__add-btn'),
        sizeGuideBtn = wrapInner.querySelector('.js-size-guide-trigger'),
        mainCols = document.querySelector('.pdp-main-cols'),
        openBtn = document.querySelector('.js-pdp-select-size');
      shareBtn = mainCols.querySelector('.social-share-list button');

      var isActive = false;

      // Add Event Listeners
      if (openBtn) openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      wrap.addEventListener('click', close);
      wrapInner.addEventListener('click', preventClose);
      addToCartBtn.addEventListener('click', addtoCart);
      if (sizeGuideBtn) sizeGuideBtn.addEventListener('click', showSizeGuide);
      if (shareBtn) shareBtn.addEventListener('click', shareProduct);

      function open(e) {
        if (e && e.target.className !== 'btn klaviyo-bis-trigger') e.preventDefault();
        if (!isActive) updatePage(true);
      }

      function close(e) {
        if (e && e.target.className !== 'btn klaviyo-bis-trigger') e.preventDefault();
        if (isActive) updatePage(false);
      }

      function preventClose(e) {
        if (e && e.target.className !== 'btn klaviyo-bis-trigger') e.stopPropagation();
      }

      function showSizeGuide() {
        close();
      }

      function addtoCart(e) {
        if (!addToCartBtn.getAttribute('disabled')) close();
      }

      function updatePage(newActiveState) {
        isActive = newActiveState;

        if (isActive) document.body.classList.add('select-size-open');
        else document.body.classList.remove('select-size-open');
      }

      async function shareProduct(e) {
        if (navigator && navigator.share) {
          try {
            await navigator.share({
              title: document.title,
              url: window.location
            });
          } catch (err) {
            console.error("Share problem");
          }
        }
      }
    });
  }

  initMobilePDPBtns();
})();

('use strict');
/**
 * Full Slider
 *
 *
 */

(function homeSliderFunc() {
  function homeSliderFuncInit() {
    var homeSlider = document.querySelectorAll('.js-block[data-block="home-slider"]');

    homeSlider.forEach(function (slideMod) {
      var homeSlide = slideMod;

      // Vars
      var width = 0;
      maintainAspectRatio();
      window.addEventListener('resize', debounce(maintainAspectRatio, 200));
      initSlide();

      function maintainAspectRatio() {
        var newWidth = window.innerWidth,
          newHeight = window.innerHeight;

        if (newWidth > 1024) {
          homeSlide.style.removeProperty('height');
          return;
        }

        if (newWidth === width) return;
        console.log('did resize');
        width = newWidth;
        homeSlide.style.height = newHeight + 'px';
      }

      function debounce(func) {
        var _arguments = arguments,
          _this = this;

        var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var immediate = arguments.length > 2 ? arguments[2] : undefined;
        var timeout;
        return function () {
          var context = _this,
            args = _arguments;

          var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };

          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      }

      function initSlide() {
        var heroSlider = tns({
          container: '.hero-slider',
          items: 1,
          mouseDrag: true,
          controls: false,
          navPosition: 'bottom',
          speed: 800,
          autoplay: true,
          autoplayTimeout: 5000,
          // autoplayHoverPause: true,
          autoplayButtonOutput: false
        });
      }
    });
  }

  homeSliderFuncInit();
})();

(function productGalleryZoom() {
  const zoomContainier = document.querySelector('.product-gallery-zoom');

  const productGalleryZoomInit = () => {
    $(".pdp-gallery__gallery-item img").on('click', function () {
      $(zoomContainier).find('figure').removeClass('visible').removeClass('zoom');
      $(zoomContainier).find(`figure[data-id=${$(this).data("id")}]`).addClass('visible');
      $('body').attr('data-modal-open', true).attr('data-gallery-zoom-open', true);
      $(zoomContainier).addClass('visible');
    });

    $(".pdp-gallery__gallery-item figure").on('mousemove', function (e) {
      let zoomer = e.currentTarget;
      if (!zoomer.style.backgroundImage) {
        console.log(zoomer.style, zoomer.dataset);
        zoomer.style.backgroundImage = `url('${zoomer.dataset.image}')`;
      }

      e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
      e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
      x = offsetX / zoomer.offsetWidth * 100
      y = offsetY / zoomer.offsetHeight * 100
      zoomer.style.backgroundPosition = `${x}% ${y}%`;
    });

    $(".product-gallery-zoom-container figure").on('click', function () {
      $(this).toggleClass('zoom');
    });

    $(".product-gallery-zoom .close").on('click', function (e) {
      $(zoomContainier).removeClass('visible');
      $('body').attr('data-modal-open', false).attr('data-gallery-zoom-open', false);
    });

    $(".product-gallery-zoom-container").on('click', function (e) {
      if (e.target == this) {
        $(zoomContainier).removeClass('visible');
        $('body').attr('data-modal-open', false).attr('data-gallery-zoom-open', false);
      }
    });
  }

  if (zoomContainier) {
    productGalleryZoomInit();
  }
})();

(function removeProductRecommendationsModule() {

  // fixes:
  // https://app.clickup.com/t/868eatpbn

  const recommendationsSections = document.querySelectorAll('.js-product-recommendations');
  console.log('removeProductRecommendationsModule', {
    recommendationsSections
  });

  /**
   * Returns true if the device is iOS 17 or under.
   */
  var isIOS17OrUnder = () => {
    var ua = window.navigator.userAgent;
    var match = ua.match(/OS (\d+)_/i);

    console.log('removeProductRecommendationsModule: isIOS17OrUnder', {
      ua,
      match
    });

    if (/iP(hone|od|ad)/.test(ua) && match && match[1]) {
      return parseInt(match[1], 10) <= 17;
    }
    return false;
  }

  /**
   * Removes product recommendations on iOS 17 and under, only on PDPs.
   */
  var removeProductRecommendations = () => {
    var isiOS17OrUnder = isIOS17OrUnder();
    var isPDP = window.location.pathname.includes('product');

    console.log('removeProductRecommendationsModule: removeProductRecommendations', {
      isIOS17OrUnder: isiOS17OrUnder,
      isPDP
    });

    if (
      isiOS17OrUnder &&
      isPDP
    ) {
      recommendationsSections.forEach(function(el) {
        el.remove();
      });
    }
  }

  if (recommendationsSections.length > 0) {
    console.log('removeProductRecommendationsModule: recommendations', recommendationsSections);
    removeProductRecommendations();
  }

})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper'
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    );
  }

  productImageLinks();
});

function productImageLinks() {
  console.log('productImageLinks');
  if ($('.product-image-links').length && $('.product-image-links').attr('data-page') == 1) {
    console.log('get URLS');
    // $( "#urls" ).load( "/collections/hiddenredpoints?page=2 div#links" );
    let page = 2;
    let size = $('.product-image-links').attr('data-size');
    while (page <= size) {
      $.get('/collections/hidden-image-links?page=' + page, function (data) {
        // $(data).find('#urls').html();
        // $('#urls').append(data);
        $('#links').append($(data).find('#links').html());
      });
      page++;
    }
  }
}

function toggleQuickAddInput(that, productId) {
  const isPreorder = $(`#AddToCart-${productId}`).data('preorder');
  $(`#AddToCart-${productId}`)
    .attr("disabled", that.classList.contains('disabled'))
    .attr("data-quick-add-to-cart", that.dataset.variantId)
    .attr("data-lazy-selectors-option", that.dataset.variantId)
    .text(that.classList.contains('disabled') ? 'SELECT SIZE' : (isPreorder ? 'PREORDER' : 'ADD TO CART'));
}


function closeSelectSizeModal() {
  $('.select-size-open').removeClass('select-size-open');
  $('.collection-filters').show();
  $('#IconLauncherTool').removeClass('select-size-open');
}

document.addEventListener('DOMContentLoaded', function() {
  $('.upsell__subproduct__radio').on('change', function (e) {
    const AddToCartId = e.target.dataset.addToCartButton;
    const that = e.target

    $(`#${AddToCartId}`)
      .attr("disabled", that.classList.contains('disabled'))
      .attr("data-quick-add-to-cart", that.dataset.variantId)
      .attr("data-lazy-selectors-option", that.dataset.variantId);
  });
});
//revome this function after the form from klaviyo is removed (instaled: 2024-03-14)
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const inputElement = document.querySelector('div[data-testid="POPUP"] input');

    console.log('inputElement', inputElement)
    if (inputElement) {
      inputElement.addEventListener('focusout', function () {
        const alertSpan = document.querySelector('div[data-testid="POPUP"] span[role="alert"]');

        alertSpan.parentElement.parentElement.style = { position: 'relative', background: 'transparent' };
        alertSpan.parentElement.style = { border: 'none' };
      });
    }
  }, 5000);
});

theme.utils = {
  a11y: {
    /**
     * Gets all focusable elements from a given container
     * @memberof theme.utils.a11y
     * @param {HTMLElement} container
     * @returns {array} focusable elements
     */
    getFocusableElements(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    },

    /** @private */
    _trapFocusHandlers: {},

    /**
     * @memberof theme.utils.a11y
     * @param {HTMLElement} container
     * @param {HTMLElement} [elementToFocus = container] - 1st element to focus in
     */
    trapFocus(container, elementToFocus = container) {
      var elements = theme.utils.a11y.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];

      theme.utils.a11y.removeTrapFocus();

      theme.utils.a11y._trapFocusHandlers.focusin = (event) => {
        if (
          event.target !== container &&
          event.target !== last &&
          event.target !== first
        )
          return;

        document.addEventListener('keydown', theme.utils.a11y._trapFocusHandlers.keydown);
      };

      theme.utils.a11y._trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', theme.utils.a11y._trapFocusHandlers.keydown);
      };

      theme.utils.a11y._trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
          (event.target === container || event.target === first) &&
          event.shiftKey
        ) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener('focusout', theme.utils.a11y._trapFocusHandlers.focusout);
      document.addEventListener('focusin', theme.utils.a11y._trapFocusHandlers.focusin);

      elementToFocus.focus();
    },

    /**
     * @memberof theme.utils.a11y
     * @param {HTMLElement} [elementToFocus = null] - 1st element to focus in after untrapping
     */
    removeTrapFocus(elementToFocus = null) {
      document.removeEventListener('focusin', theme.utils.a11y._trapFocusHandlers.focusin);
      document.removeEventListener('focusout', theme.utils.a11y._trapFocusHandlers.focusout);
      document.removeEventListener('keydown', theme.utils.a11y._trapFocusHandlers.keydown);

      if (elementToFocus) elementToFocus.focus();
    }

  },

  /**
   * Prepares transition to animate between display: none and display: block
   * @memberof theme.utils
   * @param {HTMLElement} element
   */
  prepareTransition(element) {
    element.addEventListener('transitionend', () => {
      element.classList.remove('is-transitioning');
    })

    // check the various CSS properties to see if a duration has been set
    var cl = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
    let duration = 0;
    const computedStyles = getComputedStyle(element)
    cl.forEach((prop) => duration || (duration = parseFloat(computedStyles.getPropertyValue(prop))));

    // if I have a duration then add the class
    if (duration != 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth; // check offsetWidth to force the style rendering
    }
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || theme.config.money.format);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ',');
      decimal = theme.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },

  /**
   * Similiar to jQuery.serialize
   * @param {HTMLElement} form
   * @returns json object
   */
  serializeForm: form => {
    const obj = {};
    const formData = new FormData(form);

    for (const key of formData.keys()) {
      const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

      if (regex.test(key)) {
        obj.properties = obj.properties || {};
        obj.properties[regex.exec(key)[2]] = formData.get(key);
      } else {
        obj[key] = formData.get(key);
      }
    }

    return JSON.stringify(obj);
  },

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  },

  getSiblings(element, selector) {
    let siblings = [];
    let targets;

    if (selector) {
      targets = element.parentNode.querySelectorAll(':scope > ' + selector)
    } else {
      targets = element.parentNode.children;
    }


    for (let target of targets) {
      if (target !== element)
        siblings.push(target);
    }

    return siblings;
  },

  /**
   * Refreshes UI elements
   * @param {Array} selectors -
   * @param {HTMLDocument} newHTML
   * @param {HTMLElement} container
   */
  refreshElements(selectors, newHTML, container) {
    selectors.forEach(selector => {
      const newEls = newHTML.querySelectorAll(selector)
      const oldEls = container.querySelectorAll(selector)
      oldEls.forEach((oldEl, idx) => {
        if (newEls[idx]){
          if (oldEl.getAttribute('js-accordion-item') != null) {
            const oldHeaderStatus = oldEl.querySelector('[js-accordion-header]').getAttribute('aria-expanded')
            const oldContentStatus = oldEl.querySelector('[js-accordion-content]').getAttribute('aria-hidden')
            const newEl = newEls[idx]
            newEl.querySelector('[js-accordion-header]').setAttribute('aria-expanded', oldHeaderStatus);
            newEl.querySelector('[js-accordion-content]').setAttribute('aria-hidden', oldContentStatus);
            oldEl.innerHTML = newEl.innerHTML
          } else {
            oldEl.innerHTML = newEls[idx].innerHTML
          }
        } else {
          oldEl.remove();
        }
      })
    })
  },

  /* behaves like liquid handleize, for js matching purposes */
  handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
  }
}

document.addEventListener('DOMContentLoaded', function () {
  /* Handle automatic Klaviyo BIS trigger */
  if (window.location.hash === '#bis') {
    if(window && window.klaviyoBIS && window.klaviyoBIS._initialized) {
      const interval = setInterval(() => {
        if(window && window.klaviyoBIS && window.klaviyoBIS._initialized) {
          const bisTrigger = document.querySelector('.klaviyo-bis-trigger');
          if (bisTrigger) {
            clearInterval(interval);
            setTimeout(() => {
              bisTrigger.click();
            }, 200)
          }
        }
      }, 100);
    }
  }

  // Handle Drop A Hint desktop trigger click
  $('.js-dropahint-trigger').on('click', function () {
    const realDropAHintTrigger = document.querySelector('#dropahint-cta a');
    realDropAHintTrigger.click();
  })
})
